<template>
  <div :class="[pageClass, ' d-flex flex-column gap-6']" data-testid="sl-breakup">
    <!-- Breadcrumbs block -->
   
    <div :class="[contentClass, 'd-flex flex-column gap-6']">
      <!-- Drilldown Content (No Tabs) -->
      <div class="slbreakup-card" data-testid="slbreakup-card">
        <div class="sl-data-card d-flex flex-column gap-3" data-testid="slbreakup__drilldown-card">
          <div class="sl-toolbar-wrapper">
            <template v-if="isReportingUnitdataloading">
              <div class="sl-toolbar-shimmer">
                <div class="d-flex align-center justify-space-between">
                  <div class="d-flex align-center gap-3">
                    <v-skeleton-loader type="chip" width="120" height="32"></v-skeleton-loader>
                    <v-skeleton-loader type="chip" width="100" height="32"></v-skeleton-loader>
                    <v-skeleton-loader type="chip" width="140" height="32"></v-skeleton-loader>
                  </div>
                  <div class="d-flex align-center gap-2">
                    <v-skeleton-loader type="button" width="36" height="36"></v-skeleton-loader>
                    <v-skeleton-loader type="button" width="36" height="36"></v-skeleton-loader>
                    <v-skeleton-loader type="button" width="36" height="36"></v-skeleton-loader>
                  </div>
                </div>
              </div>
            </template>
            <template v-else>
              <div class="d-flex align-center justify-space-between mb-2">
                <v-spacer></v-spacer>
                <!-- Actions Menu Component -->
                <ActionsMenu
                  v-if="commentarydata && commentarydata.length > 0"
                  ref="actionsMenu"
                  :commentarycycledata="commentarycycledata"
                  :workflows="workflows"
                  :slEnabled="slEnabled"
                  :isregionalapprover="isregionalapprover"
                  :ispreparer="ispreparer"
                  :isapprover="isapprover"
                  :isviewonly="isviewonly"
                  :commentary_local_key_label="commentary_local_key_label"
                  :commentary_regional_key_label="commentary_regional_key_label"
                  :toggleview="toggleview"
                  :toggletableview="toggletableview"
                  :ispendinglocalruapproval="ispendinglocalruapproval"
                  :ispendingregionalruapproval="ispendingregionalruapproval"
                  :workflowsDisabledMessage="workflowsDisabledMessage"
                  :multiselectdata="multiselectdata"
                  :cyclestage="cyclestage"
                  :workflowtext="workflowtext"
                  :activitylogconfigcycle="activitylogconfigcycle"
                  :isRevenueBreakupMode="true"
                  :apiBasePath="'sl_analysis'"
                  :hasPreparerActionableItems="hasPreparerActionableItems"
                  :slCommentaryId="selectedGLCommentary._id || ''"
                  :reportingType="reportingType"
                  :ruLabel="$nova.labelsName('cycle_page', 'commenrary_ru_label', 'RU')"
                  @get-previous-cycle-list="getPreviousCycleList()"
                  @perform-bulk-task="handlePerformBulkTask($event, arguments[1])"
                  @preview-bulk-commentary="handlePreviewBulkCommentary()"
                  @download-excel="downloadExcel()"
                  @download-pdf="downloadPdf()"
                  @mark-conversation-read="commentarycycledata.conversation_read = true"
                  @open-bulk-commentary-dialog-local="openBulkCommentaryDialogLocal()"
                  @open-bulk-commentary-dialog-approver="openBulkCommentaryDialogApprover()"
                  @open-bulk-approve-dialog="openBulkApproveDialog()"
                  @open-user-list-dialog="handleOpenUserListDialog()"
                  @open-status-insights-dialog="$store.commit('sbInfo', 'Status Insights available on main analysis page')"
                  data-testid="sl-breakup__actions-menu"
                />
              </div>
              <GLActionToolbar
                :commentarydata="commentarydata"
                :toggleview="toggleview"
                :commentarycycledata="commentarycycledata"
                :workflows="workflows"
                :isSodEnabled="isSodEnabled"
                :slEnabled="slEnabled"
                :isRevenueBreakupMode="false"
                :ruRoleOptions="ruRoleOptions"
                :isregionalapprover="isregionalapprover"
                :ispreparer="ispreparer"
                :isapprover="isapprover"
                :ismanager="ismanager"
                :isviewonly="isviewonly"
                :selectedRuRole="selectedRuRole"
                :alluserassigned="alluserassigned"
                :hideRoleSelector="true"
                :commentary_local_key_label="commentary_local_key_label"
                :commentary_regional_key_label="commentary_regional_key_label"
                :selectedfilter="selectedfilter"
                :customfilterstoggle="customfilterstoggle"
                :toggletableview="toggletableview"
                :cycletypeItem="cycletypeItem"
                :cycletypeReadview="cycletypeReadview"
                :ispendinglocalruapproval="ispendinglocalruapproval"
                :ispendingregionalruapproval="ispendingregionalruapproval"
                :workflowsDisabledMessage="workflowsDisabledMessage"
                :multiselectdata="multiselectdata"
                :cyclestage="cyclestage"
                :workflowtext="workflowtext"
                :pagecount="pagecount"
                :page="page"
                :isCommentaryView="isCommentaryView"
                :showViewToggle="true"
                :hideExtraControls="false"
                :apiBasePath="'sl_analysis'"
                :slGroupedView="slGroupedView"
                :hasPreparerActionableItems="hasPreparerActionableItems"
                :actualLabel="actual_shortform_label"
                :proformaLabel="proforma_shortform_label"
                :forecastLabel="forcast_shortform_label"
                @open-workflows-dialog="workflowsdialog = true"
                @update:selected-ru-role="selectedRuRole = $event"
                @open-user-list-dialog="handleOpenUserListDialog"
                @update:selected-filter="handleFilterUpdate"
                @update:custom-filters-toggle="handleCustomFiltersToggle"
                @toggle-view="handleToggleView"
                @update:toggletableview="handleToggleTableView"
                @update:sl-grouped-view="handleSlGroupedViewChange"
                @update:cycletype-readview="cycletypeReadview = $event"
                @get-previous-cycle-list="getPreviousCycleList"
                @perform-bulk-task="handlePerformBulkTask"
                @preview-bulk-commentary="handlePreviewBulkCommentary"
                @download-excel="downloadExcel"
                @download-pdf="downloadPdf"
                @mark-conversation-read="commentarycycledata.conversation_read = true"
                @open-bulk-commentary-dialog-local="openBulkCommentaryDialogLocal"
                @open-bulk-commentary-dialog-approver="openBulkCommentaryDialogApprover"
                @open-bulk-approve-dialog="openBulkApproveDialog"
                @update:page="page = $event"
              />
            </template>
          </div>

          <v-divider></v-divider>

          <div class="sl-table-wrapper">
            <template v-if="isReportingUnitdataloading">
              <div class="sl-table-shimmer">
                <div class="sl-table-header-shimmer d-flex align-center pa-3 grey lighten-4">
                  <v-skeleton-loader type="text" width="40" height="20" class="mr-4"></v-skeleton-loader>
                  <v-skeleton-loader type="text" width="120" height="20" class="mr-4"></v-skeleton-loader>
                  <v-skeleton-loader type="text" width="180" height="20" class="mr-4 flex-grow-1"></v-skeleton-loader>
                  <v-skeleton-loader type="text" width="100" height="20" class="mr-4"></v-skeleton-loader>
                  <v-skeleton-loader type="text" width="100" height="20" class="mr-4"></v-skeleton-loader>
                  <v-skeleton-loader type="text" width="100" height="20" class="mr-4"></v-skeleton-loader>
                  <v-skeleton-loader type="text" width="80" height="20"></v-skeleton-loader>
                </div>
                <div
                  v-for="i in 8"
                  :key="'shimmer-row-' + i"
                  class="sl-table-row-shimmer d-flex align-center pa-3"
                  :class="{ 'grey lighten-5': i % 2 === 0 }"
                >
                  <v-skeleton-loader type="text" width="40" height="20" class="mr-4"></v-skeleton-loader>
                  <v-skeleton-loader type="text" width="120" height="20" class="mr-4"></v-skeleton-loader>
                  <v-skeleton-loader type="text" width="180" height="20" class="mr-4 flex-grow-1"></v-skeleton-loader>
                  <v-skeleton-loader type="text" width="100" height="20" class="mr-4"></v-skeleton-loader>
                  <v-skeleton-loader type="text" width="100" height="20" class="mr-4"></v-skeleton-loader>
                  <v-skeleton-loader type="text" width="100" height="20" class="mr-4"></v-skeleton-loader>
                  <v-skeleton-loader type="text" width="80" height="20"></v-skeleton-loader>
                </div>
              </div>
            </template>
            <template v-else>
              <RUDataTable
                :key="'sl-data-table-' + slGroupedView"
                :filteredcommentarydata="filteredcommentarydata"
                :pagedItems="pagedItems"
                :commentarycycledatalist="commentarycycledatalist"
                :commentarycycledata="commentarycycledata"
                :multiselectdata="multiselectdata"
                :toggletableview="toggletableview"
                :toggleview="toggleview"
                :cycletype="cycletype"
                :cycletypeReadview="cycletypeReadview"
                :cyclestage="cyclestage"
                :isAllExpanded="isAllExpanded"
                :isFilterSet="isFilterSet"
                :isReportingUnitClicked="isReportingUnitClicked"
                :ispreparer="ispreparer"
                :isapprover="isapprover"
                :isregionalapprover="isregionalapprover"
                :ismanager="ismanager"
                :isviewonly="isviewonly"
                :isSodEnabled="isSodEnabled"
                :ruRoleOptions="ruRoleOptions"
                :selectedRuRole="selectedRuRole"
                :alluserassigned="alluserassigned"
                :workflows="workflows"
                :ispendinglocalruapproval="ispendinglocalruapproval"
                :ispendingregionalruapproval="ispendingregionalruapproval"
                :workflowtext="workflowtext"
                :workflowsDisabledMessage="workflowsDisabledMessage"
                :commentary_local_key_label="commentary_local_key_label"
                :commentary_regional_key_label="commentary_regional_key_label"
                :local_controls_label="local_controls_label"
                :local_management_label="local_management_label"
                :regional_controls_label="regional_controls_label"
                :regional_management_label="regional_management_label"
                :proformaLabel="proforma_shortform_label"
                :forecastLabel="forcast_shortform_label"
                :activitylogconfiggl="activitylogconfiggl"
                :expandedIds="expandedIds"
                :isRevenueBreakup="true"
                :apiBasePath="'sl_analysis'"
                :slViewMode="slViewMode"
                :slExpandedGroups="slExpandedGroups"
                :slGroupedView="slGroupedView"
                :selectedClientCodes="selectedClientCodes"
                :selectedClientNames="selectedClientNames"
                :uniqueClientCodes="uniqueClientCodes"
                :uniqueClientNames="uniqueClientNames"
                :selectedfilter="selectedfilter"
                :actualLabel="actual_shortform_label"
                :reportingType="reportingType"
                @toggle-expand-all="handleToggleExpandAll"
                @toggle-expand="handleToggleExpand"
                @update:multiselectdata="multiselectdata = $event"
                @update:selected-client-codes="selectedClientCodes = $event"
                @update:selected-client-names="selectedClientNames = $event"
                @update:selected-filter="handleFilterUpdate"
                @get-net-sales-data="getNetSalesData"
                @get-revenue-data="getRevenueData"
                @open-submit-dialog="handleOpenSubmitDialog"
                @mark-conversation-read="handleMarkConversationRead"
                @open-custom-filters-dialog="customfiltersdialog = true"
                @open-status-help-dialog="statushelpdialog = true"
                @toggle-sl-group="handleToggleSLGroup"
                @open-revenue-commentary="handleOpenRevenueDrilldown"
              />
            </template>
          </div>
        </div>
      </div>

      </div>

      <RevenueCommentaryDrilldownDialog
        :visible="revenueDrilldownDialogVisible"
        :row-data="revenueDrilldownRow"
        :type="currentType"
        :ispreparer="ispreparer"
        :isapprover="isapprover"
        :isregionalapprover="isregionalapprover"
        :isviewonly="isviewonly"
        :commentary_local_key_label="commentary_local_key_label"
        :commentary_regional_key_label="commentary_regional_key_label"
        :workflows="workflows"
        :workflowtext="workflowtext"
        :cyclestage="cyclestage"
        @update:visible="revenueDrilldownDialogVisible = $event"
        @close="handleCloseRevenueDrilldown"
        @save="handleDrilldownSave"
        @submit="handleDrilldownSubmit"
      />

      <!-- Commentary Dialog -->
      <commentary-dialog
        v-if="commantorydialog"
        v-model="commantorydialog"
        :loading="commentaryloading"
        :bulksubmit="bulksubmit"
        :hideTrendLine="true"
        :bulktype="bulktype"
        :bulkcommentall.sync="bulkcommentall"
        :bulkcommentreplace.sync="bulkcommentreplace"
        :showVoluntaryReason="showVoluntaryReason"
        :selectedcommentary="selectedcommentary"
        :multiselectdata="multiselectdata"
        :tablecolors="tablecolors"
        :cycletype="cycletype"
        :cycletypeReadview="cycletypeReadview"
        :ispreparer="ispreparer"
        :isapprover="isapprover"
        :isregionalapprover="isregionalapprover"
        :userid="userid"
        :sodEnabled="isSodEnabled"
        :commentarytype="commentarytype"
        :workflowtext="workflowtext"
        :workflows="workflows"
        :cyclestage="cyclestage"
        :commentary_local_key_label="commentary_local_key_label"
        :commentary_regional_key_label="commentary_regional_key_label"
        :aggregatedLabelText="commentary_regional_key_label"
        :localCommentaryGenAiBtntab="localCommentaryGenAiBtntab"
        :isRegionalCommentaryAutomationEnabled="isRegionalCommentaryAutomationEnabled"
        :isLocalCommentaryCollapsed="isLocalCommentaryCollapsed"
        :isLocalCommentaryReasonCollapsed="isLocalCommentaryReasonCollapsed"
        :isGlMandatoryRequestFlag="isGlMandatoryRequestFlag"
        :replaceExistingCommentFlag="replaceExistingCommentFlag"
        :charttab.sync="dialogCharttab"
        :commentarySubmitDialogueViewMode="commentarySubmitDialogueViewMode"
        :toggleview="toggleview"
        :trendYear="trendContext.year"
        :trendPeriod="trendContext.period"
        :trendReportingUnit="trendContext.reportingunit"
        :trendlineGlContext="sanitizedTrendlineCommentary"
        :lastActionsOnGL="lastActionsOnGL"
        :attachmentfile.sync="attachmentfile"
        :attachmentfileloading="attachmentfileloading"
        :attachmentfilepercentage="attachmentfilepercentage"
        :downloadAttachmentUrlBase="'/v2/varianceanalysis/sl_analysis/downloadattachment/'"
        :isTyping="isTyping"
        :loadingtext1="loadingtext1"
        :loadingtext2="loadingtext2"
        :isThresholdExceedLocalCommentary="isThresholdExceedLocalCommentary"
        :isThresholdExceedJVSummarisation="isThresholdExceedJVSummarisation"
        :showSummaryTab="showSummaryTab"
        :summaryAiProforma.sync="summaryAiProforma"
        :summaryAiForecast.sync="summaryAiForecast"
        :aitext.sync="aitext"
        :requestcommentarylocalcontrol.sync="requestcommentarylocalcontrol"
        :requestcommentarylocalmanagement.sync="requestcommentarylocalmanagement"
        :requestcommentaryregionalcontrol.sync="requestcommentaryregionalcontrol"
        :requestcommentaryregionalmanagement.sync="requestcommentaryregionalmanagement"
        :requestcommentarylocalcontrolvsProforma.sync="requestcommentarylocalcontrolvsProforma"
        :requestcommentarylocalcontrolvsForecast.sync="requestcommentarylocalcontrolvsForecast"
        :requestcommentarylocalmanagementvsProforma.sync="requestcommentarylocalmanagementvsProforma"
        :requestcommentarylocalmanagementvsForecast.sync="requestcommentarylocalmanagementvsForecast"
        :actualLabel="actual_shortform_label"
        :proformaLabel="proforma_shortform_label"
        :forecastLabel="forcast_shortform_label"
        :rejectTargetList="rejectTargetList"
        @toggle-local-commentary-collapse="toggleLocalCommentaryCollapse"
        @toggle-local-commentary-reason-collapse="toggleLocalCommentaryReasonCollapse"
        @generate-ai="handleGenerateAI"
        @generate-ai-summary="handleGenerateAISummary"
        @attachment-change="uploadAttachmentFile"
        @approve-commentary="approveCommentary"
        @reject-commentary="rejectCommentary"
        @save-commentary="saveCommentary"
        @save-local-commentary="saveCommentary"
        @save-regional-commentary="saveRegionalCommentary"
        @commentary-display-ready="captureCommentaryBaselines"
        :saveLocalCommentaryLoading="saveLoading"
        :saveLocalCommentaryField="saveLocalCommentaryField"
        :saveRegionalCommentaryLoading="saveLoading"
        :saveRegionalCommentaryField="saveRegionalCommentaryField"
        :commentaryBaselines="commentaryBaselines"
        :commentaryBaselinesReady="commentaryBaselinesReady"
        @add-commentary="addCommentary"
      />

      <!-- Request Commentary Dialog -->
      <request-commentary-dialog
        v-if="requestcommentarydialog"
        v-model="requestcommentarydialog"
        :heading="bulksubmit ? 'Bulk Request Commentary' : 'Request Commentary'"
        :width="800"
        :loading="requestcommentaryloading"
        :bulksubmit="bulksubmit"
        :multiselectcount="multiselectdata.length"
        :selectedcommentary="selectedcommentary"
        :isapprover="isapprover"
        :isregionalapprover="isregionalapprover"
        :workflowtext="workflowtext"
        :workflows="workflows"
        :local-controls-label="local_controls_label"
        :local-management-label="local_management_label"
        :regional-controls-label="regional_controls_label"
        :regional-management-label="regional_management_label"
        :proforma-label="proforma_shortform_label"
        :forecast-label="forcast_shortform_label"
        :requestcommentarylocalcontrolvsProforma="requestcommentarylocalcontrolvsProforma"
        :requestcommentarylocalmanagementvsProforma="requestcommentarylocalmanagementvsProforma"
        :requestcommentarylocalcontrolvsForecast="requestcommentarylocalcontrolvsForecast"
        :requestcommentarylocalmanagementvsForecast="requestcommentarylocalmanagementvsForecast"
        :requestcommentaryregionalcontrolvsProforma="requestcommentaryregionalcontrolvsProforma"
        :requestcommentaryregionalmanagementvsProforma="requestcommentaryregionalmanagementvsProforma"
        :requestcommentaryregionalcontrolvsForecast="requestcommentaryregionalcontrolvsForecast"
        :requestcommentaryregionalmanagementvsForecast="requestcommentaryregionalmanagementvsForecast"
        @request="requestCommentary"
        @update:requestcommentarylocalcontrolvsProforma="val => (requestcommentarylocalcontrolvsProforma = val)"
        @update:requestcommentarylocalmanagementvsProforma="val => (requestcommentarylocalmanagementvsProforma = val)"
        @update:requestcommentarylocalcontrolvsForecast="val => (requestcommentarylocalcontrolvsForecast = val)"
        @update:requestcommentarylocalmanagementvsForecast="val => (requestcommentarylocalmanagementvsForecast = val)"
        @update:requestcommentaryregionalcontrolvsProforma="val => (requestcommentaryregionalcontrolvsProforma = val)"
        @update:requestcommentaryregionalmanagementvsProforma="val => (requestcommentaryregionalmanagementvsProforma = val)"
        @update:requestcommentaryregionalcontrolvsForecast="val => (requestcommentaryregionalcontrolvsForecast = val)"
        @update:requestcommentaryregionalmanagementvsForecast="val => (requestcommentaryregionalmanagementvsForecast = val)"
      />

      <!-- User List Dialog -->
      <user-list-dialog
        v-if="userlistdialog"
        v-model="userlistdialog"
        :commentary-ru-data="commentaryrudata"
        :userid="userid"
        :multi-role-users="multiRoleUsers"
        :local-preparer-label="$nova.labelsName('cycle_page', 'commentary_local_preparer_label', 'Local Preparer')"
        :local-approver-label="$nova.labelsName('cycle_page', 'commentary_local_approver_label', 'Local Approver')"
        :regional-approver-label="$nova.labelsName('cycle_page', 'commentary_regional_approver_label', 'Regional Approver')"
      />

      <!-- Status Help Dialog -->
      <status-help-dialog v-if="statushelpdialog" v-model="statushelpdialog" />

      <!-- Bulk Submit Dialog (Local) -->
      <lb-dialog v-if="bulksubmitdialog" v-model="bulksubmitdialog" heading="Bulk Upload Commentary"
        :width="(Object.keys(bulksubmitfiledata).length > 0) ? '1500' : '500'" :loading="bulksubmitloading">
        <template v-slot:body>
          <div class="mb-4">
            <v-btn color="primary" class="mb-3" @click="downloadBulkTemplate()"><span>Download Template</span></v-btn>
            
            <lb-file 
              v-model="bulksubmitfiledatafile" 
              :label="Object.keys(bulksubmitfiledata).length > 0 ? 'Re-Upload' : 'Browse Files'" 
              :drag="false" 
              hidedetails 
              @change="readBulkSubmit()"
              :displayname="true" 
              accept=".xlsx,.xls,.xlsm,.xlsb"
              :dropzone="true"
              dropzone-text="Drag and drop your Excel file here"
              dropzone-hint="Supported formats: .xlsx, .xls, .xlsm, .xlsb"
              :remove="true"
            />
          </div>
          <div v-if="Object.keys(bulksubmitfiledata).length > 0">
            <div v-if="bulksubmitfiledataerror" class="error--text font-weight-semibold">
              We found few errors. Please rectify the same to proceed with the upload
            </div>
            <lb-datatablenew 
              class="bulk-upload-commentary" 
              :headers="bulkUploadCommentaryHeaders" 
              :items="bulksubmitfiledataList"
              :perpage="10"
              :enableslot="['message', 'ignore', 'actual_amount', 'proforma_amount', 'variance_amount1', 'variance_percent1', 'forecast_amount', 'variance_amount2', 'variance_percent2']" 
              :loading="bulksubmitloading"
            >
              <template v-slot:ignore="{ item }">
                <td style="width:30px;">
                  <v-icon v-if="(item.error || !item.__found)" color="error">mdi-close-circle</v-icon>
                  <v-icon v-else-if="!item.ignore" color="success">mdi-check-circle</v-icon>
                </td>
              </template>
              <!-- Values are pre-formatted in readBulkSubmit, so display directly without re-formatting -->
              <template v-slot:actual_amount="{ item }">
                <span>{{ item.actual_amount }}</span>
              </template>
              <template v-slot:proforma_amount="{ item }">
                <span>{{ item.proforma_amount }}</span>
              </template>
              <template v-slot:variance_amount1="{ item }">
                <span>{{ item.variance_amount1 }}</span>
              </template>
              <template v-slot:variance_percent1="{ item }">
                <span>{{ item.variance_percent1 }}</span>
              </template>
              <template v-slot:forecast_amount="{ item }">
                <span>{{ item.forecast_amount }}</span>
              </template>
              <template v-slot:variance_amount2="{ item }">
                <span>{{ item.variance_amount2 }}</span>
              </template>
              <template v-slot:variance_percent2="{ item }">
                <span>{{ item.variance_percent2 }}</span>
              </template>
              <template v-slot:message="{item}">
                <td :class="`${(bulksubmitfiledataerror || item.ignore)?'error--text':''}`">
                  <span v-if="!item.__found">Client Code not found</span>
                  <span v-else>{{item.error || item.message}}</span>
                </td>
              </template>
            </lb-datatablenew>
          </div>
        </template>
        <template v-slot:actions>
          <div v-if="bulksubmitfiledataerror" class="error--text font-weight-semibold">
            We found few errors. Please rectify the same to proceed with the upload
          </div>
          <div v-else-if="Object.keys(bulksubmitfiledata).length > 0" class="">
            Note: Only the GL's which are in {{
              $nova.labelsName('cycle_page', 'commentary_filter_local_commentary_awaited','Local commentary awaited') }}
            will be updated with this bulk upload option.
          </div>
          <v-spacer></v-spacer>
          <v-btn v-if="Object.keys(bulksubmitfiledata).length > 0 && !bulksubmitfiledataerror"
            @click="bulkUploadCommentaryByGL(bulksubmitfiledataList.some(item => item.showThresholdFlags === true))" color="" class="ml-2 primary"
            :disabled='(ispreparer && !workflows.lcp && !workflows.lmp && !workflows.lcf && !workflows.lmf)'><span>Proceed to
            Upload</span></v-btn>
        </template>
      </lb-dialog>

      <!-- Custom Filters Dialog -->
      <custom-filters-dialog
        v-if="customfiltersdialog"
        v-model="customfiltersdialog"
        :searchcustom="searchcustom"
        :customfilter="customfilter"
        :commentarydata="commentarydata"
        @update:searchcustom="val => (searchcustom = val)"
        @update:customfilter="val => (customfilter = val)"
        @save="saveCustomFilter"
      />

      <!-- Previous Cycle List Dialog -->
      <previous-cycle-list-dialog
        v-if="previouscyclelistdialog"
        v-model="previouscyclelistdialog"
        :loading="previouscyclelistloading"
        :previouscyclelist="previouscyclelist"
        :commentary-label="commentary_local_key_label"
        @select="getPreviousCycleData"
      />

      <!-- Previous Cycle Data Dialog -->
      <previous-cycle-data-dialog
        v-if="previouscycledatadialog"
        v-model="previouscycledatadialog"
        :loading="previouscycledataloading"
        :previouscycledatatoupload="previouscycledatatoupload"
        :prevselected="prevcommentaryselect"
        :tablecolors="tablecolors"
        :cycletype="cycletype"
        :proforma-label="proforma_shortform_label"
        :forecast-label="forcast_shortform_label"
        :gl-code-label="'SL Code'"
        @update:selected-list="val => (prevcommentaryselect = val)"
        @upload="uploadPreviousCycleCommentary"
      />

      <!-- Bulk Approve Local Dialog -->
      <bulk-approve-local-dialog
        v-if="bulkapprovelocaldialog"
        v-model="bulkapprovelocaldialog"
        :loading="bulkapprovelocalloading"
        :width="Object.keys(bulkapprovelocalfiledata).length > 0 ? '' : '500'"
        :file-data-list="bulkApproveLocalItems"
        :has-error="bulkapprovelocalfiledataerror"
        :is-regional-commentary-automation-enabled="isRegionalCommentaryAutomationEnabled"
        :is-approver="isapprover"
        :file-value="bulkapprovelocalfiledatafile"
        @download-template="downloadBulkApproveTemplate"
        @file-change="readBulkApproveLocal"
        @update:file-value="val => (bulkapprovelocalfiledatafile = val)"
        @upload="bulkUploadApproveLocalCommentaryByGL"
      />

      <!-- Bulk Upload Commentary Approver Dialog -->
      <bulk-upload-commentary-approver-dialog
        v-if="approverBulkSubmitPop"
        v-model="approverBulkSubmitPop"
        :loading="approverBulkSubmitLoading"
        :width="Object.keys(approverBulkSubmitData).length > 0 ? '' : '500'"
        :file-value="approverBulkSubmitDataFile"
        :headers="bulkUploadCommentaryisApproverHeaders"
        :items="approverBulkSubmitFileDataListis"
        :has-error="bulksubmitfiledataerrorisApprover"
        :disable-submit="isBulkSubmitDisabled"
        :gl-code-label="'SL Code'"
        :local-commentary-awaited-label="$nova.labelsName('cycle_page', 'commentary_filter_local_commentary_awaited','Local commentary awaited')"
        @download-template="downloadExcelisApprover"
        @file-change="readBulkSubmitisApprover"
        @update:file-value="val => (approverBulkSubmitDataFile = val)"
        @submit="bulkUploadCommentaryByGLisApprover"
      />

      <!-- Activity Log Dialog -->
      <activity-log-dialog
        v-if="activitylogdialog"
        v-model="activitylogdialog"
        :loading="activitylogloading"
        :activitylogdata="activitylogdata"
        :reporting-type="reportingType || ''"
        :activitylogconfig="activitylogconfiggl"
      />

      <!-- Workflows Dialog -->
      <lb-dialog v-if="workflowsdialog" v-model="workflowsdialog" heading="Workflows status" width="600">
        <template v-slot:body>
          <WorkflowsStatus
            :allworkflowstext="allworkflowstext"
            :workflowtext="workflowtext"
            :allworkflowskeys="allworkflowskeys"
            :sodEnabled="isSodEnabled"
          />
        </template>
      </lb-dialog>

      <!-- PDF Download Dialog -->
      <pdf-download-dialog
        v-if="rucyclepdfdownloaddialog"
        v-model="rucyclepdfdownloaddialog"
        :loading="rucyclepdfdownloadloading"
        :items="rucyclepdfdownloadlist"
        @generate="pdfdownloadRUcycleGenerate"
        @download="downloadRUPdfFile"
        @refresh="getpdfFun"
      />

      <GlTabWarningDialog
        v-model="unsavedCommentaryDialog"
        :message="unsavedCommentaryMessage"
        :fields="unsavedCommentaryFieldLabels"
        content-class="sl-breakup__unsaved-warning-dialog"
        data-testid="sl-breakup__unsaved-commentary-warning"
        @confirm="confirmUnsavedCommentaryClose"
        @cancel="cancelUnsavedCommentaryClose"
      />
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import GLActionToolbar from '../components/GLActionToolbar.vue';
import RUDataTable from '../components/RUDataTable.vue';
import ActionsMenu from '../components/ActionsMenu.vue';
import RevenueCommentaryDrilldownDialog from '../components/RevenueCommentaryDrilldownDialog.vue';
import CommentaryDialog from '../modals/CommentaryDialog.vue';
import RequestCommentaryDialog from '../modals/RequestCommentaryDialog.vue';
import UserListDialog from '../modals/UserListDialog.vue';
import StatusHelpDialog from '../modals/StatusHelpDialog.vue';
import CustomFiltersDialog from '../modals/CustomFiltersDialog.vue';
import PreviousCycleListDialog from '../modals/PreviousCycleListDialog.vue';
import PreviousCycleDataDialog from '../modals/PreviousCycleDataDialog.vue';
import BulkApproveLocalDialog from '../modals/BulkApproveLocalDialog.vue';
import BulkUploadCommentaryApproverDialog from '../modals/BulkUploadCommentaryApproverDialog.vue';
import ActivityLogDialog from '../modals/ActivityLogDialog.vue';
import WorkflowsStatus from '../components/WorkflowDialog.vue';
import PdfDownloadDialog from '../modals/PdfDownloadDialog.vue';
import GlTabWarningDialog from '../components/GlTabWarningDialog.vue';
import { getAvailableRoles } from '../utils/helper';
import { ROLES, ROLE_LABEL_MAPPING, VIEW_ONLY, SL_ANALYSIS_API_BASE, SL_BULK_SUBMIT_COLUMNS, varianceAnalysisConstants } from '../utils/constants';
import { validateBulkApprove } from '../utils/bulkApproveValidation';
import helpers from '../utils/helpers';

export default {
  name: 'SLBreakup',
  components: {
    GLActionToolbar,
    RUDataTable,
    ActionsMenu,
    RevenueCommentaryDrilldownDialog,
    CommentaryDialog,
    RequestCommentaryDialog,
    UserListDialog,
    StatusHelpDialog,
    CustomFiltersDialog,
    PreviousCycleListDialog,
    PreviousCycleDataDialog,
    BulkApproveLocalDialog,
    BulkUploadCommentaryApproverDialog,
    ActivityLogDialog,
    WorkflowsStatus,
    PdfDownloadDialog,
    GlTabWarningDialog,
  },
  props: {
    type: {
      type: String,
      required: false,
      default: '',
      validator: (value) => value === '' || ['revenue', 'netsales'].includes(value)
    },
     actualLabel: { type: String, default: 'Actual' },
    proformaLabel: { type: String, default: 'Proforma' },
    forecastLabel: { type: String, default: 'Forecast' },
  },
      // 5. Currently selected commentary row within SLBreakup (sanitized for readability)
  data() {
    return {
      // Tab index for SLBreakup main tabs
      slTab: 0,
      // Accordion state for summary card
      isSummaryExpanded: true,
      // ===== Core Data (mirroring helpers.js loadData) =====
      loading: false,
      isReportingUnitdataloading: true, // Start with loading true so shimmer shows immediately
      isReportingUnitClicked: true,
      
      // Commentary data arrays
      commentarydata: [], // Grouped tree data built from clientGroupData
      slUngroupedData: [], // Raw data array from fdt.data for ungrouped view
      commentarydatajson: {},
      commentarydatajsonById: {},
      commentarydatajsonByGLCode: {},
      slDataList: {},
      slClientGroupData: [], // Grouped breakdown data from getSLData clientGroupData
      commentaryrudata: {},
      commentarycycledata: {},
      
      // Cycle and RU data
      year: '',
      period: '',
      reportingunit: '',
      // Reporting type: 'pl' for Profit & Loss, 'bs' for Balance Sheet
      reportingType: 'pl',
      validationErrorField: '',
      // ===== View State =====
      toggleview: 0,
      toggletableview: 0,
      isCommentaryView: false,
      revenueDrilldownDialogVisible: false,
      revenueDrilldownRow: null,
      cycletypeReadview: 'Proforma',
      cycletype: 'Actual',
      cyclestage: 0,
      
      // ===== Pagination =====
      page: 1,
      pageSize: 200,
      
      // ===== User Roles =====
      ispreparer: false,
      isapprover: false,
      isregionalapprover: false,
      ismanager: false,
      isviewonly: false,
      
      // ===== SOD =====
      isSodEnabled: true,
      ruRoleOptions: [],
      selectedRuRole: null,
      alluserassigned: true,
      
      // ===== SL Enabled Flag =====
      // When user navigates from Base.vue as approver/regional approver, SL operations are disabled
      slEnabled: true,
      
      // ===== Workflows =====
      workflows: {
        lcp: true, lmp: true, rcp: true, rmp: true,
        lcf: true, lmf: true, rcf: true, rmf: true,
        islocalenabled: true, isregionalenabled: true,
        islocalproformaenabled: true, islocalforecastenabled: true,
        isregionalproformaenabled: true, isregionalforecastenabled: true,
        isworkflowsenabled: true
      },
      workflowtext: [],
      workflowsDisabledMessage: 'workflow disabled',
      ispendinglocalruapproval: false,
      ispendingregionalruapproval: false,
      
      // ===== Labels =====
      commentary_local_key_label: 'Local',
      commentary_regional_key_label: 'Regional',
      local_controls_label: 'Local Controls',
      local_management_label: 'Local Management',
      regional_controls_label: 'Regional Controls',
      regional_management_label: 'Regional Management',
      
      // ===== Filters =====
      // Initialize with all filter values to show all data by default
      // Filter values: 0=Local Commentary Awaited, 1=Local Commentary Awaiting Approval, -1=Local Commentary Rejected,
      // 5=Regional Commentary Awaited, 6=Regional Commentary Awaiting Approval, -2=Regional Commentary Rejected,
      // 7=Approved Commentary, 4=Immaterial Variance, 3=Nil Values, 9=Not in Scope
      selectedfilter: [0, 1, -1, 5, 6, -2, 7, 4, 3, 9],
      customfilter: [],
      customfilterstoggle: false,
      customfiltersdialog: false,
      
      // ===== Client Code/Name Filters =====
      selectedClientCodes: [], // Selected client codes for multiselect filter
      selectedClientNames: [], // Selected client names for multiselect filter
      
      // ===== Expansion State =====
      expandedIds: new Set(),
      isAllExpanded: false,
      
      // ===== SL Grouped/Ungrouped View State =====
      slViewMode: 'grouped', // 'grouped' or 'ungrouped'
      slExpandedGroups: [], // Array of expanded group IDs for grouped view
      slGroupedView: 0, // 0 = Grouped, 1 = Ungrouped (separate from toggletableview)
      initialViewSet: false, // Flag to track if initial view has been set (prevents reset on reload)
      
      // ===== Multi-select =====
      multiselectdata: [],
      
      // ===== Dialogs =====
      commantorydialog: false,
      workflowsdialog: false,
      statushelpdialog: false,
      requestcommentarydialog: false,
      requestcommentaryloading: false,
      userlistdialog: false,
      previouscyclelistdialog: false,
      previouscyclelistloading: false,
      previouscyclelist: [],
      previouscycledatadialog: false,
      previouscycledataloading: false,
      previouscycledata: [],
      previouscyclemetadata: {},
      previouscycledatatoupload: [],
      prevcommentaryselect: [],
      activitylogdialog: false,
      activitylogloading: false,
      activitylogdata: [],
      searchcustom: '',
      bulksubmitdialog: false,
      bulksubmitloading: false,
      bulksubmitfiledata: {},
      bulksubmitfiledatafile: null,
      bulksubmitfiledataerror: false,
      bulksubmitfiledataList: [],
      approverBulkSubmitPop: false,
      approverBulkSubmitLoading: false,
      approverBulkSubmitData: {},
      approverBulkSubmitDataFile: null,
      bulksubmitfiledataerrorisApprover: false,
      approverBulkSubmitFileDataListis: [],
      bulkapprovelocaldialog: false,
      bulkapprovelocalloading: false,
      bulkapprovelocalfiledata: {},
      bulkapprovelocalfiledatafile: null,
      bulkapprovelocalfiledataerror: false,
      multiRoleUsers: new Set(),
      allworkflowstext: [],
      allworkflowskeys: ['Local control proforma', 'Local control forecast', 'Local management proforma', 'Local management forecast',
        'Regional control proforma', 'Regional control forecast', 'Regional management proforma', 'Regional management forecast',
        'Local control proforma bs', 'Local control forecast bs', 'Local management proforma bs', 'Local management forecast bs',
        'Regional control proforma bs', 'Regional control forecast bs', 'Regional management proforma bs', 'Regional management forecast bs'
      ],
      actual_shortform_label: 'Actual',
      proforma_shortform_label: 'Proforma',
      forcast_shortform_label: 'Forecast',
      bulksubmitcolumns: [],
      bulkUploadCommentaryHeaders: [
        { value: 'ignore', text: '', sortable: false, lock: true },
        { value: 'code', text: 'Client Code', sortable: true, lock: true },
        { value: 'name', text: 'Description', sortable: true, lock: true },
        { value: 'actual_amount', text: 'Actual Amount', sortable: true, lock: true },
        { value: 'proforma_amount', text: 'Proforma Amount', sortable: true, lock: true },
        { value: 'variance_amount1', text: 'Variance Amt (Act vs Pro)', sortable: true, lock: true },
        { value: 'variance_percent1', text: 'Variance % (Act vs Pro)', sortable: true, lock: true },
        { value: 'crosscontrolthresholdvsproforma', text: 'Cross Ctrl (Pro)', sortable: true, lock: true },
        { value: 'crossmanagementthresholdvsproforma', text: 'Cross Mgmt (Pro)', sortable: true, lock: true },
        { value: 'commentary1', text: 'Commentary (Act vs Pro)', sortable: false, lock: true },
        { value: 'forecast_amount', text: 'Forecast Amount', sortable: true, lock: true },
        { value: 'variance_amount2', text: 'Variance Amt (Act vs For)', sortable: true, lock: true },
        { value: 'variance_percent2', text: 'Variance % (Act vs For)', sortable: true, lock: true },
        { value: 'crosscontrolthresholdvsforecast', text: 'Cross Ctrl (For)', sortable: true, lock: true },
        { value: 'crossmanagementthresholdvsforecast', text: 'Cross Mgmt (For)', sortable: true, lock: true },
        { value: 'commentary2', text: 'Commentary (Act vs For)', sortable: false, lock: true },
        { value: 'message', text: 'Message', sortable: false, lock: true },
      ],
      bulkUploadCommentaryisApproverHeaders: [
        { value: 'ignore', text: '', sortable: false, lock: true },
        { value: 'code', text: 'Client Code', sortable: true, lock: true },
        { value: 'name', text: 'Description', sortable: true, lock: true },
        { value: 'actual_amount', text: 'Actual Amount', sortable: true, lock: true },
        { value: 'proforma_amount', text: 'Proforma Amount', sortable: true, lock: true },
        { value: 'variance_amount1', text: 'Variance Amt (Act vs Pro)', sortable: true, lock: true },
        { value: 'variance_percent1', text: 'Variance % (Act vs Pro)', sortable: true, lock: true },
        { value: 'crosslocalctrlvsproforma', text: 'Cross Local Ctrl (Pro)', sortable: true, lock: true },
        { value: 'crosslocalmngtvsproforma', text: 'Cross Local Mngt (Pro)', sortable: true, lock: true },
        { value: 'crossregionalctrlvsproforma', text: 'Cross Regional Ctrl (Pro)', sortable: true, lock: true },
        { value: 'crossregionalmngtvsproforma', text: 'Cross Regional Mngt (Pro)', sortable: true, lock: true },
        { value: 'regionalcommentary1', text: 'Regional Commentary 1', sortable: false, lock: true },
        { value: 'forecast_amount', text: 'Forecast Amount', sortable: true, lock: true },
        { value: 'variance_amount2', text: 'Variance Amt (Act vs For)', sortable: true, lock: true },
        { value: 'variance_percent2', text: 'Variance % (Act vs For)', sortable: true, lock: true },
        { value: 'crosslocalctrlvsforecast', text: 'Cross Local Ctrl (For)', sortable: true, lock: true },
        { value: 'crosslocalmngtvsforecast', text: 'Cross Local Mngt (For)', sortable: true, lock: true },
        { value: 'crossregionalctrlvsforecast', text: 'Cross Regional Ctrl (For)', sortable: true, lock: true },
        { value: 'crossregionalmngtvsforecast', text: 'Cross Regional Mngt (For)', sortable: true, lock: true },
        { value: 'regionalcommentary2', text: 'Regional Commentary 2', sortable: false, lock: true },
        { value: 'message', text: 'Message', sortable: false, lock: true },
      ],
      
      // ===== Commentary Dialog State =====
      commentaryloading: false,
      saveLoading: false,
      saveLocalCommentaryField: '',
      saveRegionalCommentaryField: '',
      commentaryBaselines: {},
      commentaryBaselinesReady: false,
      unsavedCommentaryDialog: false,
      allowCommentaryDialogClose: false,
      selectedcommentary: {},
      commentarytype: '',
      commentarySubmitDialogueViewMode: false,
      charttab: 0,
      dialogCharttab: 0, // Separate tab state for commentary dialog
      lastTrendlineFetchSignature: '',
      bulksubmit: false,
      bulktype: '',
      bulkcommentall: false,
      bulkcommentreplace: false,
      showVoluntaryReason: false, // Flag to show voluntary reason section for immaterial items
      isLocalCommentaryCollapsed: false,
      isLocalCommentaryReasonCollapsed: false,
      isGlMandatoryRequestFlag: false,
      replaceExistingCommentFlag: false,
      lastActionsOnGL: {
        localaction: { type: 'none', lastAction: '' },
        regionalaction: { type: 'none', lastAction: '' },
      },
      attachmentfile: null,
      attachmentfileloading: false,
      attachmentfilepercentage: 0,
      isRegionalCommentaryAutomationEnabled: false,
      
      // ===== AI State =====
      aiProforma: '',
      aiForecast: '',
      aiLoadingProforma: false,
      aiLoadingForecast: false,
      aiResponseText: '',
      isTyping: false,
      index: 0,
      speed: 0,
      shouldStop: false,
      typingFrame: null,
      loadingtext1: false,
      loadingtext2: false,
      isThresholdExceedLocalCommentary: false,
      isThresholdExceedJVSummarisation: false,
      showSummaryTab: false,
      localCommentaryGenAiBtntab: false,
      summaryAiProforma: '',
      summaryAiForecast: '',
      aitext: '',
      commentaryGenAiBtntabValue: false,
      commentaryStatusData: null,
      
      // ===== Request Commentary State =====
      requestcommentarylocalcontrol: false,
      requestcommentarylocalmanagement: false,
      requestcommentaryregionalcontrol: false,
      requestcommentaryregionalmanagement: false,
      requestcommentarylocalcontrolvsProforma: false,
      requestcommentarylocalcontrolvsForecast: false,
      requestcommentarylocalmanagementvsProforma: false,
      requestcommentarylocalmanagementvsForecast: false,
      requestcommentaryregionalcontrolvsProforma: false,
      requestcommentaryregionalmanagementvsProforma: false,
      requestcommentaryregionalcontrolvsForecast: false,
      requestcommentaryregionalmanagementvsForecast: false,
      
      // ===== Config =====
      tablecolors: {
        heading: { a: '#d9f2ff', b: '#ffe9cc' },
        body: { a: 'rgba(0,150,255,0.06)', b: 'rgba(255,140,0,0.06)' }
      },
      cycletypeItem: [
        { text: 'Proforma', value: 'Proforma' },
        { text: 'Forecast', value: 'Forecast' }
      ],
      activitylogconfigcycle: {},
      activitylogconfiggl: {
        a_localbulkadd: { icon: 'mdi-plus-circle', color: 'info' },
        a_localadd: { icon: 'mdi-plus-circle', color: 'info' },
        a_localfileadd: { icon: 'mdi-plus-circle', color: 'info' },
        a_localfileapprove: { icon: 'mdi-check-circle', color: 'info' },
        a_localapprove: { icon: 'mdi-check-circle', color: 'success' },
        a_localbulkapprove: { icon: 'mdi-check-circle', color: 'success' },
        a_localreject: { icon: 'mdi-close-circle', color: 'error' },
        a_localbulkreject: { icon: 'mdi-close-circle', color: 'error' },
        a_localrequest: { icon: 'mdi-comment-plus', color: 'grey' },
        a_regionaladd: { icon: 'mdi-plus-circle-outline', color: 'info' },
        a_regionalapprove: { icon: 'mdi-check-circle-outline', color: 'success' },
        a_regionalreject: { icon: 'mdi-close-circle-outline', color: 'error' },
        a_regionalrequest: { icon: 'mdi-comment-plus-outline', color: 'grey' },
        a_localproformasaved: { icon: 'mdi-content-save', color: 'info' },
        a_localforecastsaved: { icon: 'mdi-content-save', color: 'info' },
        a_regionalproformasaved: { icon: 'mdi-content-save', color: 'info' },
        a_regionalforecastsaved: { icon: 'mdi-content-save', color: 'info' },
        a_regionalreasonsaved: { icon: 'mdi-content-save', color: 'info' },
        a_localreasonsaved: { icon: 'mdi-content-save', color: 'info' },
        f_localbulkadd: { icon: 'mdi-plus-circle', color: 'info' },
        f_localadd: { icon: 'mdi-plus-circle', color: 'info' },
        f_localfileadd: { icon: 'mdi-plus-circle', color: 'info' },
        f_localfileapprove: { icon: 'mdi-check-circle', color: 'info' },
        f_localapprove: { icon: 'mdi-check-circle', color: 'success' },
        f_localbulkapprove: { icon: 'mdi-check-circle', color: 'success' },
        f_localreject: { icon: 'mdi-close-circle', color: 'error' },
        f_localbulkreject: { icon: 'mdi-close-circle', color: 'error' },
        f_localrequest: { icon: 'mdi-comment-plus', color: 'grey' },
        f_regionaladd: { icon: 'mdi-plus-circle-outline', color: 'info' },
        f_regionalapprove: { icon: 'mdi-check-circle-outline', color: 'success' },
        f_regionalreject: { icon: 'mdi-close-circle-outline', color: 'error' },
        f_regionalrequest: { icon: 'mdi-comment-plus-outline', color: 'grey' },
        f_localproformasaved: { icon: 'mdi-content-save', color: 'info' },
        f_localforecastsaved: { icon: 'mdi-content-save', color: 'info' },
        f_regionalproformasaved: { icon: 'mdi-content-save', color: 'info' },
        f_regionalforecastsaved: { icon: 'mdi-content-save', color: 'info' },
        f_regionalreasonsaved: { icon: 'mdi-content-save', color: 'info' },
        f_localreasonsaved: { icon: 'mdi-content-save', color: 'info' },
      },
      
      // ===== Route Params =====
      cycleId: null,
      reportingunitId: null,
      periodId: null,
      yearId: null,
      roleId: null,
      glcodeId: null,
      
      // ===== PDF Download State =====
      rucyclepdfdownloadloading: false,
      rucyclepdfdownloaddialog: false,
      rucyclepdfdownloadlist: [],
    };
  },
  
  async created() {
    // Check if required store data exists (in case of page reload)
    const storeData = this.SLData;
    if (!storeData || !storeData.selectedGLCommentary || Object.keys(storeData.selectedGLCommentary).length === 0) {
      console.warn('[SLBreakup] Required store data not found. Going back...');
      this.$router.go(-1);
      return;
    }

    this.selectedcommentary = this.cloneCommentaryItem(storeData.selectedGLCommentary || {});
    if (this.selectedcommentary && Object.keys(this.selectedcommentary).length) {
      this.ensureReadableIdentifiers(this.selectedcommentary);
    }
    if (storeData.selectedCommentaryCycle) {
      this.commentarycycledata = this.cloneCommentaryItem(storeData.selectedCommentaryCycle);
    }

    if (storeData.cycleType || storeData.cycletype) {
      this.cycletype = storeData.cycleType || storeData.cycletype || this.cycletype;
    }
    if (typeof storeData.cycleStage === 'number') {
      this.cyclestage = storeData.cycleStage;
    }
    if (storeData.trendContext) {
      const { year: trendYear, period: trendPeriod, reportingunit: trendRu } = storeData.trendContext;
      if (trendYear) {
        this.year = trendYear;
      }
      if (trendPeriod) {
        this.period = trendPeriod;
      }
      if (trendRu) {
        this.reportingunit = trendRu;
      }
    }
    this.applySummaryStateFromCommentary(storeData.selectedGLCommentary, true);
    
    // Initialize workflow labels
    const localLabel = this.$nova?.labelsName('cycle_page', 'commentary_local_key_label', 'Local') || 'Local';
    const regionalLabel = this.$nova?.labelsName('cycle_page', 'commentary_regional_key_label', 'Regional') || 'Regional';
    const proformaLabel = this.$nova?.labelsName('cycle_page', 'proforma_shortform_label', 'Proforma') || 'Proforma';
    const forecastLabel = this.$nova?.labelsName('cycle_page', 'forecast_shortform_label', 'Forecast') || 'Forecast';
    
    this.allworkflowstext = [
      `${localLabel} control ${proformaLabel}`,
      `${localLabel} control ${forecastLabel}`,
      `${localLabel} management ${proformaLabel}`,
      `${localLabel} management ${forecastLabel}`,
      `${regionalLabel} control ${proformaLabel}`,
      `${regionalLabel} control ${forecastLabel}`,
      `${regionalLabel} management ${proformaLabel}`,
      `${regionalLabel} management ${forecastLabel}`
    ];
    
    // Extract route params
    this.cycleId = this.$route.params.cycleId;
    
    // Initialize role flags from SLData (passed from RUDataTable via Vuex)
    // These are the roles the user had when they clicked the row in RUDataTable
    if (storeData.ispreparer !== undefined) {
      this.ispreparer = storeData.ispreparer;
    }
    if (storeData.isapprover !== undefined) {
      this.isapprover = storeData.isapprover;
    }
    if (storeData.isregionalapprover !== undefined) {
      this.isregionalapprover = storeData.isregionalapprover;
    }
    if (storeData.isSodEnabled !== undefined) {
      this.isSodEnabled = storeData.isSodEnabled;
    }
    
    // Initialize ruRoleOptions and selectedRuRole from SLData for role selector persistence
    if (storeData.ruRoleOptions && storeData.ruRoleOptions.length) {
      this.ruRoleOptions = storeData.ruRoleOptions;
    }
    if (storeData.selectedRuRole) {
      this.selectedRuRole = storeData.selectedRuRole;
    }
    
    // Initialize slEnabled based on ispreparer from SLData
    // When ispreparer is false (navigating as approver/regional approver), disable SL operations (view-only mode)
    if (storeData && storeData.ispreparer !== undefined) {
      this.slEnabled = storeData.ispreparer;
    }
      
    this.reportingunitId = storeData.reportingunit || this.$route.params.reportingunitId || this.$route.query.reportingunit;
    this.periodId = storeData.period || this.$route.params.periodId || this.$route.query.period;
    this.yearId = storeData.year || this.$route.params.yearId || this.$route.query.year;
    this.roleId = this.$route.params.roleId || this.$route.query.role;
    this.glcodeId = storeData.glcode || this.$route.params.glcodeId || this.$route.query.glcode;
    
    // Initialize reporting type from SLData (defaults to 'pl' for Profit & Loss)
    if (storeData.reportingType) {
      this.reportingType = storeData.reportingType;
    }

    // Fetch AI features
    await this.fetchAiFeatures();
    
    // Load SL data
    await this.loadSLData();
  },
  
  watch: {
    commantorydialog(val, oldVal) {
      // X/close with unsaved edits: keep Add Commentary open and show warning in front (GL-aligned).
      if (!val && oldVal && this.hasUnsavedCommentaryChanges && !this.allowCommentaryDialogClose) {
        this.commantorydialog = true;
        this.$nextTick(() => {
          this.unsavedCommentaryDialog = true;
        });
        return;
      }

      if (!val) {
        this.allowCommentaryDialogClose = false;
        this.unsavedCommentaryDialog = false;
        this.bulksubmit = false;
        this.bulktype = '';
        this.commentarytype = '';
        this.commentaryBaselinesReady = false;
        if (this.selectedcommentary && !this.selectedcommentary._id) {
           this.selectedcommentary = {};
        }
      }
    },
    bulksubmit(val) {
      if (val && this.normalizeTabIndex(this.slTab) !== 0) {
        this.slTab = 0;
      }
    },
    inlineShouldRenderSummaryTab(val) {
      if (!val && this.normalizeTabIndex(this.slTab) === 2) {
        this.slTab = 0;
        this.requestcommentarylocalcontrolvsProforma = false
        this.requestcommentarylocalcontrolvsForecast = false
        this.requestcommentarylocalmanagementvsProforma = false
        this.requestcommentarylocalmanagementvsForecast = false
        this.requestcommentarylocalcontrol = false;
        this.requestcommentarylocalmanagement = false;
        this.requestcommentaryregionalcontrol = false;
        this.requestcommentaryregionalmanagement = false;
      }
    },
    /**
     * Sync bulk voluntary checkboxes to vsProforma/vsForecast when in bulk submit mode.
     * This ensures consistency between the main checkbox and the individual period checkboxes.
     */
    requestcommentarylocalcontrol(val) {
      if (this.bulksubmit) {
        console.log('[SLBreakup] Syncing requestcommentarylocalcontrol to vsProforma/vsForecast:', val);
        this.requestcommentarylocalcontrolvsProforma = val;
        this.requestcommentarylocalcontrolvsForecast = val;
      }
    },
    requestcommentarylocalmanagement(val) {
      if (this.bulksubmit) {
        console.log('[SLBreakup] Syncing requestcommentarylocalmanagement to vsProforma/vsForecast:', val);
        this.requestcommentarylocalmanagementvsProforma = val;
        this.requestcommentarylocalmanagementvsForecast = val;
      }
    },
    requestcommentaryregionalcontrol(val) {
      if (this.bulksubmit) {
        console.log('[SLBreakup] Syncing requestcommentaryregionalcontrol to vsProforma/vsForecast:', val);
        this.requestcommentaryregionalcontrolvsProforma = val;
        this.requestcommentaryregionalcontrolvsForecast = val;
      }
    },
    requestcommentaryregionalmanagement(val) {
      if (this.bulksubmit) {
        console.log('[SLBreakup] Syncing requestcommentaryregionalmanagement to vsProforma/vsForecast:', val);
        this.requestcommentaryregionalmanagementvsProforma = val;
        this.requestcommentaryregionalmanagementvsForecast = val;
      }
    },
    '$route.params.cycleId': function(newId) {
      if (newId && newId !== this.cycleId) {
        this.cycleId = newId;
        this.initialViewSet = false; // Reset view flag for new cycle
        this.loadSLData(true);
      }
    },
    /**
     * Watch for GL code changes from parent (GLBreakdown).
     * Reset initialViewSet so the default grouped view is applied for the new GL.
     */
    'SLData.glcode': function(newGlcode) {
      if (newGlcode && newGlcode !== this.glcodeId) {
        console.log('[SLBreakup] GL code changed:', { newGlcode, oldGlcode: this.glcodeId });
        this.glcodeId = newGlcode;
        this.initialViewSet = false; // Reset view flag for new GL
        this.loadSLData(true);
      }
    },
    type: function() {
      this.loadSLData(true);
    },
    /**
     * Watch Vuex SLData for role changes from GLBreakdown Breadcrumbs.
     * When user changes role in GLBreakdown, it updates Vuex SLData via updateSlContextField.
     * This watcher syncs those changes to SLBreakup so the actions column reflects the new role.
     */
    'SLData.selectedRuRole': function(newVal, oldVal) {
      // Only sync if value actually changed and differs from local state
      if (newVal && newVal !== oldVal && newVal !== this.selectedRuRole) {
        console.log('[SLBreakup] Vuex SLData.selectedRuRole changed:', { newVal, oldVal, localSelectedRuRole: this.selectedRuRole });
        this.selectedRuRole = newVal;
        // Note: The existing selectedRuRole watcher will handle applyRoleFlags and reprocessItemActions
      }
    },
    /**
     * Watch Vuex SLData for role flag changes from GLBreakdown Breadcrumbs.
     * This handles cases where role flags are updated directly in Vuex.
     */
    'SLData.ispreparer': function(newVal) {
      if (newVal !== undefined && newVal !== this.ispreparer) {
        this.ispreparer = newVal;
        this.reprocessItemActions();
      }
    },
    'SLData.isapprover': function(newVal) {
      if (newVal !== undefined && newVal !== this.isapprover) {
        this.isapprover = newVal;
        this.reprocessItemActions();
      }
    },
    'SLData.isregionalapprover': function(newVal) {
      if (newVal !== undefined && newVal !== this.isregionalapprover) {
        this.isregionalapprover = newVal;
        this.reprocessItemActions();
      }
    },
    selectedRuRole(newVal) {
      if (newVal) {
        this.applyRoleFlags(newVal);
        
        // When SOD is disabled and user switches roles, update slEnabled based on selected role
        // If switching to preparer, enable SL operations; otherwise keep them disabled
        if (!this.isSodEnabled) {
          this.slEnabled = (newVal === ROLES.LOCAL_PREPARER);
        }
        
        // Reprocess item actions based on new role
        this.reprocessItemActions();
      }
    },
    // Reset page to 1 when filters change - use deep watch for arrays
    selectedfilter: {
      handler() {
        this.page = 1;
      },
      deep: true
    },
    // Reset page to 1 when custom filters toggle changes
    customfilterstoggle() {
      this.page = 1;
    },
    // Keep inline commentary tabs aligned with the selected SL tab
    slTab: {
      immediate: true,
      handler(newVal) {
        const normalized = this.normalizeTabIndex(newVal);
        if (normalized === null) {
          return;
        }

        if (this.slTab !== normalized) {
          this.slTab = normalized;
        }
        if (normalized >= 0 && normalized <= 2 && this.charttab !== normalized) {
          this.charttab = normalized;
        }
        if (normalized === 1) {
          this.$nextTick(() => this.ensureTrendlineDataset());
        }
      },
    },
    charttab(newVal) {
      const normalized = this.normalizeTabIndex(newVal);
      if (normalized === null) {
        return;
      }

      if (this.charttab !== normalized) {
        this.charttab = normalized;
      }
      if (normalized >= 0 && normalized <= 2 && this.slTab !== normalized) {
        this.slTab = normalized;
      }
      if (normalized === 1 && this.normalizeTabIndex(this.slTab) === 1) {
        this.ensureTrendlineDataset();
      }
    },
    dialogCharttab(newVal) {
      if (newVal === 1) {
        this.ensureDialogTrendlineDataset();
      }
    },
    selectedGLCommentary: {
      handler() {
        this.syncSelectedCommentary();
      },
      deep: false,
    },
    selectedStoreCommentary: {
      handler() {
        this.syncSelectedCommentary();
      },
      deep: false,
    },
    trendContext: {
      immediate: true,
      handler(newContext = {}) {
        this.year = this.normalizeIdentifier(newContext.year);
        this.period = this.normalizeIdentifier(newContext.period);
        this.reportingunit = this.normalizeIdentifier(newContext.reportingunit);
        // Only fetch trendline when tab is visible
        if (this.normalizeTabIndex(this.slTab) === 1) {
          this.ensureTrendlineDataset(true);
        }
      },
    },
    trendlineLogs(newLogs) {
      if (Array.isArray(newLogs) && newLogs.length > 0) {
        this.lastActionsOnGL = this.deriveLastActionsFromLogs(newLogs);
      } else {
        this.lastActionsOnGL = this.getEmptyLastActions();
      }
    },
    trendlineFetchParams: {
      deep: true,
      handler(next) {
        if (!next || !next.contextKey || !next.filter) {
          return;
        }

        const signature = JSON.stringify(next);
        if (signature === this.lastTrendlineFetchSignature) {
          return;
        }

        this.lastTrendlineFetchSignature = signature;
        if (this.normalizeTabIndex(this.slTab) === 1) {
          this.ensureTrendlineDataset();
        }
      },
    },
    slAiLoadingProformaFromStore(value) {
      this.aiLoadingProforma = Boolean(value);
    },
    slAiLoadingForecastFromStore(value) {
      this.aiLoadingForecast = Boolean(value);
    },
    slSummaryLoadingProformaFromStore(value) {
      this.loadingtext1 = Boolean(value);
    },
    slSummaryLoadingForecastFromStore(value) {
      this.loadingtext2 = Boolean(value);
    },
    slAiResponseTextFromStore(newText) {
      if (!newText || typeof newText !== 'string') {
        return;
      }

      const variant = this.slAiGeneratedVariant || '';
      const normalizedVariant = variant.toLowerCase();
      if (normalizedVariant === 'proforma') {
        this.aiProforma = '';
      } else if (normalizedVariant === 'forecast') {
        this.aiForecast = '';
      }

      if (this.typingFrame) {
        cancelAnimationFrame(this.typingFrame);
        this.typingFrame = null;
      }

      this.aiResponseText = newText;
      this.isTyping = true;
      this.index = 0;
      this.shouldStop = false;

      const typeToken = normalizedVariant === 'forecast' ? 'Two' : 'One';
      this.typeEffect(typeToken);
    },
    slSummaryResponseTextFromStore(newText) {
      if (!newText || typeof newText !== 'string') {
        return;
      }

      const variant = (this.slSummaryVariantFromStore || '').toLowerCase();
      if (variant === 'forecast') {
        this.summaryAiForecast = newText;
      } else {
        this.summaryAiProforma = newText;
      }
    },
  },
  
  computed: {
    // Derive type from route path if not provided via props
    currentType() {
      // If type prop is provided, use it
      if (this.type && this.type !== '') {
        return this.type;
      }
      // Otherwise derive from route path
      const path = this.$route.path || '';
      if (path.includes('revenuebreakup')) {
        return 'revenue';
      } else if (path.includes('netsalesbreakup')) {
        return 'netsales';
      }
      // Default to revenue if can't determine
      return 'revenue';
    },
    // Type-based computed properties
    isRevenue() {
      return this.currentType === 'revenue';
    },
    isNetSales() {
      return this.currentType === 'netsales';
    },
    
    // Generate CSS classes based on type
    pageClass() {
      return `${this.currentType}-breakup-page`;
    },
    contentClass() {
      return `${this.currentType}-breakup-content`;
    },
    summaryClass() {
      return `${this.currentType}-summary`;
    },
    summaryGridClass() {
      return `${this.currentType}-summary__grid`;
    },

    trendContext() {
      const extractId = (obj, key) => {
        if (!obj || typeof obj !== 'object') {
          return '';
        }
        const detailCandidate = this.normalizeIdentifier(obj[`${key}_detail`]);
        if (detailCandidate) {
          return detailCandidate;
        }
        return this.normalizeIdentifier(obj[key]);
      };

      const sources = [
        this.commentarycycledata,
        this.selectedCommentaryCycle,
        this.selectedGLCommentary,
        this.SLData,
        this.sanitizedTrendlineCommentary,
        this.selectedcommentary,
      ];

      const resolvedYear =
        sources.map((s) => extractId(s, 'year')).find(Boolean) ||
        this.normalizeIdentifier(this.SLData?.year) ||
        this.normalizeIdentifier(this.year) ||
        '';

      const resolvedPeriod =
        sources.map((s) => extractId(s, 'period')).find(Boolean) ||
        this.normalizeIdentifier(this.SLData?.period) ||
        this.normalizeIdentifier(this.periodId) ||
        this.normalizeIdentifier(this.period) ||
        '';

      const resolvedReportingUnit =
        sources.map((s) => extractId(s, 'reportingunit')).find(Boolean) ||
        this.normalizeIdentifier(this.SLData?.reportingunit) ||
        this.normalizeIdentifier(this.reportingunitId) ||
        this.normalizeIdentifier(this.reportingunit) ||
        '';

      return {
        year: resolvedYear,
        period: resolvedPeriod,
        reportingunit: resolvedReportingUnit,
      };
    },

    commentaryStatusChip() {
      if (this.bulksubmit) {
        return null;
      }

      const stage = this.selectedcommentary?.__stage;
      const theme = this.$vuetify.theme.currentTheme || {};
      const colorWithOpacity = (themeKey, fallback = '#9e9e9e') => {
        const baseColor = theme[themeKey] || fallback;
        return this.$nova?.hexToRgbA ? this.$nova.hexToRgbA(baseColor, 0.1) : baseColor;
      };

      const stageMap = {
        [-1]: {
          icon: 'mdi-close-circle',
          iconColor: 'error',
          textKey: 'commentary_filter_local_commentary_awaiting_approval',
          fallbackText: 'Local Commentary rejected',
          textClass: 'error--text',
          background: colorWithOpacity('error'),
        },
        0: {
          icon: 'mdi-timer-sand-full',
          iconColor: 'info',
          textKey: 'commentary_filter_local_commentary_awaited',
          fallbackText: 'Local commentary awaited',
          textClass: 'info--text',
          background: colorWithOpacity('info', '#2196f3'),
        },
        1: {
          icon: 'mdi-timer-sand-full',
          iconColor: 'warning',
          textKey: 'commentary_filter_local_commentary_awaiting_approval',
          fallbackText: 'Local commentary awaiting approval',
          textClass: 'warning--text',
          background: colorWithOpacity('warning', '#fb8c00'),
        },
        [-2]: {
          icon: 'mdi-close-circle-outline',
          iconColor: 'error',
          textKey: 'commentary_filter_regional_commentary_rejected',
          fallbackText: 'Regional commentary rejected',
          textClass: 'error--text',
          background: colorWithOpacity('error'),
        },
        5: {
          icon: 'mdi-timer-sand-empty',
          iconColor: 'info',
          textKey: 'commentary_filter_regional_commentary_awaited',
          fallbackText: 'Regional commentary awaited',
          textClass: 'info--text',
          background: colorWithOpacity('info', '#2196f3'),
        },
        6: {
          icon: 'mdi-timer-sand-empty',
          iconColor: 'warning',
          textKey: 'commentary_filter_regional_commentary_awaiting_approval',
          fallbackText: 'Regional Commentary awaiting approval',
          textClass: 'warning--text',
          background: colorWithOpacity('warning', '#fb8c00'),
        },
        7: {
          icon: 'mdi-check-circle',
          iconColor: 'success',
          text: 'Approved',
          textClass: 'success--text',
          background: colorWithOpacity('success', '#4caf50'),
        },
        3: {
          icon: 'mdi-bookmark-off',
          iconColor: 'grey',
          textKey: 'commentary_filter_nil_value_accounts_label',
          fallbackText: 'Nil value accounts',
          textClass: 'grey--text',
          background: colorWithOpacity('grey'),
        },
        4: {
          icon: 'mdi-cash-remove',
          iconColor: 'grey',
          textKey: 'commentary_filter_immaterial_variance_label',
          fallbackText: 'Immaterial variance',
          textClass: 'grey--text',
          background: colorWithOpacity('grey'),
        },
      };

      const config = stageMap[stage];
      if (!config) {
        return null;
      }

      const text = config.text || this.$nova?.labelsName?.(
        'cycle_page',
        config.textKey,
        config.fallbackText,
      ) || config.fallbackText;

      return {
        stage,
        icon: config.icon,
        iconColor: config.iconColor,
        text,
        textClass: config.textClass,
        background: config.background,
      };
    },

    commentarySaveState() {
      if (this.bulksubmit || this.selectedcommentary?.__myaction !== 'localadd') {
        return '';
      }

      const normalize = (value) => String(value ?? '').trim();
      const savedOne = this.isSubmittedCommentaryField('commentary1') ||
        normalize(this.selectedcommentary.savedcommentary1) === normalize(this.selectedcommentary.commentary1);
      const savedTwo = this.isSubmittedCommentaryField('commentary2') ||
        normalize(this.selectedcommentary.savedcommentary2) === normalize(this.selectedcommentary.commentary2);

      if (savedOne && savedTwo) {
        return 'saved';
      }

      return 'unsaved';
    },

    hasUnsavedLocalCommentary() {
      if (!this.ispreparer || this.bulksubmit) {
        return false;
      }

      const action = this.selectedcommentary?.__myaction;
      if (action !== 'localadd' && action !== 'localvoluntary') {
        return false;
      }

      const proformaDirty = (this.workflows.lcp || this.workflows.lmp) &&
        !this.isSubmittedCommentaryField('commentary1') &&
        this.isCommentaryTextDirty(
          this.selectedcommentary?.commentary1,
          this.commentaryBaselines.commentary1
        );
      const forecastDirty = (this.workflows.lcf || this.workflows.lmf) &&
        !this.isSubmittedCommentaryField('commentary2') &&
        this.isCommentaryTextDirty(
          this.selectedcommentary?.commentary2,
          this.commentaryBaselines.commentary2
        );

      return proformaDirty || forecastDirty;
    },

    hasUnsavedRegionalCommentary() {
      if (!this.isapprover || this.isregionalapprover || this.bulksubmit) {
        return false;
      }
      const action = this.selectedcommentary?.__myaction;
      if (action !== 'regionaladd' && action !== 'regionalvoluntary') {
        return false;
      }

      const proformaDirty = (this.workflows.rcp || this.workflows.rmp) &&
        this.isCommentaryTextDirty(
          this.selectedcommentary?.regionalcommentary1,
          this.commentaryBaselines.regionalcommentary1
        );
      const forecastDirty = (this.workflows.rcf || this.workflows.rmf) &&
        this.isCommentaryTextDirty(
          this.selectedcommentary?.regionalcommentary2,
          this.commentaryBaselines.regionalcommentary2
        );

      return proformaDirty || forecastDirty;
    },

    hasUnsavedCommentaryChanges() {
      return this.hasUnsavedLocalCommentary || this.hasUnsavedRegionalCommentary;
    },

    unsavedCommentaryMessage() {
      return 'Your commentary has not been saved. If you leave now, your changes will be lost. Changes detected in:';
    },

    unsavedCommentaryFieldLabels() {
      const labels = [];
      const localLabel = this.$nova.labelsName('cycle_page', 'commentary_local_key_label', 'Local');
      const regionalLabel = this.$nova.labelsName('cycle_page', 'commentary_regional_key_label', 'Regional');

      if (this.ispreparer && !this.bulksubmit) {
        if ((this.workflows.lcp || this.workflows.lmp) &&
          !this.isSubmittedCommentaryField('commentary1') &&
          this.isCommentaryTextDirty(
            this.selectedcommentary?.commentary1,
            this.commentaryBaselines.commentary1
          )) {
          labels.push(`${localLabel} Commentary (Vs ${this.proforma_shortform_label || this.proformaLabel})`);
        }
        if ((this.workflows.lcf || this.workflows.lmf) &&
          !this.isSubmittedCommentaryField('commentary2') &&
          this.isCommentaryTextDirty(
            this.selectedcommentary?.commentary2,
            this.commentaryBaselines.commentary2
          )) {
          labels.push(`${localLabel} Commentary (Vs ${this.forcast_shortform_label || this.forecastLabel})`);
        }
      }

      if (this.isapprover && !this.isregionalapprover && !this.bulksubmit) {
        if ((this.workflows.rcp || this.workflows.rmp) &&
          this.isCommentaryTextDirty(
            this.selectedcommentary?.regionalcommentary1,
            this.commentaryBaselines.regionalcommentary1
          )) {
          labels.push(`${regionalLabel} Commentary (Vs ${this.proforma_shortform_label || this.proformaLabel})`);
        }
        if ((this.workflows.rcf || this.workflows.rmf) &&
          this.isCommentaryTextDirty(
            this.selectedcommentary?.regionalcommentary2,
            this.commentaryBaselines.regionalcommentary2
          )) {
          labels.push(`${regionalLabel} Commentary (Vs ${this.forcast_shortform_label || this.forecastLabel})`);
        }
      }

      return labels;
    },

    sanitizedTrendlineCommentary() {
      const source = this.selectedcommentary && Object.keys(this.selectedcommentary).length > 0
        ? this.selectedcommentary
        : (this.selectedGLCommentary && Object.keys(this.selectedGLCommentary).length > 0
          ? this.selectedGLCommentary
          : null);
      
      if (!source) return {};
      
      const clone = this.cloneCommentaryItem(source);
      this.ensureReadableIdentifiers(clone);
      return clone;
    },

    // Shared bindings for inline commentary tabs
    commentaryTabsProps() {
      return {
        inline: true,
        forceSummaryTab: true,
        showInternalTabs: true,
        bulksubmit: this.bulksubmit,
        bulktype: this.bulktype,
        bulkcommentall: this.bulkcommentall,
        bulkcommentreplace: this.bulkcommentreplace,
        selectedcommentary: this.selectedcommentary,
        multiselectdata: this.multiselectdata,
        tablecolors: this.tablecolors,
        cycletype: this.cycletype,
        cycletypeReadview: this.cycletypeReadview,
        ispreparer: this.ispreparer,
        isapprover: this.isapprover,
        isregionalapprover: this.isregionalapprover,
        userid: this.userid,
        sodEnabled: this.isSodEnabled,
        workflowtext: this.workflowtext,
        workflows: this.workflows,
        cyclestage: this.cyclestage,
        commentary_local_key_label: this.commentary_local_key_label,
        commentary_regional_key_label: this.commentary_regional_key_label,
        aggregatedLabelText: this.commentary_regional_key_label,
        localCommentaryGenAiBtntab: this.commentaryGenAiBtntab,
        isRegionalCommentaryAutomationEnabled: this.isRegionalCommentaryAutomationEnabled,
        isLocalCommentaryCollapsed: this.isLocalCommentaryCollapsed,
        isLocalCommentaryReasonCollapsed: this.isLocalCommentaryReasonCollapsed,
        isGlMandatoryRequestFlag: this.isGlMandatoryRequestFlag,
        replaceExistingCommentFlag: this.replaceExistingCommentFlag,
        charttab: this.charttab,
        commentarySubmitDialogueViewMode: this.commentarySubmitDialogueViewMode,
        toggleview: this.toggleview,
        trendYear: this.trendContext.year,
        trendPeriod: this.trendContext.period,
        trendReportingUnit: this.trendContext.reportingunit,
        lastActionsOnGL: this.lastActionsOnGL,
        attachmentfile: this.attachmentfile,
        attachmentfileloading: this.attachmentfileloading,
        attachmentfilepercentage: this.attachmentfilepercentage,
        isTyping: this.isTyping,
        loadingtext1: this.loadingtext1,
        loadingtext2: this.loadingtext2,
        isThresholdExceedLocalCommentary: this.isThresholdExceedLocalCommentary,
        isThresholdExceedJVSummarisation: this.isThresholdExceedJVSummarisation,
        showSummaryTab: this.showSummaryTab,
        summaryAiProforma: this.summaryAiProforma,
        summaryAiForecast: this.summaryAiForecast,
        aitext: this.aitext,
        requestcommentarylocalcontrol: this.requestcommentarylocalcontrol,
        requestcommentarylocalmanagement: this.requestcommentarylocalmanagement,
        requestcommentaryregionalcontrol: this.requestcommentaryregionalcontrol,
        requestcommentaryregionalmanagement: this.requestcommentaryregionalmanagement,
        requestcommentarylocalcontrolvsProforma: this.requestcommentarylocalcontrolvsProforma,
        requestcommentarylocalcontrolvsForecast: this.requestcommentarylocalcontrolvsForecast,
        requestcommentarylocalmanagementvsProforma: this.requestcommentarylocalmanagementvsProforma,
        requestcommentarylocalmanagementvsForecast: this.requestcommentarylocalmanagementvsForecast,
        requestcommentaryregionalcontrolvsProforma: this.requestcommentaryregionalcontrolvsProforma,
        requestcommentaryregionalmanagementvsProforma: this.requestcommentaryregionalmanagementvsProforma,
        requestcommentaryregionalcontrolvsForecast: this.requestcommentaryregionalcontrolvsForecast,
        requestcommentaryregionalmanagementvsForecast: this.requestcommentaryregionalmanagementvsForecast,
        trendlineGlContext: this.sanitizedTrendlineCommentary,
      };
    },

    inlineContentClasses() {
      return {
        'commentary-tabs-content': true,
        'commentary-tabs-content--inline': true,
      };
    },

    inlineShowInternalTabs() {
      return Boolean(this.commentaryTabsProps.showInternalTabs !== false);
    },

    inlineShouldRenderSummaryTab() {
      const baseCondition =
        this.$store.state.aiEnabled &&
        this.showSummaryTab &&
        (this.selectedcommentary?.summarycommentary1 ||
          this.selectedcommentary?.summarycommentary2 ||
          (typeof this.summaryAiProforma === 'string' && this.summaryAiProforma.trim()) ||
          (typeof this.summaryAiForecast === 'string' && this.summaryAiForecast.trim()));

      return Boolean(this.commentaryTabsProps.forceSummaryTab || baseCondition);
    },

    commentaryMainTabProps() {
      const base = this.commentaryTabsProps;
      return {
        selectedcommentary: base.selectedcommentary,
      };
    },

    commentaryTrendlineTabProps() {
      const base = this.commentaryTabsProps;
      return {
        bulksubmit: base.bulksubmit,
        charttab: this.normalizeTabIndex(this.slTab) ?? 0,
        cycletype: base.cycletype,
        reportingType: this.reportingType || 'pl',
        actualLabel: this.actualLabel,
        proformaLabel: this.proformaLabel,
        forecastLabel: this.forecastLabel,
        trendYear: base.trendYear,
        trendPeriod: base.trendPeriod,
        trendReportingUnit: base.trendReportingUnit,
        selectedcommentary: base.selectedcommentary,
        toggleview: base.toggleview,
        glContext: base.trendlineGlContext,
      };
    }, 

    commentarySummaryTabProps() {
      const base = this.commentaryTabsProps;
      return {
        bulksubmit: base.bulksubmit,
        selectedcommentary: base.selectedcommentary,
        tablecolors: base.tablecolors,
        cycletype: base.cycletype,
        bulktype: base.bulktype,
        summaryAiProforma: base.summaryAiProforma,
        summaryAiForecast: base.summaryAiForecast,
        aitext: base.aitext,
        loadingtext1: base.loadingtext1,
        loadingtext2: base.loadingtext2,
        isTyping: base.isTyping,
        isThresholdExceedJVSummarisation: base.isThresholdExceedJVSummarisation,
        showSummaryTab: base.showSummaryTab,
        forceSummaryTab: base.forceSummaryTab,
        ispreparer: base.ispreparer,
      };
    },

    commentaryMainTabListeners() {
      // Use a generic update handler for all update events
      const createUpdateHandler = (propName) => (val) => { this[propName] = val; };
      
      return {
        'update:bulkcommentall': createUpdateHandler('bulkcommentall'),
        'update:bulkcommentreplace': createUpdateHandler('bulkcommentreplace'),
        'update:attachmentfile': createUpdateHandler('attachmentfile'),
        'update:requestcommentarylocalcontrol': createUpdateHandler('requestcommentarylocalcontrol'),
        'update:requestcommentarylocalmanagement': createUpdateHandler('requestcommentarylocalmanagement'),
        'update:requestcommentaryregionalcontrol': createUpdateHandler('requestcommentaryregionalcontrol'),
        'update:requestcommentaryregionalmanagement': createUpdateHandler('requestcommentaryregionalmanagement'),
        'update:requestcommentarylocalcontrolvsProforma': createUpdateHandler('requestcommentarylocalcontrolvsProforma'),
        'update:requestcommentarylocalcontrolvsForecast': createUpdateHandler('requestcommentarylocalcontrolvsForecast'),
        'update:requestcommentarylocalmanagementvsProforma': createUpdateHandler('requestcommentarylocalmanagementvsProforma'),
        'update:requestcommentarylocalmanagementvsForecast': createUpdateHandler('requestcommentarylocalmanagementvsForecast'),
        'update:requestcommentaryregionalcontrolvsProforma': createUpdateHandler('requestcommentaryregionalcontrolvsProforma'),
        'update:requestcommentaryregionalmanagementvsProforma': createUpdateHandler('requestcommentaryregionalmanagementvsProforma'),
        'update:requestcommentaryregionalcontrolvsForecast': createUpdateHandler('requestcommentaryregionalcontrolvsForecast'),
        'update:requestcommentaryregionalmanagementvsForecast': createUpdateHandler('requestcommentaryregionalmanagementvsForecast'),
        'toggle-local-commentary-collapse': this.toggleLocalCommentaryCollapse,
        'toggle-local-commentary-reason-collapse': this.toggleLocalCommentaryReasonCollapse,
        'generate-ai': this.handleGenerateAI,
        'attachment-change': this.handleAttachmentChange,
      };
    },

    commentarySummaryTabListeners() {
      const createUpdateHandler = (propName) => (val) => { this[propName] = val; };
      
      return {
        'update:summaryAiProforma': createUpdateHandler('summaryAiProforma'),
        'update:summaryAiForecast': createUpdateHandler('summaryAiForecast'),
        'update:aitext': createUpdateHandler('aitext'),
        'generate-ai-summary': this.handleGenerateAISummary,
      };
    },
    
    // User ID from store
    userid() {
      return this.$store.state.user?.id || this.$store.state.userid || '';
    },

    /**
     * Agg market and SOXID reporting units can have a LOCTOT total with no local client rows.
     * Those units still show that total as a LOCAL header.
     */
    isSpecialRu() {
      const ruType = this.commentaryrudata?.type || '';
      const { RU_TYPE } = varianceAnalysisConstants.CLIENT_SALES_BREAKDOWN;
      return ruType === RU_TYPE.AGG_MARKET || ruType === RU_TYPE.SOXID;
    },

    // Reject target options for regional approvers (localized)
    rejectTargetList() {
      return helpers.getRejectTargetList(this.workflows, this.$nova.labelsName);
    },
    
    // Filtered commentary data based on filters
    filteredcommentarydata() {
      // Determine which data source to use based on view mode
      // Ungrouped view (slGroupedView === 1): Use slUngroupedData (raw fdt.data)
      // Grouped view (slGroupedView === 0): Use commentarydata (built from clientGroupData)
      const isUngrouped = this.slGroupedView === 1;
      const dataSource = isUngrouped ? this.slUngroupedData : this.commentarydata;
      
      if (!dataSource?.length) return [];
      
      const { selectedfilter: currentFilters, customfilterstoggle: customFilterActive, 
              customfilter: customFilterList, expandedIds,
              selectedClientCodes, selectedClientNames } = this;
      
      // Check if client filters are active
      const hasClientCodeFilter = selectedClientCodes && selectedClientCodes.length > 0;
      const hasClientNameFilter = selectedClientNames && selectedClientNames.length > 0;
      
      return dataSource.reduce((filtered, el, i) => {
        // Set index and key
        el.__key = i;
        el.__index = i;
        
        // Ensure __stage is set
        el.__stage = el.__stage ?? this.getStageFromItem(el);
        
        // Ensure __myaction is set
        if (el.__myaction === undefined) {
          el.__myaction = this.getActionFromItem(el);
        }
        
        // Get the filter flag
        const [shouldIgnore] = this.getFilterFlag(el, currentFilters, customFilterActive, customFilterList);
        
        if (shouldIgnore) return filtered;
        
        // Apply client code filter (only for non-header rows)
        if (hasClientCodeFilter && el.__type !== 'header') {
          const clientCode = el.client_code || el.clientcode || el.__code || '';
          if (!selectedClientCodes.includes(clientCode)) return filtered;
        }
        
        // Apply client name filter (only for non-header rows)
        if (hasClientNameFilter && el.__type !== 'header') {
          const clientName = el.client_name || el.clientname || el.__name || '';
          if (!selectedClientNames.includes(clientName)) return filtered;
        }

        // In grouped view, skip child rows whose parent is collapsed
        const isChildRow = el.__type === 'child' || el.level > 0;
        if (!isUngrouped && isChildRow) {
          const parentCode = el.__parent || el.parentcode || el.parent_code;
          const normalizedParent = parentCode ? String(parentCode) : '';
          if (normalizedParent && normalizedParent !== 'primary' && normalizedParent !== 'NA' && !expandedIds.has(normalizedParent)) {
            return filtered;
          }
        }
        
        filtered.push(el);
        return filtered;
      }, []);
    },
    
    // Paged items for pagination
    pagedItems() {
      const start = (this.page - 1) * this.pageSize;
      return this.filteredcommentarydata.slice(start, start + this.pageSize);
    },
    
    // Total page count
    pagecount() {
      return Math.ceil(this.filteredcommentarydata.length / this.pageSize) || 1;
    },
    
    // Check if filters are actually filtering out items (not just showing all)
    // Returns true when items have been filtered out due to filter selection
    isFilterSet() {
      return this.customfilterstoggle || 
             this.selectedClientCodes.length > 0 ||
             this.selectedClientNames.length > 0 ||
             this.filteredcommentarydata.length < this.commentarydata.length;
    },
    
    /**
     * Get unique client codes from commentary data for filter dropdown
     * @returns {Array<{text: string, value: string}>} Sorted unique client codes
     */
    uniqueClientCodes() {
      if (!this.commentarydata?.length) return [];
      const codes = new Set();
      this.commentarydata.forEach(el => {
        if (el.__type !== 'header') {
          const code = el.client_code || el.clientcode || el.__code || '';
          if (code && code !== 'NA') {
            codes.add(code);
          }
        }
      });
      return Array.from(codes).sort().map(code => ({ text: code, value: code }));
    },
    
    /**
     * Get unique client names from commentary data for filter dropdown
     * @returns {Array<{text: string, value: string}>} Sorted unique client names
     */
    uniqueClientNames() {
      if (!this.commentarydata?.length) return [];
      const names = new Set();
      this.commentarydata.forEach(el => {
        if (el.__type !== 'header') {
          const name = el.client_name || el.clientname || el.__name || '';
          if (name) {
            names.add(name);
          }
        }
      });
      return Array.from(names).sort().map(name => ({ text: name, value: name }));
    },
    
    // GL Code text for breadcrumbs
    glCodeText() {
      const ruData = this.commentaryrudata?.name 
        ? this.commentaryrudata 
        : this.commentarycycledata?.reportingunit_detail;
      
      return ruData 
        ? `${ruData.code || ''} - ${ruData.name || ''}` 
        : 'Actual Cycle';
    },
    
    // Active commentary for summary
    activeCommentary() {
      if (this.selectedcommentary && Object.keys(this.selectedcommentary).length > 0) {
        return this.selectedcommentary;
      }

      if (this.selectedGLCommentary && Object.keys(this.selectedGLCommentary).length > 0) {
        return this.selectedGLCommentary;
      }

      const { contextKey } = this.trendlineFetchParams;
      if (contextKey) {
        const entry = this.trendlineDataByKey(contextKey);
        if (entry && typeof entry === 'object') {
          return entry;
        }
      }

      return {};
    },
    
    // Summary data computed
  summaryData() {
      const source = this.selectedGLCommentary;
      if (!source) {
        return null;
      }

      const glCode = source.glcode_detail?.code || source.glcode || source.gl_code || source.cl_code || source._id || '';
      const description = source.glcode_detail?.name || source.description || source.gl_description || source.glcode_detail?.description || '';
      const displayCode = glCode
        ? (description ? `${glCode} - ${description}` : glCode)
        : (description || '');

      const actualLabel = source.amount1heading || this.actualLabel;
      const proformaLabel = source.amount2heading || this.proformaLabel;
      const forecastLabel = source.amount3heading || this.forecastLabel;

      return {
        displayCode: displayCode || 'GL Details',
        description,
        cycleLabel: this.selectedCommentaryCycle?.cycle_name || this.selectedCommentaryCycle?.label || '',
        actualLabel,
        proformaLabel,
        forecastLabel,
        actualAmount: source.amount1,
        proformaAmount: source.amount2,
        forecastAmount: source.amount3,
        proformaVarianceAmount: source.varianceamount1,
        proformaVariancePercent: source.variancepercent1,
        forecastVarianceAmount: source.varianceamount2,
        forecastVariancePercent: source.variancepercent2,
        localCommentary: source.commentary1,
        forecastCommentary: source.commentary2,
      };
    },

    
    // Gen AI computed properties
    commentaryGenAiBtntab() {
      return this.commentaryGenAiBtntabValue;
    },
    isThresholdExceedCommentary() {
      const status = this.commentaryStatusData;
      if (!status) return false;
      return status.isExceed || false;
    },
    
    // Bulk approve local items
    bulkApproveLocalItems() {
      return this.bulkapprovelocalfiledata && Object.keys(this.bulkapprovelocalfiledata).length > 0
        ? Object.values(this.bulkapprovelocalfiledata)
        : [];
    },
    
    // Check if bulk submit is disabled
    isBulkSubmitDisabled() {
      return this.bulksubmitfiledataerrorisApprover || 
             !this.approverBulkSubmitData || 
             Object.keys(this.approverBulkSubmitData).length === 0;
    },
    
    /**
     * Check if preparer has any items available for bulk local commentary submission
     * Preparer can only add local commentary when stage is in [-1, 0, 1, 9]
     * If all items are in regional stages (5, 6, 7, etc.), hide bulk submit button
     */
    hasPreparerActionableItems() {
      if (!this.commentarydata?.length) return false;
      
      const preparerActionableStages = this.workflows.islocalenabled 
        ? [-1, 0, 1, 9, 3, 4, 8] 
        : [-1, 0, 1, 9];
      
      return this.commentarydata.some(item => preparerActionableStages.includes(item.__stage));
    },
    
    ...mapState('varianceanalysis', {
      SLData: state => state.SLData
    }),
    ...mapGetters('varianceanalysis', {
      trendlineLogsByKey: 'getTrendlineLogs',
      trendlineDataByKey: 'getTrendlineData',
      trendlineLoadingFlag: 'getTrendlineLoading',
      trendlineActiveContextKey: 'getTrendlineActiveKey',
      slAiResponseTextFromStore: 'getSlAiResponseText',
      slAiLoadingProformaFromStore: 'getSlAiLoadingProforma',
      slAiLoadingForecastFromStore: 'getSlAiLoadingForecast',
      slAiGeneratedVariant: 'getSlLastGeneratedVariant',
      slSummaryResponseTextFromStore: 'getSlSummaryResponseText',
      slSummaryLoadingProformaFromStore: 'getSlSummaryLoadingProforma',
      slSummaryLoadingForecastFromStore: 'getSlSummaryLoadingForecast',
      slSummaryVariantFromStore: 'getSlLastSummaryVariant',
      slCommentaryLastAction: 'getSlCommentaryLastAction',
    }),
    trendlineLogsKey() {
      const commentary = this.selectedcommentary || {};
      const commentaryId = commentary._id || commentary.id || '';
      if (!commentaryId) {
        return '';
      }
      const cycleType = this.normalizeCycleType(this.cycletype) || 'Actual';
      return `${commentaryId}__${cycleType}`;
    },
    trendlineLogs() {
      if (!this.trendlineLogsKey) {
        return [];
      }
      const logs = this.trendlineLogsByKey(this.trendlineLogsKey);
      return Array.isArray(logs) ? logs : [];
    },
    trendlineFetchParams() {
      const context = this.sanitizedTrendlineCommentary || {};
      const derivedContext = this.trendContext || {};

      const glcode = this.normalizeIdentifier([
        context.glcode_detail?._id,
        context.glcodeId,
        context.glcode,
        context.glcode_internal,
        context.gl_code,
        context.client_code,
        context.cl_code,
        context.clcode,
        context.glcode_detail?.code,
        context.glcode_detail?.glcode,
        context._id,
        this.glcodeId,
      ]);

      const year = this.normalizeIdentifier([
        derivedContext.year?._id,
        derivedContext.year?.id,
        derivedContext.year,
        context.year_detail?._id,
        context.year,
        this.commentarycycledata?.year_detail?._id,
        this.commentarycycledata?.year,
        // SLData.year is set from buildSlContextPayload in RUDataTable
        // yearName in this app contains the year _id (e.g., "2023")
        this.SLData?.year,
        this.SLData?.yearName,
        this.SLData?.year_detail?._id,
        this.SLData?.selectedGLCommentary?.year_detail?._id,
        this.SLData?.selectedGLCommentary?.year,
        this.SLData?.selectedCommentaryCycle?.year_detail?._id,
        this.SLData?.selectedCommentaryCycle?.year,
        this.yearId,
        this.year,
        this.yearName,
      ]);

      const period = this.normalizeIdentifier([
        derivedContext.period?._id,
        derivedContext.period?.id,
        derivedContext.period,
        context.period_detail?._id,
        context.period,
        this.periodId,
        this.period,
        this.SLData?.period,
      ]);

      const reportingunit = this.normalizeIdentifier([
        derivedContext.reportingunit?._id,
        derivedContext.reportingunit?.id,
        derivedContext.reportingunit,
        context.reportingunit_detail?._id,
        context.reportingunit,
        this.reportingunit,
        this.SLData?.reportingunit,
        this.reportingunitId,
      ]);
      const rawCycleType = this.normalizeIdentifier([this.cycletype, derivedContext.cycletype]) || 'Actual';
      const cycleType = this.normalizeCycleType(rawCycleType) || 'Actual';

      // Convert year to number if it's a numeric string (API expects number)
      // Year IDs in this app are numeric values like 2023, 2024, 2025
      const yearValue = year && !isNaN(Number(year)) ? Number(year) : year;

      if ([glcode, yearValue, period, reportingunit, cycleType].some((value) => this.isMissingValue(value))) {
        console.warn('[SLBreakup] trendlineFetchParams - missing required values');
        return { contextKey: '', filter: null };
      }

      // Include reportingType in context key to cache separately for PL vs BS
      const contextKey = `${glcode}__${yearValue}__${period}__${reportingunit}__${cycleType}__${this.reportingType || 'pl'}`;

      // Build filter with optional reporting_type for Balance Sheet
      const trendFilter = {
        cycletype: cycleType,
        glcode,
        year: yearValue,
        period,
        reportingunit,
      };
      if (this.reportingType) {
        trendFilter.reporting_type = this.reportingType;
      }

      return {
        contextKey,
        filter: trendFilter,
      };
    },
    hasTrendlineDataset() {
      const { contextKey } = this.trendlineFetchParams;
      if (!contextKey) {
        return false;
      }
      const existing = this.trendlineDataByKey(contextKey);
      return Array.isArray(existing) && existing.length > 0;
    },
    selectedGLCommentary() {
      return this.SLData.selectedGLCommentary || {};
    },
    selectedCommentaryCycle() {
      return this.SLData.selectedCommentaryCycle || {};
    },
    selectedStoreCommentary() {
      return this.SLData.selectedCommentary || {};
    },
    // GL Code info for breadcrumbs
    glCodeInfo() {
      const source = this.selectedGLCommentary;
      if (!source || !Object.keys(source).length) return '';
      
      const glCode = source.glcode_detail?.code || source.glcode || source.gl_code || '';
      const description = source.glcode_detail?.name || source.description || source.gl_description || '';
      
      return glCode && description ? `${glCode} - ${description}` : (glCode || description || '');
    },
    /**
     * Build conversation control options for the Breadcrumbs header so SL Breakup can surface the dialog-level conversation entry point.
     */
    breadcrumbsConversationOptions() {
      const source = this.selectedGLCommentary;
      if (!source || !source._id) {
        return null;
      }

      const cycleId = source.cycle || this.selectedCommentaryCycle?._id || this.commentarycycledata?._id;
      if (!cycleId) {
        return null;
      }

      const basePath = SL_ANALYSIS_API_BASE;
      const conversationEnabled = (this.workflowtext || '').length !== 8;

      return {
        enabled: conversationEnabled,
        tooltip: this.workflowsDisabledMessage || 'Workflows disabled for this GL.',
        closed: this.cyclestage === 1 || this.isviewonly,
        highlight: !source.conversation_read,
        notify: !source.conversation_read,
        getApi: `${basePath}/getconversation/${cycleId}/c/${source._id}`,
        sendApi: `${basePath}/addconversation/${cycleId}/c/${source._id}`,
        readApi: `${basePath}/markreadconversation/${cycleId}/c/${source._id}`,
      };
    },
    /**
     * Provide activity log configuration for the Breadcrumbs header to expose the GL level history surface.
     */
    breadcrumbsActivityLogOptions() {
      const source = this.selectedGLCommentary;
      if (!source || !source._id || !this.activitylogconfiggl) {
        return null;
      }

      const activityType = this.selectedCommentaryCycle?.type || this.commentarycycledata?.type;
      if (!activityType) {
        return null;
      }

      return {
        config: this.activitylogconfiggl,
        url: `${SL_ANALYSIS_API_BASE}/getlogs/${source._id}/f/${activityType}`,
      };
    },
    // Cycle data list for RUDataTable - maps cycle IDs to cycle data objects
    commentarycycledatalist() {
      if (!this.commentarycycledata || !this.commentarycycledata._id) {
        return {};
      }
      // Return an object with cycle ID as key and cycle data as value
      return {
        [this.commentarycycledata._id]: this.commentarycycledata
      };
    },
  },

  methods: {
    /**
     * Open the revenue drill-down dialog with the selected row details.
     * Modified to use CommentaryDialog instead of RevenueCommentaryDrilldownDialog.
     */
    handleOpenRevenueDrilldown(row) {
      if (!row) {
        return;
      }
      
      // Map row action to commentary dialog mode
      let mode = 'view';
      const action = row.__myaction;
      
      if (['localadd', 'localvoluntary', 'localfileadd'].includes(action)) {
        mode = 'addlocal';
      } else if (['regionaladd', 'regionalvoluntary'].includes(action)) {
        mode = 'addregional';
      } else if (['localapprove', 'localfileapprove'].includes(action)) {
        mode = 'approvelocal';
      } else if (action === 'regionalapprove') {
        mode = 'approveregional';
      } else if (action === 'localrequest') {
        mode = 'requestlocal';
      } else if (action === 'regionalrequest') {
        mode = 'requestregional';
      }

      this.bulksubmit = false;
      this.commentarytype = mode;
      this.selectedcommentary = this.prepareCommentaryForDialog(row);
      
      if (this.ensureReadableIdentifiers) {
        this.ensureReadableIdentifiers(this.selectedcommentary);
      }
      
      this.dialogCharttab = 0; // Reset to main tab
      this.commentarySubmitDialogueViewMode = (mode === 'view');

      if (mode === 'addregional' || mode === 'approveregional') {
        this.isLocalCommentaryCollapsed = true;
        this.isLocalCommentaryReasonCollapsed = true;
      } else {
        this.isLocalCommentaryCollapsed = false;
        this.isLocalCommentaryReasonCollapsed = false;
      }

      // Open appropriate dialog based on mode
      if (['requestlocal', 'requestregional'].includes(mode)) {
        // Reset request flags
        this.requestcommentarylocalcontrolvsProforma = false;
        this.requestcommentarylocalmanagementvsProforma = false;
        this.requestcommentaryregionalcontrolvsProforma = false;
        this.requestcommentaryregionalmanagementvsProforma = false;
        this.requestcommentarylocalcontrolvsForecast = false;
        this.requestcommentarylocalmanagementvsForecast = false;
        this.requestcommentaryregionalcontrolvsForecast = false;
        this.requestcommentaryregionalmanagementvsForecast = false;
        this.requestcommentarydialog = true;
      } else {
        this.selectedcommentary = this.prepareCommentaryForDialog(row);
        if (this.ensureReadableIdentifiers) {
          this.ensureReadableIdentifiers(this.selectedcommentary);
        }
        
        // Open dialog immediately with current row data
        this.commentaryBaselinesReady = false;
        this.commantorydialog = true;
        this.commentaryloading = false;
        this.$nextTick(() => {
          this.scheduleCommentaryBaselineCapture();
        });
      }
    },

    /**
     * Close the revenue drill-down dialog and clear its row context.
     */
    handleCloseRevenueDrilldown() {
      this.revenueDrilldownDialogVisible = false;
      this.revenueDrilldownRow = null;
    },

    /**
     * Handle save from the drill-down dialog.
     */
    handleDrilldownSave(rowData) {
      if (!rowData || !rowData._id) {
        console.warn('[SLBreakup]: handleDrilldownSave - No row data or ID');
        return;
      }
      // Update the local data with the saved commentary
      const index = this.commentarydata.findIndex(item => item._id === rowData._id);
      if (index !== -1) {
        this.$set(this.commentarydata, index, { ...this.commentarydata[index], ...rowData });
      }
      // Also update the drilldown row reference
      this.revenueDrilldownRow = { ...rowData };
    },

    /**
     * Handle submit from the drill-down dialog.
     */
    async handleDrilldownSubmit(rowData) {
      if (!rowData || !rowData._id) {
        console.warn('[SLBreakup]: handleDrilldownSubmit - No row data or ID');
        return;
      }
      // Delegate to existing add/approve commentary methods based on action
      const action = rowData.__myaction || '';
      if (['localadd', 'localvoluntary'].includes(action)) {
        this.selectedcommentary = rowData;
        await this.addCommentary();
      } else if (['localapprove'].includes(action)) {
        this.selectedcommentary = rowData;
        await this.approveCommentary();
      } else if (['regionaladd', 'regionalvoluntary', 'regionalapprove'].includes(action)) {
        this.selectedcommentary = rowData;
        await this.addCommentary();
      }
      // Reload data after submit
      await this.loadSLData();
    },

    ...mapActions('varianceanalysis', {
      fetchTrendlineDataAction: 'fetchTrendlineData',
      generateSlCommentaryAiAction: 'generateSlCommentaryAI',
      generateSlCommentarySummaryAction: 'generateSlCommentarySummary',
      approveSlCommentaryAction: 'approveSlCommentary',
      rejectSlCommentaryAction: 'rejectSlCommentary',
      saveSlCommentaryAction: 'saveSlCommentary',
      addSlCommentaryAction: 'addSlCommentary',
    }),
    // Toggle the summary card accordion so the section can collapse or expand on demand
    toggleSummaryAccordion() {
      this.isSummaryExpanded = !this.isSummaryExpanded;
    },

    isMissingValue(value) {
      return value === null || value === undefined || value === '';
    },

    normalizeTabIndex(value) {
      if (value === null || value === undefined || value === '') {
        return null;
      }

      if (typeof value === 'number') {
        return Number.isFinite(value) ? value : null;
      }

      const parsed = Number(value);
      return Number.isFinite(parsed) ? parsed : null;
    },

    normalizeCycleType(value) {
      if (value === null || value === undefined) {
        return '';
      }

      const text = String(value).trim();
      if (!text) {
        return '';
      }

      const lowered = text.toLowerCase();
      if (lowered === 'actual') {
        return 'Actual';
      }
      if (lowered === 'forecast') {
        return 'Forecast';
      }
      if (lowered === 'proforma') {
        return 'Proforma';
      }

      return text;
    },

    normalizeIdentifier(value) {
      if (value === null || value === undefined) {
        return '';
      }

      if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
        return String(value).trim();
      }

      if (Array.isArray(value)) {
        for (const entry of value) {
          const normalized = this.normalizeIdentifier(entry);
          if (normalized) {
            return normalized;
          }
        }
        return '';
      }

      if (typeof value === 'object') {
        const candidates = [
          value._id,
          value.id,
          value.code,
          value.value,
          value.number,
          value.glcode,
          value.gl_code,
          value.period,
          value.reportingunit,
        ];
        for (const candidate of candidates) {
          const normalized = this.normalizeIdentifier(candidate);
          if (normalized) {
            return normalized;
          }
        }
        return '';
      }

      return '';
    },

    normalizeLookupKey(value) {
      const normalized = this.normalizeIdentifier(value);
      return normalized ? normalized.toUpperCase() : '';
    },

    async ensureTrendlineDataset(force = false) {
      if (this.normalizeTabIndex(this.slTab) !== 1) {
        return;
      }

      const { filter, contextKey } = this.trendlineFetchParams;
      if (!filter || !contextKey) {
        console.warn('[SLBreakup]: Trendline fetch skipped due to incomplete context', { contextKey, filter });
        return;
      }

      const isLoadingForContext = this.trendlineLoadingFlag && this.trendlineActiveContextKey === contextKey;
      if (!force) {
        const existing = this.trendlineDataByKey(contextKey);
        if (Array.isArray(existing) && existing.length > 0) {
          return;
        }
        if (isLoadingForContext) {
          return;
        }
      }

      const axiosInstance = this.axios || this.$axios || this.$http;
      if (!axiosInstance) {
        console.warn('[SLBreakup]: Axios instance missing for trendline fetch');
        return;
      }

      try {
        await this.fetchTrendlineDataAction({
          axios: axiosInstance,
          filter,
          contextKey,
          successMessage: '',
        });
      } catch (error) {
        console.error('[SLBreakup]: fetchTrendlineDataAction failed', error);
      }
    },

    async ensureDialogTrendlineDataset(force = false) {
      const { filter, contextKey } = this.trendlineFetchParams;
      if (!filter || !contextKey) {
        return;
      }

      const existing = this.trendlineDataByKey(contextKey);
      const isLoadingForContext = this.trendlineLoadingFlag && this.trendlineActiveContextKey === contextKey;
      if (!force) {
        if (Array.isArray(existing) && existing.length > 0) {
          return;
        }
        if (isLoadingForContext) {
          return;
        }
      }

      const axiosInstance = this.axios || this.$axios || this.$http;
      if (!axiosInstance) {
        console.warn('[SLBreakup]: Axios instance missing for dialog trendline fetch');
        return;
      }

      try {
        await this.fetchTrendlineDataAction({
          axios: axiosInstance,
          filter,
          contextKey,
          successMessage: '',
        });
      } catch (error) {
        console.error('[SLBreakup]: ensureDialogTrendlineDataset failed', error);
      }
    },

    /**
     * Load SL Data - Similar to loadData in helpers.js
     * Calls /v2/varianceanalysis/sl_analysis/getSLData
     */
    async loadSLData(reload = false) {
      this.isReportingUnitdataloading = true;
      this.commentarydata = [];
      this.slUngroupedData = []; // Reset ungrouped data
      // Reset maps to avoid stale data
      this.commentarydatajson = {};
      this.commentarydatajsonById = {};
      this.commentarydatajsonByGLCode = {};
      
      this.multiselectdata = [];
      this.isReportingUnitClicked = true;
      this.toggleview = 0;
      this.selectedcommentary = {};
      
      // Cache key for storing fetched data - includes reportingType for Balance Sheet separation
      const cacheKey = `${this.type}_${this.cycleId}_${this.reportingunitId}_${this.periodId}_${this.reportingType || 'pl'}`;
      
      // Check if data is already cached
      if (!reload && this.slDataList[cacheKey]) {
        this.processLoadedData(this.slDataList[cacheKey]);
        this.isReportingUnitdataloading = false;
        return;
      }
      
      try {
        const slParams = {
          cycletype: this.cycletype,
          type: this.type,
          cycle: this.cycleId,
          reportingunit: this.reportingunitId,
          period: this.periodId,
          role: this.roleId,
          glcode: this.glcodeId,
        };
        if (this.reportingType) {
          slParams.reporting_type = this.reportingType;
        }
        const response = await helpers.apiGet.call(this, '/v2/varianceanalysis/sl_analysis/getSLData', slParams);
        
        if (response.data.status !== 'success') {
          throw new Error(response.data.message || 'Error fetching SL data');
        }
        
        const fdt = response.data.data[0] || {};
        this.slDataList[cacheKey] = fdt; // Cache the data
        this.processLoadedData(fdt);
        
      } catch (err) {
        // this.$store.commit('sbError', err.message || 'Unknown error!');
        console.error('[SLBreakup] Error loading SL data:', err);
        // Fallback to show GL commentary even if SL data fetch fails
        this.syncSelectedCommentary(true);
      } finally {
        this.isReportingUnitdataloading = false;
      }
    },
    
    /**
     * Process loaded data - Similar to the data processing in loadData helper
     */
    processLoadedData(fdt) {
      // Reset data maps
      this.commentarydatajson = {};
      this.commentarydatajsonById = {};
      this.commentarydatajsonByGLCode = {};

      const registerLookup = (target, key, entry) => {
        if (Array.isArray(key)) {
          key.forEach(candidate => registerLookup(target, candidate, entry));
          return;
        }
        const normalized = this.normalizeLookupKey(key);
        if (normalized) {
          target[normalized] = entry;
          const compact = normalized.replace(/[^A-Z0-9]/g, '');
          if (compact && compact !== normalized) {
            target[compact] = entry;
          }
        }
      };
      
      // Process reporting unit data
      this.commentaryrudata = fdt.reportingunit || {};
      this.isRegionalCommentaryAutomationEnabled = this.commentaryrudata?.auto_regional_commentary_submission_enabled || false;
      this.isSodEnabled = this.commentaryrudata?.sod_enabled !== undefined && this.commentaryrudata?.sod_enabled !== null 
        ? this.commentaryrudata.sod_enabled 
        : true;
      
      // Reset and set workflows
      this.workflowtext = [];
      this.workflows = {
        lcp: true, lmp: true, rcp: true, rmp: true,
        lcf: true, lmf: true, rcf: true, rmf: true,
        islocalenabled: true, isregionalenabled: true,
        islocalproformaenabled: true, islocalforecastenabled: true,
        isregionalproformaenabled: true, isregionalforecastenabled: true,
        isworkflowsenabled: true
      };
      
      // Check workflow settings from reporting unit using a map for cleaner code
      const workflowChecks = [
        { key: 'localcontrol_proforma', flag: 'lcp', text: 'Local control proforma' },
        { key: 'localmanagement_proforma', flag: 'lmp', text: 'Local management proforma' },
        { key: 'regionalcontrol_proforma', flag: 'rcp', text: 'Regional control proforma' },
        { key: 'regionalmanagement_proforma', flag: 'rmp', text: 'Regional management proforma' },
        { key: 'localcontrol_forecast', flag: 'lcf', text: 'Local control forecast' },
        { key: 'localmanagement_forecast', flag: 'lmf', text: 'Local management forecast' },
        { key: 'regionalcontrol_forecast', flag: 'rcf', text: 'Regional control forecast' },
        { key: 'regionalmanagement_forecast', flag: 'rmf', text: 'Regional management forecast' }
      ];
      
      workflowChecks.forEach(({ key, flag, text }) => {
        if (!this.commentaryrudata[key]) {
          this.workflows[flag] = false;
          this.workflowtext.push(text);
        }
      });
      
      // Set workflows enabled flags
      this.setWorkflows();
      
      // Initialize labels using $nova.labelsName
      this.local_controls_label = this.$nova.labelsName('cycle_page', 'local_control_label', 'Local Control');
      this.local_management_label = this.$nova.labelsName('cycle_page', 'local_management_label', 'Local Management');
      this.regional_controls_label = this.$nova.labelsName('cycle_page', 'regional_control_label', 'Regional Control');
      this.regional_management_label = this.$nova.labelsName('cycle_page', 'regional_management_label', 'Regional Management');
      this.commentary_local_key_label = this.$nova.labelsName('cycle_page', 'commentary_local_key_label', 'Local');
      this.commentary_regional_key_label = this.$nova.labelsName('cycle_page', 'commentary_regional_key_label', 'Regional');
      const isBS = this.reportingType === 'bs';
      this.actual_shortform_label = isBS
        ? this.$nova.labelsName('cycle_page', 'actual_label_balancesheet', 'Actual')
        : this.$nova.labelsName('cycle_page', 'actual_label', 'Actual');
      this.proforma_shortform_label = isBS
        ? this.$nova.labelsName('cycle_page', 'proforma_shortform_label_balancesheet', 'Proforma')
        : this.$nova.labelsName('cycle_page', 'proforma_shortform_label', 'Proforma');
      this.forcast_shortform_label = isBS
        ? this.$nova.labelsName('cycle_page', 'forecast_shortform_label_balancesheet', 'Forecast')
        : this.$nova.labelsName('cycle_page', 'forecast_shortform_label', 'Forecast');

      // Update SL table upload preview headers with remapped labels
      const labelsPage = 'reporting_units_bulk_file';
      const remapLabel = (label) => this.$nova.identifyAndRemapLabelName(labelsPage, label);
      this.bulkUploadCommentaryHeaders = this.bulkUploadCommentaryHeaders.map((h) => ({
        ...h,
        text: h.text ? remapLabel(h.text) : h.text,
      }));
      this.bulkUploadCommentaryisApproverHeaders = this.bulkUploadCommentaryisApproverHeaders.map((h) => ({
        ...h,
        text: h.text ? remapLabel(h.text) : h.text,
      }));
      
      // Process commentary data items
      for (const item of (fdt.data || [])) {
        registerLookup(this.commentarydatajsonById, item._id, item);
        registerLookup(this.commentarydatajsonById, item.id, item);

        registerLookup(this.commentarydatajson, item.glcode, item);
        registerLookup(this.commentarydatajson, item.gl_code, item);
        registerLookup(this.commentarydatajson, item.glcode_str, item);
        registerLookup(this.commentarydatajson, item.clcode, item);
        registerLookup(this.commentarydatajson, item.client_code, item);

        registerLookup(this.commentarydatajsonByGLCode, item.glcode_detail?.code, item);
        registerLookup(this.commentarydatajsonByGLCode, item.glcode_detail?.glcode, item);
        registerLookup(this.commentarydatajsonByGLCode, item.glcode_detail?.path?.[0], item);
        registerLookup(this.commentarydatajsonByGLCode, item.clcode, item);
        registerLookup(this.commentarydatajsonByGLCode, item.client_code, item);
        
        // Normalize amounts
        item.amount1 = item.amount1 || 0;
        item.amount2 = item.amount2 || 0;
        item.amount3 = item.amount3 || 0;
        item.varianceamount1 = item.varianceamount1 || 0;
        item.varianceamount2 = item.varianceamount2 || 0;
        item.variancepercent1 = item.variancepercent1 || 0;
        item.variancepercent2 = item.variancepercent2 || 0;
        item.glcode_detail = item.glcode_detail || {};
        this.ensureReadableIdentifiers(item);
      }
      
      // Set cycle data
      this.commentarycycledata = fdt.cycle || {};
      
      // Set year, period, reportingunit from cycle data to ensure trendline context is complete
      // Try multiple paths for year extraction including from data items and period_detail
      // Note: In this app, year _id is the year value itself (e.g., "2023", "2024")
      // SLData.year and SLData.yearName both contain the year _id from buildSlContextPayload
      const yearSources = [
        fdt.cycle?.year_detail?._id,
        fdt.cycle?.year,
        fdt.year_detail?._id,
        fdt.year,
        fdt.reportingunit?.year_detail?._id,
        fdt.reportingunit?.year,
        fdt.data?.[0]?.year_detail?._id,
        fdt.data?.[0]?.year,
        fdt.cycle?.period_detail?.year_detail?._id,
        fdt.cycle?.period_detail?.year,
        // SLData.year is set from buildSlContextPayload in RUDataTable
        this.SLData?.year,
        this.SLData?.yearName,
        this.SLData?.year_detail?._id,
        this.SLData?.selectedGLCommentary?.year_detail?._id,
        this.SLData?.selectedGLCommentary?.year,
        this.SLData?.selectedCommentaryCycle?.year_detail?._id,
        this.SLData?.selectedCommentaryCycle?.year,
        this.commentarycycledata?.year_detail?._id,
        this.commentarycycledata?.year,
        this.yearId,
      ];
      
      
      for (const src of yearSources) {
        if (src) {
          this.year = src;
          break;
        }
      }
      
      if (this.commentarycycledata.period) {
        this.period = this.commentarycycledata.period;
      } else if (this.periodId) {
        this.period = this.periodId;
      }
      
      if (this.commentaryrudata._id) {
        this.reportingunit = this.commentaryrudata._id;
      } else if (this.reportingunitId) {
        this.reportingunit = this.reportingunitId;
      }

      // Set approval pending flags
      if (this.workflows.islocalenabled) {
        this.ispendinglocalruapproval = !(this.commentarycycledata.local_ru_approve || false);
      }
      if (this.workflows.isregionalenabled) {
        this.ispendingregionalruapproval = !(this.commentarycycledata.regional_ru_approve || false);
      }
      
      // Set other data
      this.allgls = fdt.gllist || [];
      this.commentarysummarydata = fdt.summary || {};
      
      // Extract clientGroupData for grouped view (similar to NetSalesBreakup)
      this.slClientGroupData = fdt.clientGroupData || [];
      
      // Set view mode based on whether grouped data exists
      // Only set default view on initial load, preserve user's view choice on reload
      const hasGroupedData = this.slClientGroupData.length > 0;
      if (hasGroupedData) {
        this.slViewMode = 'grouped';
        // Only set to grouped view if this is the initial load (slGroupedView hasn't been set yet)
        // Preserve user's view choice if they've already switched views
        if (this.initialViewSet !== true) {
          this.slGroupedView = 0; // 0 = Grouped (default)
          this.initialViewSet = true;
        }
      } else {
        this.slViewMode = 'ungrouped';
        this.slGroupedView = 1; // 1 = Ungrouped (no grouped data available)
      }
      
      // Store raw data for ungrouped view - process items with __stage and __myaction.
      // DESTOT is the DESIGNATED header, so it stays out of the flat list.
      // LOCTOT stays: it is a real row when there are no local client records, and it should still be visible when the list is ungrouped.
      this.slUngroupedData = (fdt.data || [])
        .filter(item => !this.isDesignatedTotalClcode(item.clcode || item.cl_code))
        .map((item, index) => ({
          ...item,
          __key: index,
          __index: index,
          __type: item.cl_type === 'SUBTOTAL' ? 'subtotal' : 'item',
          __code: item.clcode || item.glcode_detail?.code,
        }));
      console.log('[SLBreakup] slUngroupedData:', this.slUngroupedData.length, 'items from fdt.data');
      
      // Build tree structure from clientGroupData for grouped view
      this.commentarydata = this.buildSLTreeData(fdt.data || []);
      console.log('[SLBreakup] commentarydata (grouped):', this.commentarydata.length, 'items from clientGroupData');
      
      // Process commentary flags and compute user roles
      this.processCommentaryFlag();

      // Ensure inline tabs receive the latest GL context
      this.syncSelectedCommentary(true);
    },
    
    /**
     * DESTOT is the DESIGNATED group header and is not repeated as its own row.
     */
    isDesignatedTotalClcode(clcode) {
      const code = (clcode || '').toUpperCase();
      return code === varianceAnalysisConstants.CLIENT_SALES_BREAKDOWN.CL_CODES.DESTOT;
    },

    /**
     * LOCTOT is the LOCAL group header and is not repeated as its own flat row.
     */
    isLocalTotalClcode(clcode) {
      const code = (clcode || '').toUpperCase();
      return code === varianceAnalysisConstants.CLIENT_SALES_BREAKDOWN.CL_CODES.LOCTOT;
    },

    /**
     * Prepare clientGroupData the same way WPP_SL does before building the tree.
     * Sort each group's documents, copy DESTOT/LOCTOT onto the DESIGNATED/LOCAL headers,
     * and for agg market / SOXID insert a LOCAL header when only the LOCTOT total arrived.
     */
    reorganizeClientGroupData() {
      if (!this.slClientGroupData || this.slClientGroupData.length === 0) return;

      const { CL_TYPES, CL_CODES } = varianceAnalysisConstants.CLIENT_SALES_BREAKDOWN;
      const idToClCodeMap = varianceAnalysisConstants.idToClCodeMap;

      this.slClientGroupData.forEach(group => {
        if (Array.isArray(group?.documents)) {
          group.documents.sort((a, b) => (b?.amount1 || 0) - (a?.amount1 || 0));
        }
      });

      const subtotalGroup = this.slClientGroupData.find(
        item => item._id && item._id.toUpperCase() === CL_TYPES.SUBTOTAL
      );
      if (!subtotalGroup) return;

      const subtotalDocsMap = {};
      (subtotalGroup.documents || []).forEach(doc => {
        if (doc?.clcode) subtotalDocsMap[doc.clcode.toUpperCase()] = doc;
      });

      for (const item of this.slClientGroupData) {
        const mappedClCode = idToClCodeMap[item?._id?.toUpperCase()];
        if (mappedClCode && subtotalDocsMap[mappedClCode]) {
          item.subtotal = {
            ...subtotalDocsMap[mappedClCode],
            clcode: mappedClCode,
          };
        }
      }

      if (this.isSpecialRu) {
        const localIndex = this.slClientGroupData.findIndex(
          item => item._id && item._id.toUpperCase() === CL_TYPES.LOCAL
        );
        if (localIndex === -1 && subtotalDocsMap[CL_CODES.LOCTOT]) {
          const localSubtotalDoc = subtotalDocsMap[CL_CODES.LOCTOT];
          const localSubtotalRow = {
            _id: CL_TYPES.LOCAL,
            subtotal: {
              ...localSubtotalDoc,
              clcode: CL_CODES.LOCTOT,
            },
            documents: [],
            isLocalSubtotal: true,
          };
          const designatedIndex = this.slClientGroupData.findIndex(item =>
            item._id && item._id.toUpperCase() === CL_TYPES.DESIGNATED
          );
          const insertIndex = designatedIndex === -1 ? 0 : designatedIndex + 1;
          this.slClientGroupData.splice(insertIndex, 0, localSubtotalRow);
        }
      }

      // LOCTOT is the row under DESTOT. Keep LOCAL immediately after DESIGNATED,
      // ahead of the flat OTHER client rows.
      const localIndex = this.slClientGroupData.findIndex(
        item => item._id && item._id.toUpperCase() === CL_TYPES.LOCAL
      );
      if (localIndex !== -1) {
        const [localGroup] = this.slClientGroupData.splice(localIndex, 1);
        const designatedIndex = this.slClientGroupData.findIndex(
          item => item._id && item._id.toUpperCase() === CL_TYPES.DESIGNATED
        );
        const insertIndex = designatedIndex === -1 ? 0 : designatedIndex + 1;
        this.slClientGroupData.splice(insertIndex, 0, localGroup);
      }

      const othersIndex = this.slClientGroupData.findIndex(item =>
        item._id && (
          item._id.toUpperCase() === CL_TYPES.OTHERS ||
          item._id.toUpperCase() === CL_TYPES.OTHER
        )
      );
      const totalIndex = this.slClientGroupData.findIndex(item =>
        item._id && item._id.toUpperCase() === CL_TYPES.TOTAL
      );
      if (othersIndex !== -1 && totalIndex !== -1 && othersIndex > totalIndex) {
        const othersItem = this.slClientGroupData.splice(othersIndex, 1)[0];
        const newTotalIndex = this.slClientGroupData.findIndex(item =>
          item._id && item._id.toUpperCase() === CL_TYPES.TOTAL
        );
        this.slClientGroupData.splice(newTotalIndex, 0, othersItem);
      }
    },

    /**
     * Build tree structure from SL data
     * For SL Breakup: Groups items by gl_code and creates a virtual parent header
     * All items sharing the same gl_code become children under that header
     */
    buildSLTreeData(rawData) {
      if (!rawData || rawData.length === 0) return [];

      // If clientGroupData exists and we're in grouped view, use it for grouping
      if (this.slClientGroupData && this.slClientGroupData.length > 0) {
        return this.buildGroupedTreeFromClientGroupData();
      }

      // Check if data has SUBTOTAL items (traditional parent-child structure)
      const hasSubtotalItems = rawData.some(item => item.cl_type === 'SUBTOTAL');
      
      if (hasSubtotalItems) {
        // Use traditional parent-child structure based on cl_type and cl_clientTotal
        return this.buildTraditionalTreeData(rawData);
      }
      
      // For SL data without SUBTOTAL items, group by gl_code
      return this.buildVirtualParentTreeData(rawData);
    },
    
    /**
     * Build tree structure using clientGroupData for grouped view
     * Structure: clientGroupData = [{ _id, documents: [...], subtotal: {...} }, ...]
     * Similar to NetSalesBreakup's transformGroupedNetSalesData
     * 
     * IMPORTANT: 
     * - DESIGNATED, LOCAL: Show as grouped (header + expandable children)
     * - OTHER / OTHERS: Each client is its own flat row. There is no OTHER header.
     * - SUBTOTAL: DESTOT and LOCTOT are omitted because DESIGNATED and LOCAL already show them.
     *   Agg market / SOXID with no local client rows still get a LOCAL header from LOCTOT.
     * 
     * For API calls (addcommentary, savecommentary, etc.):
     * - Group headers use subtotal._id (the actual DB record ID)
     * - Child items use their own _id from documents array
     */
    buildGroupedTreeFromClientGroupData() {
      this.reorganizeClientGroupData();

      const treeData = [];
      let globalIndex = 0;
      
      // Groups that should be displayed as collapsed/expandable (header + children).
      // OTHER and OTHERS stay flat: each client is its own row.
      const GROUPED_TYPES = ['DESIGNATED', 'LOCAL'];
      let subtotalFlatDocuments = [];
      
      // Process each group from clientGroupData
      this.slClientGroupData.forEach(group => {
        const parentCode = group._id || `group_${globalIndex}`; // e.g., "DESIGNATED", "OTHER"
        const parentCodeUpper = parentCode.toUpperCase();
        const subtotal = group.subtotal || {};
        let documents = group.documents || [];

        // SUBTOTAL group has no header of its own.
        // DESTOT and LOCTOT are the DESIGNATED and LOCAL headers, so they are not repeated here.
        if (parentCodeUpper === 'SUBTOTAL') {
          subtotalFlatDocuments = documents.filter(doc => {
            const code = doc.clcode || doc.cl_code;
            return !this.isDesignatedTotalClcode(code) && !this.isLocalTotalClcode(code);
          });
          console.log('[SLBreakup] Deferring SUBTOTAL group — flat docs:', subtotalFlatDocuments.length);
          return;
        }
        
        console.log('[SLBreakup] buildGroupedTreeFromClientGroupData - Processing group:', parentCode, 'subtotal._id:', subtotal._id, 'documents:', documents.length);
        
        // Check if this group should be displayed as grouped or flat
        const isGroupedType = GROUPED_TYPES.includes(parentCode.toUpperCase());
        const isOthers = parentCodeUpper === 'OTHER' || parentCodeUpper === 'OTHERS';
        
        if (isGroupedType) {
          // ============= GROUPED VIEW (DESIGNATED, LOCAL) =============
          // Create group header using subtotal data
          // CRITICAL: Use subtotal._id for API calls (not parent_DESIGNATED)
          const groupHeader = {
            _id: subtotal._id || `parent_${parentCode}`, // Use subtotal._id for API calls
            client_name: parentCode,
            clcode: subtotal.clcode || parentCode,
            // Use subtotal amounts for header
            amount1: subtotal.amount1 || 0,
            amount2: subtotal.amount2 || 0,
            amount3: subtotal.amount3 || 0,
            varianceamount1: subtotal.varianceamount1 || 0,
            varianceamount2: subtotal.varianceamount2 || 0,
            variancepercent1: subtotal.variancepercent1 || 0,
            variancepercent2: subtotal.variancepercent2 || 0,
            // Include stage_local and stage_regional from subtotal for proper stage calculation
            stage_local: subtotal.stage_local,
            stage_regional: subtotal.stage_regional,
            __type: 'header',
            __code: parentCode,
            __parent: 'primary',
            __isGroupHeader: true,
            __isGroupedRow: true, // Flag for grouped row styling
            __index: globalIndex++,
            level: 0,
            glcode_detail: {
              _id: subtotal.glcode_detail?._id || `header_${parentCode}`,
              code: subtotal.clcode || parentCode,
              name: subtotal.client_name || parentCode,
              type: 'group',
              parent: 'primary',
              children: documents.map(d => d.clcode || d._id),
              subsequent_children: documents.map(d => d.clcode || d._id),
              path: subtotal.glcode_detail?.path || [parentCode]
            },
            // Materiality flags from subtotal
            var1_cross_control: subtotal.var1_cross_control || false,
            var1_cross_management: subtotal.var1_cross_management || false,
            var2_cross_control: subtotal.var2_cross_control || false,
            var2_cross_management: subtotal.var2_cross_management || false,
            var1_cross_control_regional: subtotal.var1_cross_control_regional || false,
            var1_cross_management_regional: subtotal.var1_cross_management_regional || false,
            var2_cross_control_regional: subtotal.var2_cross_control_regional || false,
            var2_cross_management_regional: subtotal.var2_cross_management_regional || false,
            // Other fields from subtotal
            commentary1: subtotal.commentary1 || '',
            commentary2: subtotal.commentary2 || '',
            regionalcommentary1: subtotal.regionalcommentary1 || '',
            regionalcommentary2: subtotal.regionalcommentary2 || '',
            ignorecommentary: subtotal.ignorecommentary || false,
            conversation_read: subtotal.conversation_read !== false,
            cycle: subtotal.cycle || this.cycleId,
            // Additional fields needed for API calls
            reportingunit: subtotal.reportingunit,
            period: subtotal.period,
            glcode: subtotal.glcode,
            hide_action: subtotal.hide_action || false,
          };
          
          // Calculate __stage for header using getStageFromItem
          groupHeader.__stage = this.getStageFromItem(groupHeader);
          groupHeader.__myaction = this.getActionFromItem(groupHeader);
          
          treeData.push(groupHeader);
          
          // Add child items from documents array
          documents.forEach(item => {
            const childItem = {
              ...item, // Spread all original fields including _id
              __type: 'child',
              __code: item.clcode || item._id,
              __parent: parentCode,
              __isGroupedRow: true, // Flag for grouped row styling
              __index: globalIndex++,
              level: 1,
              glcode_detail: item.glcode_detail || {
                _id: item._id,
                code: item.clcode || item._id,
                name: item.client_name || '',
                children: [],
                subsequent_children: []
              },
              // Ensure materiality flags are set
              var1_cross_control: item.var1_cross_control || false,
              var1_cross_management: item.var1_cross_management || false,
              var2_cross_control: item.var2_cross_control || false,
              var2_cross_management: item.var2_cross_management || false,
              var1_cross_control_regional: item.var1_cross_control_regional || false,
              var1_cross_management_regional: item.var1_cross_management_regional || false,
              var2_cross_control_regional: item.var2_cross_control_regional || false,
              var2_cross_management_regional: item.var2_cross_management_regional || false,
              hide_action: item.hide_action || false,
            };
            
            // Calculate __stage and __myaction for child
            childItem.__stage = this.getStageFromItem(childItem);
            childItem.__myaction = this.getActionFromItem(childItem);
            
            treeData.push(childItem);
          });
        } else {
          // ============= FLAT VIEW (non-grouped types) =============
          // Show each document as a flat row without grouping
          documents.forEach(item => {
            const flatItem = {
              ...item, // Spread all original fields including _id
              __type: 'flat', // Not grouped, individual item
              __code: item.clcode || item._id,
              __parent: null, // No parent - flat item
              __isOthers: isOthers, // Flag for OTHERS styling
              __isGroupedRow: false, // Not a grouped row
              __index: globalIndex++,
              level: 0, // Top level since no grouping
              glcode_detail: item.glcode_detail || {
                _id: item._id,
                code: item.clcode || item._id,
                name: item.client_name || '',
                children: [],
                subsequent_children: []
              },
              // Ensure materiality flags are set
              var1_cross_control: item.var1_cross_control || false,
              var1_cross_management: item.var1_cross_management || false,
              var2_cross_control: item.var2_cross_control || false,
              var2_cross_management: item.var2_cross_management || false,
              var1_cross_control_regional: item.var1_cross_control_regional || false,
              var1_cross_management_regional: item.var1_cross_management_regional || false,
              var2_cross_control_regional: item.var2_cross_control_regional || false,
              var2_cross_management_regional: item.var2_cross_management_regional || false,
              hide_action: item.hide_action || false,
            };
            
            // Calculate __stage and __myaction for flat item
            flatItem.__stage = this.getStageFromItem(flatItem);
            flatItem.__myaction = this.getActionFromItem(flatItem);
            
            treeData.push(flatItem);
          });
        }
      });

      // Append remaining SUBTOTAL documents (TOTCLI and any other totals) as flat rows
      subtotalFlatDocuments.forEach(item => {
        const flatItem = {
          ...item,
          __type: 'flat',
          __code: item.clcode || item._id,
          __parent: null,
          __isSubtotal: true,
          __isGroupedRow: false,
          __index: globalIndex++,
          level: 0,
          glcode_detail: item.glcode_detail || {
            _id: item._id,
            code: item.clcode || item._id,
            name: item.client_name || '',
            children: [],
            subsequent_children: []
          },
          var1_cross_control: item.var1_cross_control || false,
          var1_cross_management: item.var1_cross_management || false,
          var2_cross_control: item.var2_cross_control || false,
          var2_cross_management: item.var2_cross_management || false,
          var1_cross_control_regional: item.var1_cross_control_regional || false,
          var1_cross_management_regional: item.var1_cross_management_regional || false,
          var2_cross_control_regional: item.var2_cross_control_regional || false,
          var2_cross_management_regional: item.var2_cross_management_regional || false,
          hide_action: item.hide_action || false,
        };
        flatItem.__stage = this.getStageFromItem(flatItem);
        flatItem.__myaction = this.getActionFromItem(flatItem);
        treeData.push(flatItem);
      });
      
      // Initialize expanded state - start with all groups COLLAPSED (closed)
      this.expandedIds = new Set();
      this.isAllExpanded = false;
      
      return treeData;
    },
    
    /**
     * Build tree with virtual parent headers based on gl_code
     * Used when SL data has no SUBTOTAL items
     */
    buildVirtualParentTreeData(rawData) {
      // Group items by gl_code (e.g., "450000")
      const groupedByGlCode = {};
      rawData.forEach(item => {
        const glCode = item.gl_code || item.glcode_str || item.glcode_detail?.path?.[0] || 'UNKNOWN';
        if (!groupedByGlCode[glCode]) {
          groupedByGlCode[glCode] = [];
        }
        groupedByGlCode[glCode].push(item);
      });

      const treeData = [];
      
      // Process each GL code group
      Object.keys(groupedByGlCode).forEach(glCode => {
        const items = groupedByGlCode[glCode];
        
        // Calculate aggregated values for the parent header
        let totalAmount1 = 0;
        let totalAmount2 = 0;
        let totalAmount3 = 0;
        let totalVariance1 = 0;
        let totalVariance2 = 0;
        
        items.forEach(item => {
          totalAmount1 += Number(item.amount1) || 0;
          totalAmount2 += Number(item.amount2) || 0;
          totalAmount3 += Number(item.amount3) || 0;
          totalVariance1 += Number(item.varianceamount1) || 0;
          totalVariance2 += Number(item.varianceamount2) || 0;
        });

        // Get GL name from selectedGLCommentary or first item
        const glName = this.selectedGLCommentary?.glcode_detail?.name || 
                       items[0]?.glcode_detail?.name || 
                       `GL ${glCode}`;

        // Create virtual parent header for this GL code
        const parentHeader = {
          _id: `header_${glCode}`,
          gl_code: glCode,
          glcode_str: glCode,
          client_name: `${glCode} - ${glName}`,
          clcode: glCode,
          amount1: totalAmount1,
          amount2: totalAmount2,
          amount3: totalAmount3,
          varianceamount1: totalVariance1,
          varianceamount2: totalVariance2,
          variancepercent1: totalAmount2 !== 0 ? ((totalVariance1 / Math.abs(totalAmount2)) * 100) : 0,
          variancepercent2: totalAmount3 !== 0 ? ((totalVariance2 / Math.abs(totalAmount3)) * 100) : 0,
          __type: 'header',
          __code: glCode,
          __parent: 'primary',
          __isVirtualHeader: true,
          level: 0,
          glcode_detail: {
            _id: `header_${glCode}`,
            code: glCode,
            name: `${glCode} - ${glName}`,
            type: 'gl',
            parent: 'primary',
            children: items.map(item => item.clcode || item._id),
            subsequent_children: items.map(item => item.clcode || item._id),
            path: [glCode]
          },
          // Aggregate flags from children
          var1_cross_control: items.some(item => item.var1_cross_control),
          var1_cross_management: items.some(item => item.var1_cross_management),
          var2_cross_control: items.some(item => item.var2_cross_control),
          var2_cross_management: items.some(item => item.var2_cross_management),
          var1_cross_control_regional: items.some(item => item.var1_cross_control_regional),
          var1_cross_management_regional: items.some(item => item.var1_cross_management_regional),
          var2_cross_control_regional: items.some(item => item.var2_cross_control_regional),
          var2_cross_management_regional: items.some(item => item.var2_cross_management_regional),
        };
        
        treeData.push(parentHeader);
        
        // Add child items
        items.forEach(item => {
          treeData.push({
            ...item,
            __type: 'child',
            __code: item.clcode || item.glcode_detail?.code || item._id,
            __parent: glCode,
            level: 1,
            glcode_detail: {
              ...item.glcode_detail,
              code: item.clcode || item.glcode_detail?.code,
              name: item.client_name || item.glcode_detail?.name,
              children: [],
              subsequent_children: []
            }
          });
        });
      });

      // Reset expanded state on tree build
      this.expandedIds = new Set();
      this.isAllExpanded = false;

      return treeData;
    },
    
    /**
     * Build tree with traditional parent-child structure based on cl_type === 'SUBTOTAL'
     */
    buildTraditionalTreeData(rawData) {
      // Build a map of all items by clcode for quick lookup
      const allItemsByClcode = {};
      rawData.forEach(item => {
        if (item.clcode) {
          allItemsByClcode[item.clcode] = item;
        }
      });

      // Identify parents (headers) and children
      const parents = [];
      const children = [];
      rawData.forEach(item => {
        if (item.cl_type === 'SUBTOTAL') {
          parents.push(item);
        } else {
          children.push(item);
        }
      });

      // Build parent-child relationships
      const parentMap = {};
      parents.forEach(parent => {
        parentMap[parent.clcode] = {
          ...parent,
          __type: 'header',
          __code: parent.clcode || 'NA',
          __parent: 'primary',
          level: 0,
          glcode_detail: {
            ...parent.glcode_detail,
            code: parent.clcode || parent.glcode_detail?.code,
            name: parent.client_name || parent.glcode_detail?.name,
            children: [],
            subsequent_children: []
          }
        };
      });

      // Assign children to parents
      children.forEach(child => {
        const parentCode = child.cl_clientTotal;
        if (parentCode && parentMap[parentCode]) {
          parentMap[parentCode].glcode_detail.children.push(child.clcode);
          parentMap[parentCode].glcode_detail.subsequent_children.push(child.clcode);
        }
      });

      // Build the tree data array
      const treeData = [];
      const processedParents = new Set();

      // Add parents and their children in order
      rawData.forEach(item => {
        if (item.cl_type === 'SUBTOTAL' && !processedParents.has(item.clcode)) {
          const parent = parentMap[item.clcode];
          treeData.push(parent);
          processedParents.add(item.clcode);
          // Add children for this parent
          children.forEach(child => {
            if (child.cl_clientTotal === item.clcode) {
              treeData.push({
                ...child,
                __type: 'child',
                __code: child.clcode || child.glcode_detail?.code,
                __parent: item.clcode,
                level: 1,
                glcode_detail: {
                  ...child.glcode_detail,
                  code: child.clcode || child.glcode_detail?.code,
                  name: child.client_name || child.glcode_detail?.name,
                  children: [],
                  subsequent_children: []
                }
              });
            }
          });
        }
      });

      // Add orphan children (no parent found)
      children.forEach(child => {
        const parentCode = child.cl_clientTotal;
        if (!parentCode || !parentMap[parentCode]) {
          treeData.push({
            ...child,
            __type: 'child',
            __code: child.clcode || child.glcode_detail?.code,
            __parent: 'NA',
            level: 0,
            glcode_detail: {
              ...child.glcode_detail,
              code: child.clcode || child.glcode_detail?.code,
              name: child.client_name || child.glcode_detail?.name,
              children: [],
              subsequent_children: []
            }
          });
        }
      });

      // Always reset expanded state on tree build
      this.expandedIds = new Set();
      this.isAllExpanded = false;

      return treeData;
    },

    cloneCommentaryItem(item) {
      if (!item || typeof item !== 'object') {
        return {};
      }
      try {
        return JSON.parse(JSON.stringify(item));
      } catch (error) {
        console.warn('[SLBreakup] Failed to clone commentary item', error);
        return { ...item };
      }
    },
    getEmptyLastActions() {
      // Provide predictable structure when no log entries are available.
      return {
        localaction: { type: 'none', lastAction: '' },
        regionalaction: { type: 'none', lastAction: '' },
      };
    },

    deriveLastActionsFromLogs(logs) {
      const entries = Array.isArray(logs) ? logs : [];
      const baseResult = this.getEmptyLastActions();

      if (!entries.length) {
        return baseResult;
      }

      const isActualCycle = (this.cycletype || 'Actual').toLowerCase() === 'actual';
      const actualConfig = {
        localTypes: ['a_localreject', 'a_localapprove', 'a_Localbulkreject', 'a_localbulkapprove', 'a_localfileapprove', 'a_localfilereject'],
        localMapping: {
          reject: ['a_localreject', 'a_Localbulkreject', 'a_localfilereject'],
          approve: ['a_localapprove', 'a_localbulkapprove', 'a_localfileapprove'],
          rejectLabel: 'localreject',
          approveLabel: 'localapprove',
        },
        regionalTypes: ['a_regionalreject', 'a_regionalapprove', 'a_Regionalbulkreject', 'a_regionalbulkapprove', 'a_regionalfileapprove', 'a_regionalfilereject'],
        regionalMapping: {
          reject: ['a_regionalreject', 'a_Regionalbulkreject', 'a_regionalfilereject'],
          approve: ['a_regionalapprove', 'a_regionalbulkapprove', 'a_regionalfileapprove'],
          rejectLabel: 'regionalreject',
          approveLabel: 'regionalapprove',
        },
      };

      const forecastConfig = {
        localTypes: ['f_localreject', 'f_localapprove', 'f_Localbulkreject', 'f_localbulkapprove', 'f_localfileapprove', 'f_localfilereject'],
        localMapping: {
          reject: ['f_localreject', 'f_Localbulkreject', 'f_localfilereject'],
          approve: ['f_localapprove', 'f_localbulkapprove', 'f_localfileapprove'],
          rejectLabel: 'localreject',
          approveLabel: 'localapprove',
        },
        regionalTypes: ['f_regionalreject', 'f_regionalapprove', 'f_Regionalbulkreject', 'f_regionalbulkapprove', 'f_regionalfileapprove', 'f_regionalfilereject'],
        regionalMapping: {
          reject: ['f_regionalreject', 'f_Regionalbulkreject', 'f_regionalfilereject'],
          approve: ['f_regionalapprove', 'f_regionalbulkapprove', 'f_regionalfileapprove'],
          rejectLabel: 'regionalreject',
          approveLabel: 'regionalapprove',
        },
      };

      const config = isActualCycle ? actualConfig : forecastConfig;

      const pickLatestByTypes = (types) => {
        let latest = null;
        for (const entry of entries) {
          if (!types.includes(entry.type)) {
            continue;
          }
          if (!latest || new Date(entry.created_at) > new Date(latest.created_at)) {
            latest = entry;
          }
        }
        return latest;
      };

      const annotate = (entry, mapping) => {
        if (!entry) {
          return { type: 'none', lastAction: '' };
        }
        const annotated = { ...entry };
        if (mapping.reject.includes(entry.type)) {
          annotated.lastAction = mapping.rejectLabel;
        } else if (mapping.approve.includes(entry.type)) {
          annotated.lastAction = mapping.approveLabel;
        } else {
          annotated.lastAction = '';
        }
        return annotated;
      };

      return {
        localaction: annotate(pickLatestByTypes(config.localTypes), config.localMapping),
        regionalaction: annotate(pickLatestByTypes(config.regionalTypes), config.regionalMapping),
      };
    },

    syncSelectedCommentary(force = false) {
      const storeItem = this.selectedGLCommentary;
      if (!storeItem || !Object.keys(storeItem).length) {
        if (force) {
          this.selectedcommentary = {};
          this.summaryAiProforma = '';
          this.summaryAiForecast = '';
          this.showSummaryTab = false;
        }
        return;
      }

      const storeKeys = this.extractCommentaryKeys(storeItem);
      const currentKeys = this.extractCommentaryKeys(this.selectedcommentary);
      const selectionChanged = force || (storeKeys.primary && storeKeys.primary !== currentKeys.primary);

      if (!force && storeKeys.primary && storeKeys.primary === currentKeys.primary) {
        return;
      }

      const lookupMaps = [
        this.commentarydatajsonById,
        this.commentarydatajson,
        this.commentarydatajsonByGLCode,
      ];

      const candidates = [
        storeKeys.primary,
        storeKeys.secondary,
        storeKeys.code,
        ...(storeKeys.aliases || []),
      ].filter(Boolean);

      let nextItem = null;
      for (const candidate of candidates) {
        const normalized = this.normalizeLookupKey(candidate);
        if (!normalized) {
          continue;
        }
        nextItem = lookupMaps.reduce((found, map) => found || map[normalized], null);
        if (nextItem) {
          break;
        }
      }

      if (!nextItem) {
        const fallbackKeys = [
          storeItem.glcode_detail?.code,
          storeItem.glcode_detail?.glcode,
          storeItem.glcode,
          storeItem.gl_code,
          storeItem.glcode_str,
          storeItem.clcode,
          storeItem.client_code,
          storeItem.client_glcode,
        ];
        for (const fallback of fallbackKeys) {
          const normalized = this.normalizeLookupKey(fallback);
          if (!normalized) {
            continue;
          }
          nextItem = this.commentarydatajsonByGLCode[normalized] || this.commentarydatajson[normalized];
          if (nextItem) {
            break;
          }
        }
      }

      if (!nextItem) {
        nextItem = storeItem;
      }

      this.selectedcommentary = this.mergeCommentaryData(nextItem, storeItem, this.selectedStoreCommentary);
      this.applySummaryStateFromCommentary(this.selectedcommentary, selectionChanged);
    },

    applySummaryStateFromCommentary(commentary, shouldHydrate = false) {
      if (!shouldHydrate) {
        return;
      }

      const fallbackProforma = typeof this.SLData?.summaryAiProforma === 'string' ? this.SLData.summaryAiProforma : '';
      const fallbackForecast = typeof this.SLData?.summaryAiForecast === 'string' ? this.SLData.summaryAiForecast : '';

      const summaryProforma = typeof commentary?.summarycommentary1 === 'string' ? commentary.summarycommentary1 : fallbackProforma;
      const summaryForecast = typeof commentary?.summarycommentary2 === 'string' ? commentary.summarycommentary2 : fallbackForecast;

      this.summaryAiProforma = summaryProforma || '';
      this.summaryAiForecast = summaryForecast || '';

      const hasSummary = Boolean(
        (this.summaryAiProforma && this.summaryAiProforma.trim()) ||
        (this.summaryAiForecast && this.summaryAiForecast.trim()),
      );
      const showSummaryPreference = typeof this.SLData?.showSummaryTab === 'boolean'
        ? this.SLData.showSummaryTab
        : undefined;
      this.showSummaryTab = showSummaryPreference !== undefined ? showSummaryPreference : hasSummary;

      if (commentary && commentary.isThresholdExceedJVSummarisation !== undefined) {
        this.isThresholdExceedJVSummarisation = Boolean(commentary.isThresholdExceedJVSummarisation);
      } else if (this.SLData?.isThresholdExceedJVSummarisation !== undefined) {
        this.isThresholdExceedJVSummarisation = Boolean(this.SLData.isThresholdExceedJVSummarisation);
      } else if (!hasSummary) {
        this.isThresholdExceedJVSummarisation = false;
      }
    },

    extractCommentaryKeys(item) {
      if (!item || typeof item !== 'object') {
        return { primary: '', secondary: '', code: '', aliases: [] };
      }

      const detail = item.glcode_detail || {};
      const register = (set, value, includeVariants = false) => {
        if (Array.isArray(value)) {
          value.forEach(entry => register(set, entry, includeVariants));
          return;
        }
        const normalized = this.normalizeLookupKey(value);
        if (!normalized) {
          return;
        }
        set.add(normalized);
        if (includeVariants) {
          const compact = normalized.replace(/[^A-Z0-9]/g, '');
          if (compact && compact !== normalized) {
            set.add(compact);
          }
        }
      };

      const primary = this.normalizeLookupKey([item._id, item.id]);

      const secondarySet = new Set();
      register(secondarySet, [item.glcode, item.gl_code, item.glcode_str, item.client_glcode]);
      register(secondarySet, [detail.code, detail.glcode, detail.client_code, detail.clcode]);
      register(secondarySet, [item.clcode, item.client_code, detail.path]);
      const secondary = secondarySet.size ? Array.from(secondarySet)[0] : '';

      const code = this.normalizeLookupKey([detail.code, detail.glcode, item.client_code, item.clcode]);

      const aliasSet = new Set();
      const aliasSources = [
        item.glcode_alias,
        item.glcode_aliases,
        item.alias,
        item.aliases,
        detail.alias,
        detail.aliases,
        detail.aliasList,
        detail.alias_codes,
        detail.alternate_codes,
        detail.alternateCodes,
        detail.legacy_codes,
        detail.legacyCodes,
        detail.alt_codes,
        detail.path,
      ];
      aliasSources.forEach(source => register(aliasSet, source, true));
      register(aliasSet, secondary, true);
      register(aliasSet, code, true);

      const aliases = Array.from(aliasSet).filter(value => value && value !== primary && value !== secondary && value !== code);

      return { primary, secondary, code, aliases };
    },

    // Merge processed SL dataset row with the GL snapshots from the store so inline tabs display GL numbers.
    mergeCommentaryData(datasetItem, ...storeItems) {
      const datasetClone = this.cloneCommentaryItem(datasetItem);
      const merged = { ...datasetClone, glcode_detail: { ...(datasetClone.glcode_detail || {}) } };

      const numericKeys = [
        'amount1', 'amount2', 'amount3',
        'varianceamount1', 'varianceamount2',
        'variancepercent1', 'variancepercent2',
        'crosscontrolthresholdvsproforma', 'crossmanagementthresholdvsproforma',
        'crosscontrolthresholdvsforecast', 'crossmanagementthresholdvsforecast',
      ];

      const commentaryKeys = [
        'commentary1', 'commentary2',
        'regionalcommentary1', 'regionalcommentary2',
        'savedcommentary1', 'savedcommentary2',
        'approvereason', 'regionalapprovereason',
      ];

      // Filter out empty snapshots and process
      storeItems.filter(s => s && typeof s === 'object' && Object.keys(s).length).forEach(snapshot => {
        const snapshotClone = this.cloneCommentaryItem(snapshot);
        Object.assign(merged, snapshotClone);
        
        merged.glcode_detail = {
          ...merged.glcode_detail,
          ...snapshotClone.glcode_detail,
        };

        // Merge numeric and commentary keys with defined values only
        [...numericKeys, ...commentaryKeys].forEach(key => {
          const value = snapshotClone[key];
          if (value !== undefined && value !== null && value !== '') {
            merged[key] = value;
          }
        });
      });

      // Preserve stage and action from dataset if not in merged
      if (datasetClone.__stage !== undefined && merged.__stage === undefined) {
        merged.__stage = datasetClone.__stage;
      }
      if (datasetClone.__myaction !== undefined && merged.__myaction === undefined) {
        merged.__myaction = datasetClone.__myaction;
      }

      this.ensureReadableIdentifiers(merged);
      return merged;
    },

    ensureReadableIdentifiers(record) {
      if (!record || typeof record !== 'object') return;

      // Process GL identifiers
      const detail = record.glcode_detail || {};
      const readableGl = detail.code || detail.glcode || detail.client_code;
      
      if (readableGl) {
        const shouldUpdateGl = !record.glcode || this.isLikelyObjectId(record.glcode);
        if (shouldUpdateGl) record.glcode = readableGl;
        
        // Set all GL-related fields if missing
        ['client_glcode', 'clcode', 'client_code'].forEach(key => {
          if (!record[key]) record[key] = readableGl;
        });
      }

      // Process reporting unit identifier
      const ruDetail = record.reportingunit_detail || {};
      const ruCode = ruDetail.code;
      const ruId = ruDetail._id;
      
      if (!record.reportingunit && (ruId || ruCode)) {
        record.reportingunit = ruId || ruCode;
      }
      if (ruCode) {
        record.reportingunitReadable = ruCode;
      }

      // Process period identifier
      const periodId = record.period_detail?._id;
      if (periodId && (!record.period || this.isLikelyObjectId(record.period))) {
        record.period = periodId;
      }

      // Process year identifier
      const yearId = record.year_detail?._id;
      if (yearId && (!record.year || this.isLikelyObjectId(record.year))) {
        record.year = yearId;
      }
    },

    isLikelyObjectId(value) {
      return typeof value === 'string' && /^[a-f0-9]{24}$/i.test(value);
    },
    
    getRoleLabel(role){
      const mapping = ROLE_LABEL_MAPPING[role] || VIEW_ONLY;
      if (this.$nova && typeof this.$nova.labelsName === 'function') {
        return this.$nova.labelsName('cycle_page', mapping?.key, mapping?.default);
      }
      return mapping?.default;
    },

    applyRoleFlags(role) {
      // reset
      this.ispreparer = false;
      this.isapprover = false;
      this.isregionalapprover = false;
      this.ismanager = false;
      this.isviewonly = false;

      // set the chosen role
      if (role === ROLES.LOCAL_PREPARER) this.ispreparer = true;
      else if (role === ROLES.LOCAL_APPROVER) this.isapprover = true;
      else if (role === ROLES.REGIONAL_APPROVER) this.isregionalapprover = true;
      else if (role === ROLES.MANAGER) this.ismanager = true;
      else this.isviewonly = true;
    },

    /**
     * Reprocess item actions after role change
     * Updates __myaction for all commentary items based on current role flags
     */
    reprocessItemActions() {
      for (const item of this.commentarydata) {
        item.__myaction = this.getActionFromItem(item);
      }
      // Also clear multiselect when switching roles
      this.$nextTick(() => {
        this.multiselectdata = [];
      });
    },

    /**
     * Process commentary flags for each item and set up roles
     */
    processCommentaryFlag() {
      // 1. Setup Roles FIRST
      this.ispreparer = false;
      this.isapprover = false;
      this.isregionalapprover = false;
      this.ismanager = false;
      this.isviewonly = false;

      const userRoles = getAvailableRoles(this.commentaryrudata, this.userid).map((role) => {
        return {
          ...role,
          label: this.getRoleLabel(role.value)
        }
      });

      // If no recognized role → viewonly
      if (!userRoles?.length) {
        this.isviewonly = true;
        this.ruRoleOptions = [];
        this.selectedRuRole = null;
        // Even if viewonly, we should still process item flags, though actions will likely be 'view'
      } else {
        this.ruRoleOptions = userRoles;
        
        // Auto-select *lowest* priority role (first in list usually) or keep existing if valid
        let defaultRole = userRoles[0]?.value || '';
        
        // If we already have a selected role and it's still valid, keep it
        if (this.selectedRuRole && userRoles.some(r => r.value === this.selectedRuRole)) {
          defaultRole = this.selectedRuRole;
        }
        
        // When slEnabled is false (navigated as approver), override with approver role from SLData
        if (!this.slEnabled) {
          const storeData = this.SLData;
          if (storeData.isregionalapprover && userRoles.some(r => r.value === ROLES.REGIONAL_APPROVER)) {
            defaultRole = ROLES.REGIONAL_APPROVER;
          } else if (storeData.isapprover && userRoles.some(r => r.value === ROLES.LOCAL_APPROVER)) {
            defaultRole = ROLES.LOCAL_APPROVER;
          }
        }

        this.selectedRuRole = defaultRole;
        this.applyRoleFlags(defaultRole);
      }
      
      if ((this.commentaryrudata.submitter || []).length === 0 || (this.commentaryrudata.approver || []).length === 0 || (this.commentaryrudata.manager || []).length === 0 || (this.commentaryrudata.regional_approver || []).length === 0) {
        this.alluserassigned = false;
      } else {
        this.alluserassigned = true;
      }

      // 2. Process item flags SECOND (now that roles are set)
      for (const item of this.commentarydata) {
        // Set stage based on commentary status
        item.__stage = this.getStageFromItem(item);
        item.__myaction = this.getActionFromItem(item);
      }
    },
    setWorkflows() {
      // Check if local workflows are enabled
      this.workflows.islocalenabled = this.workflows.lcp || this.workflows.lmp || this.workflows.lcf || this.workflows.lmf;
      this.workflows.isregionalenabled = this.workflows.rcp || this.workflows.rmp || this.workflows.rcf || this.workflows.rmf;
      this.workflows.islocalproformaenabled = this.workflows.lcp || this.workflows.lmp;
      this.workflows.islocalforecastenabled = this.workflows.lcf || this.workflows.lmf;
      this.workflows.isregionalproformaenabled = this.workflows.rcp || this.workflows.rmp;
      this.workflows.isregionalforecastenabled = this.workflows.rcf || this.workflows.rmf;
      this.workflows.isworkflowsenabled = this.workflows.islocalenabled || this.workflows.isregionalenabled;
    },
    

    
    /**
     * Get stage from item based on commentary status
     * This consolidates local and regional stages into a single __stage value
     */
    getStageFromItem(item) {
      // If item already has __stage, use it
      if (item.__stage !== undefined && item.__stage !== null) {
        return item.__stage;
      }
      
      // If item has a direct 'stage' field (common in SL data), use it
      if (item.stage !== undefined && item.stage !== null) {
        return item.stage;
      }
      
      // Match the exact logic from helpers.js using else-if chain
      // This ensures once a condition matches, subsequent conditions are skipped
      let stage = 0;
      if (item.stage_local === 0) stage = 0;
      else if (item.stage_local === -1) stage = -1;
      else if (item.stage_local === 1) stage = 1;
      else if (item.stage_regional === 0) stage = 5;
      else if (item.stage_regional === -1) stage = -2;
      else if (item.stage_regional === 1) stage = 6;
      else if (item.stage_regional === 2) stage = 7; // Regional approved - fully approved
      else if (item.stage_local === 2) {
        // Local approved - check if regional workflows require action
        // If regional workflows are enabled and regional thresholds are crossed, show Regional Commentary Awaited
        if (this.workflows.isregionalenabled) {
          const hasRegionalProformaThreshold = item.var1_cross_control_regional || item.var1_cross_management_regional;
          const hasRegionalForecastThreshold = item.var2_cross_control_regional || item.var2_cross_management_regional;
          if (hasRegionalProformaThreshold || hasRegionalForecastThreshold) {
            // Regional commentary is required - show Regional Commentary Awaited
            stage = 5;
          } else {
            // No regional threshold crossed - approved
            stage = 7;
          }
        } else {
          // Regional workflows not enabled - mark as approved
          stage = 7;
        }
      }
      else if (item.stage_local === 3) stage = 3;
      else if (item.stage_regional === 4) stage = 4;
      else if (item.stage_regional === 5 || item.stage_local === 5) stage = 9;
      else stage = 4;
      
      return stage;
    },
    
    /**
     * Get action from item based on user role and item status
     * This determines what action buttons are shown in RUDataTable
     */
    getActionFromItem(item) {
      // Default to view
      let action = 'view';
      
      // Skip action assignment if commentary is ignored
      if (item.ignorecommentary) {
        return action;
      }
      
      // If SL operations are disabled (user navigated as approver/regional approver), 
      // only allow regional commentary actions for approvers, not local preparer actions
      if (!this.slEnabled) {
        // Allow approvers to add regional commentary when stage is appropriate
        if (this.isapprover && [-2, 5, 6, 9].indexOf(item.__stage) > -1) {
          action = 'regionaladd';
        } else if (this.isapprover && [3, 8, 9].indexOf(item.__stage) > -1 && this.workflows.isregionalenabled) {
          action = 'regionalvoluntary';
        }
        // Note: Regional approver actions (regionalapprove, regionalrequest) are disabled on SLBreakup page
        return action;
      }
      
      // Determine action based on role and stage
      if (this.ispreparer && [-1, 0, 1, 9].indexOf(item.__stage) > -1) {
        action = 'localadd';
      } else if (this.isapprover && item.__stage === 1) {
        action = 'localapprove';
      } else if (this.isapprover && [-2, 5, 6, 9].indexOf(item.__stage) > -1) {
        action = 'regionaladd';
      } else if (this.ispreparer && [3, 4, 8, 9].indexOf(item.__stage) > -1 && this.workflows.islocalenabled) {
        action = 'localvoluntary';
      } else if (this.isapprover && [3, 8, 9].indexOf(item.__stage) > -1 && this.workflows.isregionalenabled) {
        action = 'regionalvoluntary';
      } else if (this.isapprover && [7, 9].indexOf(item.__stage) > -1 && this.workflows.islocalenabled) {
        action = 'localrequest';
      }
      // Note: Regional approver actions (regionalapprove, regionalrequest) are disabled on SLBreakup page
      
      return action;
    },
    
    /**
     * Get filter flag for an item based on selectedfilter and customfilterstoggle
     * Returns [shouldIgnore, isDefaultFilter] tuple, matching helpers.js getFilterFlag
     * @param {Object} dt - The commentary data item
     * @param {Array} filters - The selected filter values (optional, defaults to this.selectedfilter)
     * @param {Boolean} customToggle - Custom filter toggle state (optional)
     * @param {Array} customList - Custom filter list (optional)
     * @returns {Array} [shouldIgnore: boolean, isDefaultFilter: boolean]
     */
    getFilterFlag(dt, filters, customToggle, customList) {
      const selectedFilters = filters !== undefined ? filters : this.selectedfilter;
      const isCustomToggle = customToggle !== undefined ? customToggle : this.customfilterstoggle;
      const customFilterList = customList !== undefined ? customList : this.customfilter;
      
      // If custom filter toggle is on and item's glcode is not in custom filter list, ignore it
      if (isCustomToggle && customFilterList && customFilterList.indexOf(dt.glcode) === -1) {
        return [true, true];
      }
      // If no filters are selected, ignore all items (show nothing)
      if (!selectedFilters || selectedFilters.length === 0) {
        return [true, true];
      }
      // If item's stage is not in selected filter array, ignore it
      if (selectedFilters.indexOf(dt?.__stage) === -1) {
        return [true, !(dt?.__stage === 3 || dt?.__stage === 9)];
      }
      return [false, true];
    },
    
    /**
     * Toggle between commentary view and list view
     */
    toggleViewFun() {
      this.isCommentaryView = !this.isCommentaryView;
      if (this.isCommentaryView) {
        this.toggletableview = 1;
      } else {
        this.toggletableview = 0;
      }
    },
    
    // ===== Fetch AI Features =====
    async fetchAiFeatures() {
      try {
        const features = await this.$store.dispatch('varianceanalysis/fetchAiFeatures', this.axios);

        if (!Array.isArray(features)) {
          console.warn('[SLBreakup] features is not an array:', features);
          this.commentaryStatusData = null;
          this.commentaryGenAiBtntabValue = false;
          return;
        }
        
        // JV Summarisation (from Base.vue logic)
        const summaryStatus = features.find(feature => feature.name === 'jv_summarisation');
        this.showSummaryTab = summaryStatus?.platform_admin_enabled && summaryStatus?.super_admin_enabled;
        this.isThresholdExceedJVSummarisation = summaryStatus?.isExceed || false;

        // Local Commentary (from Base.vue logic)
        const localCommentaryStatus = features.find(feature => feature.name === 'local_commentary_summary');
        this.isThresholdExceedLocalCommentary = localCommentaryStatus?.isExceed || false;
        this.localCommentaryGenAiBtntab = localCommentaryStatus?.platform_admin_enabled && localCommentaryStatus?.super_admin_enabled;

        const featureName = this.isRevenue ? 'revenue_commentary_summary' : 'netsales_commentary_summary';
        const commentaryStatus = features.find(feature => feature.name === featureName);
        this.commentaryStatusData = commentaryStatus || null;
        
        console.log('[SLBreakup] featureName:', featureName);
        console.log('[SLBreakup] Available features:', features.map(f => f.name));
        console.log('[SLBreakup] commentaryStatusData:', this.commentaryStatusData);
        
        if (this.commentaryStatusData) {
          this.commentaryGenAiBtntabValue = this.commentaryStatusData.platform_admin_enabled && this.commentaryStatusData.super_admin_enabled;
        } else {
          this.commentaryGenAiBtntabValue = false;
        }
      } catch (error) {
        console.error('Error fetching AI features:', error);
        this.commentaryStatusData = null;
        this.commentaryGenAiBtntabValue = false;
      }
    },
    
    // ===== Navigation =====
    handleBack() {
      // Set flag to skip reload when Base.vue mounts again
      this.$store.commit('varianceanalysis/setSkipReloadOnBack', true);
      this.$router.back();
    },
    
    handleRefresh() {
      // Reload SL data with force refresh
      this.loadSLData(true);
    },
    
    getStatusLabel(key, fallback) {
      if (this.$nova && typeof this.$nova.labelsName === 'function') {
        return this.$nova.labelsName('cycle_page', key, fallback);
      }
      return fallback;
    },
    
    // ===== Formatting =====
    formatCurrency(amount) {
      if (amount === null || amount === undefined || amount === '') {
        return '-';
      }
      if (this.$nova && typeof this.$nova.formatCurrency === 'function') {
        return this.$nova.formatCurrency(amount, '', false, true);
      }
      return Number(amount).toLocaleString();
    },
    
    formatPercent(value) {
      if (value === null || value === undefined || value === '') {
        return '-';
      }
      const percent = Number(value) * 100;
      if (Number.isNaN(percent)) {
        return '-';
      }
      if (this.$nova && typeof this.$nova.formatCurrency === 'function') {
        const formatted = this.$nova.formatCurrency(percent, '', false, true);
        return `${formatted}${percent !== 0 ? ' %' : ''}`;
      }
      return `${percent.toFixed(1)}${percent !== 0 ? '%' : ''}`;
    },
    
    varianceClass(value) {
      if (value > 0) return 'success--text font-weight-bold';
      if (value < 0) return 'error--text font-weight-bold';
      return 'grey--text font-weight-bold';
    },
    
    // ===== Event Handlers =====
    handleFilterUpdate(value) {
      this.selectedfilter = value;
    },
    
    handleCustomFiltersToggle(value) {
      this.customfilterstoggle = value;
    },
    
    handleToggleView() {
      this.toggleViewFun();
    },
    
    handleToggleTableView(value) {
      this.toggletableview = value;
    },
    
    // Handle SL Grouped/Ungrouped view change (separate from toggletableview)
    handleSlGroupedViewChange(value) {
      this.slGroupedView = value;
      this.slViewMode = value === 0 ? 'grouped' : 'ungrouped';
    },
    
    // Handle SL group toggle for grouped view (parent-child expansion)
    handleToggleSLGroup(groupId) {
      const index = this.slExpandedGroups.indexOf(groupId);
      if (index > -1) {
        this.slExpandedGroups.splice(index, 1);
      } else {
        this.slExpandedGroups.push(groupId);
      }
    },
    
    handleToggleExpandAll() {
      this.isAllExpanded = !this.isAllExpanded;
      if (this.isAllExpanded) {
        // Expand all parent/header items
        this.expandedIds = new Set(
          this.commentarydata
            .filter(item => item.__type === 'header')
            .map(item => (item.__code ?? item.clcode ?? '')?.toString())
            .filter(Boolean)
        );
      } else {
        this.expandedIds = new Set();
      }
    },
    
    handleToggleExpand(item) {
      // Use __code for tree expansion (GL codes like "450000" for SL data)
      const code = item.__code || item.clcode || item.gl_code;
      if (!code) return;
      
      const codeStr = String(code);
      if (this.expandedIds.has(codeStr)) {
        this.expandedIds.delete(codeStr);
      } else {
        this.expandedIds.add(codeStr);
      }
      // Force reactivity
      this.expandedIds = new Set(this.expandedIds);
    },
    
    /**
     * Check if item has children (for showing expand icon)
     */
    hasChildren(item) {
      // Virtual headers always have children
      if (item.__isVirtualHeader) {
        return true;
      }
      return item.__type === 'header' && 
             item.glcode_detail?.children && 
             item.glcode_detail.children.length > 0;
    },
    
    /**
     * Check if item is expanded
     */
    isExpanded(item) {
      const code = item.__code || item.clcode;
      return code && this.expandedIds.has(code);
    },
    
    handleMarkConversationRead() {
      if (this.commentarycycledata) {
        this.commentarycycledata.conversation_read = true;
      }
      if (this.selectedGLCommentary && typeof this.selectedGLCommentary === 'object') {
        this.$set(this.selectedGLCommentary, 'conversation_read', true);
      }
    },
    
    handleOpenUserListDialog() {
      this.userlistdialog = true;
    },
    
    resolveMultiselectCommentaryItem(id) {
      const key = this.normalizeLookupKey(id);
      if (key && this.commentarydatajsonById?.[key]) {
        return this.commentarydatajsonById[key];
      }
      return this.commentarydata.find((item) => item._id === id)
        || this.slUngroupedData.find((item) => item._id === id)
        || null;
    },

    getAggregatedMultiselectThresholdFlags() {
      const flags = {
        var1_cross_control: false,
        var1_cross_management: false,
        var2_cross_control: false,
        var2_cross_management: false,
        var1_cross_control_regional: false,
        var1_cross_management_regional: false,
        var2_cross_control_regional: false,
        var2_cross_management_regional: false,
      };
      (this.multiselectdata || []).forEach((id) => {
        const item = this.resolveMultiselectCommentaryItem(id);
        if (!item) {
          return;
        }
        flags.var1_cross_control = flags.var1_cross_control || Boolean(item.var1_cross_control);
        flags.var1_cross_management = flags.var1_cross_management || Boolean(item.var1_cross_management);
        flags.var2_cross_control = flags.var2_cross_control || Boolean(item.var2_cross_control);
        flags.var2_cross_management = flags.var2_cross_management || Boolean(item.var2_cross_management);
        flags.var1_cross_control_regional = flags.var1_cross_control_regional || Boolean(item.var1_cross_control_regional);
        flags.var1_cross_management_regional = flags.var1_cross_management_regional || Boolean(item.var1_cross_management_regional);
        flags.var2_cross_control_regional = flags.var2_cross_control_regional || Boolean(item.var2_cross_control_regional);
        flags.var2_cross_management_regional = flags.var2_cross_management_regional || Boolean(item.var2_cross_management_regional);
      });
      return flags;
    },

    handlePerformBulkTask(payload, action) {
      
      if (action === 'request') {
        if ((this.isapprover && this.workflows.islocalenabled) || (this.isregionalapprover && this.workflows.isregionalenabled)) {
          this.requestcommentarylocalcontrolvsProforma = false;
          this.requestcommentarylocalmanagementvsProforma = false;
          this.requestcommentaryregionalcontrolvsProforma = false;
          this.requestcommentaryregionalmanagementvsProforma = false;
          this.requestcommentarylocalcontrolvsForecast = false;
          this.requestcommentarylocalmanagementvsForecast = false;
          this.requestcommentaryregionalcontrolvsForecast = false;
          this.requestcommentaryregionalmanagementvsForecast = false;
          this.selectedcommentary = {};
          this.requestcommentarydialog = true;
        }
      } else if (action === 'addlocal') {
        if (this.ispreparer && this.workflows.islocalenabled) {
          // Reset all voluntary submission reason flags
          this.requestcommentarylocalcontrol = false;
          this.requestcommentarylocalmanagement = false;
          this.requestcommentaryregionalcontrol = false;
          this.requestcommentaryregionalmanagement = false;
          this.requestcommentarylocalcontrolvsProforma = false;
          this.requestcommentarylocalmanagementvsProforma = false;
          this.requestcommentaryregionalcontrolvsProforma = false;
          this.requestcommentaryregionalmanagementvsProforma = false;
          this.requestcommentarylocalcontrolvsForecast = false;
          this.requestcommentarylocalmanagementvsForecast = false;
          this.requestcommentaryregionalcontrolvsForecast = false;
          this.requestcommentaryregionalmanagementvsForecast = false;
          this.bulkcommentall = false;
          this.bulkcommentreplace = false;
          this.isGlMandatoryRequestFlag = false;
          this.replaceExistingCommentFlag = false;
          this.showVoluntaryReason = false;
          
          // Check if any selected items are immaterial (stage 3 or 4) with no flags
          let hasImmaterialWithoutFlags = false;
          let allItemsAreImmaterial = true; // Track if ALL selected items are immaterial
          for (let id of this.multiselectdata) {
            const item = this.resolveMultiselectCommentaryItem(id);
            if (item) {
              const stage = item.__stage !== undefined ? item.__stage : item.stage_local;
              const hasFlags = item.var1_cross_control || item.var1_cross_management ||
                               item.var2_cross_control || item.var2_cross_management;
              if ((stage === 3 || stage === 4) && !hasFlags) {
                hasImmaterialWithoutFlags = true;
              } else {
                // This item is NOT an immaterial item without flags
                allItemsAreImmaterial = false;
              }
            }
          }
          this.showVoluntaryReason = hasImmaterialWithoutFlags;
          
          // CRITICAL: For pure immaterial selections (no threshold flags),
          // we MUST set bulkcommentall = true because:
          // - Backend query uses $or with threshold flag conditions when all=false
          // - Immaterial items have no threshold flags, so they won't match
          // - Setting all=true bypasses this filter and includes all selected items
          if (allItemsAreImmaterial && hasImmaterialWithoutFlags) {
            this.bulkcommentall = true;
            console.log('[SLBreakup] All selected items are immaterial without flags - setting bulkcommentall=true');
          }
          
          // Initialize selectedcommentary with first item, but OR threshold flags across selection
          // so Mandatory/Optional matches any raised flag in the multi-select set.
          const aggregatedFlags = this.getAggregatedMultiselectThresholdFlags();
          if (this.multiselectdata.length > 0) {
            const firstItem = this.resolveMultiselectCommentaryItem(this.multiselectdata[0]);
            if (firstItem) {
              this.selectedcommentary = { 
                ...firstItem,
                ...aggregatedFlags,
                stage: firstItem.__stage !== undefined ? firstItem.__stage : firstItem.stage, // Ensure stage property exists for dialog check
                commentary1: '', 
                commentary2: '',
                regionalcommentary1: '',
                regionalcommentary2: ''
              };
            } else {
              this.selectedcommentary = { ...aggregatedFlags };
            }
          } else {
            this.selectedcommentary = {};
          }
          
          // Check for existing commentary in selected items
          for (let id of this.multiselectdata) {
            let glItem = this.resolveMultiselectCommentaryItem(id);
            if (glItem && ([3, 4].indexOf(glItem.__stage) > -1)) {
              this.isGlMandatoryRequestFlag = false;
            }
            if (glItem && ((glItem.commentary1 && String(glItem.commentary1).trim() !== '') || 
                (glItem.commentary2 && String(glItem.commentary2).trim() !== '') || 
                (glItem.regionalcommentary1 && String(glItem.regionalcommentary1).trim() !== '') || 
                (glItem.regionalcommentary2 && String(glItem.regionalcommentary2).trim() !== ''))) {
              this.replaceExistingCommentFlag = true;
            }
          }
          this.dialogCharttab = 0; // Reset dialog tabs
          this.commantorydialog = true;
        }
      } else if (action === 'approvelocal') {
        if (this.workflows.islocalenabled) {
          this.dialogCharttab = 0; // Reset dialog tabs
          this.commantorydialog = true;
          this.selectedcommentary = {};
        }
      } else if (action === 'addregional') {
        if (this.workflows.isregionalenabled) {
          this.requestcommentarylocalcontrolvsProforma = false;
          this.requestcommentarylocalmanagementvsProforma = false;
          this.requestcommentaryregionalcontrolvsProforma = false;
          this.requestcommentaryregionalmanagementvsProforma = false;
          this.requestcommentarylocalcontrolvsForecast = false;
          this.requestcommentarylocalmanagementvsForecast = false;
          this.requestcommentaryregionalcontrolvsForecast = false;
          this.requestcommentaryregionalmanagementvsForecast = false;
          this.bulkcommentall = false;
          this.bulkcommentreplace = false;
          const aggregatedFlags = this.getAggregatedMultiselectThresholdFlags();
          const firstItem = this.multiselectdata.length
            ? this.resolveMultiselectCommentaryItem(this.multiselectdata[0])
            : null;
          this.selectedcommentary = firstItem
            ? {
                ...firstItem,
                ...aggregatedFlags,
                commentary1: '',
                commentary2: '',
                regionalcommentary1: '',
                regionalcommentary2: '',
              }
            : { ...aggregatedFlags };
          this.dialogCharttab = 0; // Reset dialog tabs
          this.commantorydialog = true;
        }
      } else if (action === 'approveregional') {
        if (this.workflows.isregionalenabled) {
          this.dialogCharttab = 0; // Reset dialog tabs
          this.commantorydialog = true;
          this.selectedcommentary = {};
        }
      }
      
      this.bulksubmit = true;
      this.bulktype = action;
      this.commentarytype = action;
      this.commentarySubmitDialogueViewMode = false;
    },
    
    handlePreviewBulkCommentary() {
      this.$store.commit('sbInfo', `Submit Draft Commentary for ${this.multiselectdata.length} selected items`);
    },
    
    handleOpenSubmitDialog(payload) {
      const { row, mode, approver } = payload;
      console.log('Open submit dialog:', mode, 'Row:', row, 'Approver:', approver);
      
      this.bulksubmit = false;
      this.commentarytype = mode;
      this.selectedcommentary = this.prepareCommentaryForDialog(row);
      this.ensureReadableIdentifiers(this.selectedcommentary);
      // Trendline is hidden in SL commentary dialog (hideTrendLine=true); skip prefetch.
      this.commentarySubmitDialogueViewMode = (mode === 'view');
      this.dialogCharttab = 0; // Reset dialog tabs to main tab
      
      // Reset bulk commentary flags for single item submission
      this.bulkcommentall = false;
      this.bulkcommentreplace = false;
      this.showVoluntaryReason = false;
      
      if (mode === 'addregional' || mode === 'approveregional') {
        this.isLocalCommentaryCollapsed = true;
        this.isLocalCommentaryReasonCollapsed = true;
      } else {
        this.isLocalCommentaryCollapsed = false;
        this.isLocalCommentaryReasonCollapsed = false;
      }
      
      if (['view', 'addlocal', 'addregional', 'approvelocal', 'approveregional'].includes(mode)) {
        this.commentaryBaselinesReady = false;
        this.commantorydialog = true;
        this.$nextTick(() => {
          this.scheduleCommentaryBaselineCapture();
        });
      } else if (['requestlocal', 'requestregional'].includes(mode)) {
        // Open request commentary dialog
        this.requestcommentarylocalcontrolvsProforma = false;
        this.requestcommentarylocalmanagementvsProforma = false;
        this.requestcommentaryregionalcontrolvsProforma = false;
        this.requestcommentaryregionalmanagementvsProforma = false;
        this.requestcommentarylocalcontrolvsForecast = false;
        this.requestcommentarylocalmanagementvsForecast = false;
        this.requestcommentaryregionalcontrolvsForecast = false;
        this.requestcommentaryregionalmanagementvsForecast = false;
        this.requestcommentarydialog = true;
      }
    },
    
    // ===== Previous Cycle Methods =====
    getPreviousCycleList() {
      if (this.workflows.islocalenabled) {
        this.previouscyclelistdialog = true;
        this.previouscyclelistloading = true;
        this.previouscyclelist = [];
        const url = '/v2/varianceanalysis/sl_analysis/getpreviouscycle';
        // Build filter with optional reporting_type for Balance Sheet
        const prevCycleListFilter = { 
          cycletype: this.cycletype, 
          reportingunit: this.reportingunitId, 
          period: this.periodId,
          type: this.type,
          glcode: this.glcodeId
        };
        if (this.reportingType) {
          prevCycleListFilter.reporting_type = this.reportingType;
        }
        this.axios.post(url, { 
          data: [], 
          filter: prevCycleListFilter 
        }).then(dt => {
          if (dt.data.status === 'success') {
            this.previouscyclelist = dt.data.data || [];
          } else {
            throw new Error(dt.data.message || 'Error loading previous cycles');
          }
        }).catch(err => {
          this.$store.commit('sbError', err.message || err || 'Unknown error!');
          console.error(err);
        }).finally(() => {
          this.previouscyclelistloading = false;
        });
      }
    },
    
    getPreviousCycleData(id) {
      this.previouscycledatadialog = true;
      this.previouscycledataloading = true;
      this.previouscycledata = [];
      const url = '/v2/varianceanalysis/sl_analysis/getpreviouscycledata';
      // Build filter with optional reporting_type for Balance Sheet
      const prevCycleDataFilter = { 
        cycletype: this.cycletype, 
        cycle: id, 
        reportingunit: this.reportingunitId,
        type: this.type,
        glcode: this.glcodeId
      };
      if (this.reportingType) {
        prevCycleDataFilter.reporting_type = this.reportingType;
      }
      this.axios.post(url, { 
        data: [], 
        filter: prevCycleDataFilter 
      }).then(dt => {
        if (dt.data.status === 'success') {
          this.previouscyclemetadata = (dt.data.data[0] || {}).metadata || {};
          this.previouscycledata = (dt.data.data[0] || {}).data || [];
          this.previouscycledatatoupload = [];
          this.prevcommentaryselect = [];
          for (const i of this.previouscycledata) {
            if (this.commentarydatajson[i.glcode]) {
              let t = { ...(this.commentarydatajson[i.glcode] || {}) };
              t.commentary1 = i.commentary1 || '';
              t.commentary2 = i.commentary2 || '';
              t.glcode = i.glcode;
              if (!this.commentarydatajson[i.glcode].commentary1 && 
                  !this.commentarydatajson[i.glcode].commentary2 && 
                  !this.commentarydatajson[i.glcode].savedcommentary1 && 
                  !this.commentarydatajson[i.glcode].savedcommentary2 && 
                  this.commentarydatajson[i.glcode].stage_local === 0) {
                t.import = true;
              }
              if (t.import) this.prevcommentaryselect.push(i.glcode);
              this.previouscycledatatoupload.push(t);
            }
          }
        } else {
          throw new Error(dt.data.message || 'Error loading previous cycle data');
        }
      }).catch(err => {
        this.$store.commit('sbError', err.message || err || 'Unknown error ');
        console.error(err);
      }).finally(() => {
        this.previouscycledataloading = false;
      });
    },
    
    uploadPreviousCycleCommentary() {
      this.previouscycledataloading = true;
      const url = '/v2/varianceanalysis/sl_analysis/uploadpreviouscycledata';
      let ndt = [];
      for (const i of this.previouscycledatatoupload) {
        if (i.import && this.prevcommentaryselect.indexOf(i.glcode) > -1) {
          ndt.push({ glcode: i.glcode, commentary1: i.commentary1, commentary2: i.commentary2 });
        }
      }
      // Build filter with optional reporting_type for Balance Sheet
      const uploadPrevFilter = { 
        cycletype: this.cycletype, 
        period: this.periodId, 
        reportingunit: this.reportingunitId,
        type: this.type,
        glcode: this.glcodeId
      };
      if (this.reportingType) {
        uploadPrevFilter.reporting_type = this.reportingType;
      }
      this.axios.post(url, { 
        data: ndt, 
        filter: uploadPrevFilter 
      }).then(dt => {
        if (dt.data.status === 'success') {
          this.previouscycledatadialog = false;
          this.previouscyclelistdialog = false;
          this.$store.commit('sbSuccess', 'Commentary saved');
          this.loadSLData(true);
        } else {
          throw new Error(dt.data.message || 'Error adding previous cycle commentary');
        }
      }).catch(err => {
        this.$store.commit('sbError', err.message || err || 'Unknown error!');
        console.error(err);
      }).finally(() => {
        this.previouscycledataloading = false;
      });
    },
    
    requestCommentary() {
      let gls = [];
      let notInScopeGLs = [];
      if (this.bulksubmit) {
        gls = this.multiselectdata;
        gls.forEach((glid) => {
          let glItem = this.commentarydata.find((item) => item._id === glid);
          if ([9].indexOf(glItem?.__stage) > -1) {
            notInScopeGLs.push(glid);
          }
        });
      } else {
        if ([9].indexOf(this.selectedcommentary.__stage) > -1) {
          notInScopeGLs.push(this.selectedcommentary._id);
        }
        gls = [this.selectedcommentary._id];
      }
      
      this.requestcommentaryloading = true;
      let level = 'local';
      // Build filter with optional reporting_type for Balance Sheet
      let fltr = { 
        level: level, 
        cycletype: this.cycletype, 
        cycle: this.commentarycycledata._id, 
        gls: gls, 
        notinscopegls: notInScopeGLs, 
        type: this.type,
        glcode: this.glcodeId,
        crosscontrollocalthresholdvsproforma: this.requestcommentarylocalcontrolvsProforma, 
        crossmanagementlocalthresholdvsproforma: this.requestcommentarylocalmanagementvsProforma, 
        crosscontrollocalthresholdvsforecast: this.requestcommentarylocalcontrolvsForecast, 
        crossmanagementlocalthresholdvsforecast: this.requestcommentarylocalmanagementvsForecast 
      };
      if (this.reportingType) {
        fltr.reporting_type = this.reportingType;
      }
      
      if (this.isregionalapprover) {
        level = 'regional';
        fltr.level = level;
        fltr.crosscontrolregionalthresholdvsproforma = this.requestcommentaryregionalcontrolvsProforma;
        fltr.crosscontrolregionalthresholdvsforecast = this.requestcommentaryregionalcontrolvsForecast;
        fltr.crossmanagementregionalthresholdvsproforma = this.requestcommentaryregionalmanagementvsProforma;
        fltr.crossmanagementregionalthresholdvsforecast = this.requestcommentaryregionalmanagementvsForecast;
      }
      
      if ((level === 'local' &&
          !(fltr.crosscontrollocalthresholdvsforecast ||
            fltr.crosscontrollocalthresholdvsproforma ||
            fltr.crossmanagementlocalthresholdvsproforma ||
            fltr.crossmanagementlocalthresholdvsforecast)) ||
        (level === 'regional' &&
          !(fltr.crosscontrolregionalthresholdvsproforma ||
            fltr.crosscontrolregionalthresholdvsforecast ||
            fltr.crossmanagementregionalthresholdvsproforma ||
            fltr.crossmanagementregionalthresholdvsforecast))) {
        this.$store.commit('sbError', 'Reason for request for commentary is mandatory');
        this.requestcommentaryloading = false;
      } else {
        const url = '/v2/varianceanalysis/sl_analysis/requestcommentary';
        this.axios.post(url, { filter: fltr }).then(dt => {
          if (dt.data.status === 'success') {
            this.$store.commit('sbSuccess', "Request Success. Commentary will be requested only for GL's are in 'Approved', 'Immaterial Variance', 'Not In Scope' and 'Nil Value'.");
            this.requestcommentarydialog = false;
            this.loadSLData(true);
            // Also refresh GL-level details (getgldetails) in the parent view
            this.$emit('refresh-gl-details');
          } else {
            throw new Error(dt.data.message || 'Error requesting commentary');
          }
        }).catch(err => {
          this.$store.commit('sbError', err.message || err || 'Unknown error!');
          console.error(err);
        }).finally(() => {
          this.requestcommentaryloading = false;
        });
      }
    },
    
    saveCustomFilter() {
      localStorage.setItem('commentary_custom_filter', this.customfilter.join(','));
      if (this.customfilter.length > 0) {
        this.customfilterstoggle = true;
      } else {
        this.customfilterstoggle = false;
      }
      localStorage.setItem('commentary_custom_filter_toggle', this.customfilterstoggle);
      this.customfiltersdialog = false;
    },
    
 
    
    // ===== Bulk Upload Dialog Methods =====
    downloadExcel() {
      this.$store.commit('sbInfo', 'Downloading Excel');
      this.downloadBulkTemplate();
    },
    
    downloadPdf() {
      if (!this.commentarycycledata?._id) {
        this.$store.commit('sbError', 'No cycle data available for PDF download');
        return;
      }
      // Open the PDF download dialog
      this.getpdfFun();
    },
    
    pdfdownloadRUcycleGenerate() {
      this.rucyclepdfdownloadloading = true;
      const url = `/v2/varianceanalysis/sl_analysis/downloadpdf/${this.commentarycycledata._id}/c/${this.$store.state.client}/g/${this.glcodeId}`;
      
      this.axios.post(url, { filter: { reporting_type: this.reportingType, cycletype: this.cycletype } }).then(dt => {
        if (dt.data.status === 'success') {
          this.getpdfFun();
          const download_data = dt.data.data[0] || {};
          if (download_data.upload) {
            this.$nova.downloadFile(undefined, {}, `/v2/varianceanalysis/sl_analysis/download/${download_data._id}`);
          }
        } else {
          throw new Error(dt.data.message || 'Error generating PDF download');
        }
      }).catch(err => {
        this.$store.commit('sbError', err.message || err || 'Unknown error!');
        console.log(err);
      }).finally(() => {
        this.rucyclepdfdownloadloading = false;
      });
    },
    
    getpdfFun() {
      this.rucyclepdfdownloadloading = true;
      this.rucyclepdfdownloaddialog = true;
      const url = '/v2/varianceanalysis/sl_analysis/downloadsinglerupdfllist';
      
      this.axios.post(url, { filter: { type: 'singleru_pdf_sl', cycle: this.commentarycycledata._id, glcode: this.glcodeId } }).then(dt => {
        if (dt.data.status === 'success') {
          this.rucyclepdfdownloadlist = dt.data.data;
        } else {
          throw new Error(dt.data.message || 'Error loading download list');
        }
      }).catch(err => {
        this.$store.commit('sbError', err.message || err || 'Unknown error!');
        console.log(err);
      }).finally(() => {
        this.rucyclepdfdownloadloading = false;
      });
    },
    
    downloadRUPdfFile(downloadId) {
      if (!downloadId) return;
      this.$nova.downloadFile(
        undefined,
        {},
        `/v2/varianceanalysis/sl_analysis/download/${downloadId}`,
        '&timestamp=' + new Date().getTime()
      );
    },

    initializeBulkSubmitColumns() {
      const normalizedCycleType = this.normalizeCycleType(this.cycletype);
      const cycleType = normalizedCycleType === 'Forecast' ? 'Forecast' : 'Actual';
      const labelsPage = 'reporting_units_bulk_file';
      const isBS = this.reportingType === 'bs';
      this.bulksubmitcolumns = [...SL_BULK_SUBMIT_COLUMNS[cycleType]].map((label) => {
        if (isBS) {
          if (label === 'Actual Amount') {
            const l = this.$nova.labelsName('cycle_page', 'actual_label_balancesheet', 'Actual');
            return l.endsWith('Amount') ? l : l + ' Amount';
          }
          if (label === 'Proforma Amount') {
            const l = this.$nova.labelsName('cycle_page', 'proforma_shortform_label_balancesheet', 'Proforma');
            return l.endsWith('Amount') ? l : l + ' Amount';
          }
          if (label === 'Forecast Amount' || label === 'Previous Forecast Amount') {
            const prefix = label.startsWith('Previous') ? 'Previous ' : '';
            const l = this.$nova.labelsName('cycle_page', 'forecast_shortform_label_balancesheet', 'Forecast');
            const base = l.endsWith('Amount') ? l : l + ' Amount';
            return prefix + base;
          }
        }
        return this.$nova.identifyAndRemapLabelName(labelsPage, label);
      });
      return this.bulksubmitcolumns;
    },
    
    downloadBulkTemplate() {
      // Use styledxlsx to create and download bulk upload template - matching helpers.js downloadExcel
      return Promise.resolve().then(() => {
        this.bulksubmitloading = true;
        return this.loadSLData(true);
      }).then(() => {
        const styledxlsx = require('sheetjs-style');
        const workbook = styledxlsx.utils.book_new();
        const primarycolor = 'd8e8f0';
        const heading1 = 'bfffbf';
        const heading2 = 'E8EEFF';
        const heading3 = 'F2E1F5';
        const body1 = 'E3FFE3';
        const body2 = 'E8EEFF';
        const body3 = 'F2E1F5';
        const scolor = '078f0e';
        const ecolor = 'd11b1b';
        const runame = this.commentaryrudata?.code || 'Report';
        
        // Get period and year info from cycle data or SLData passed from Base.vue
        const periodName = this.commentarycycledata?.period_detail?.name || 
                          this.selectedCommentaryCycle?.period_detail?.name || 
                          this.SLData?.periodName ||
                          '';
        const yearName = this.commentarycycledata?.year_detail?.name || 
                        this.selectedCommentaryCycle?.year_detail?.name || 
                        this.SLData?.yearName ||
                        this.commentarycycledata?.year || 
                        this.selectedCommentaryCycle?.year || 
                        '';
        // Build subtitle with period, year and reporting type info
        const reportingTypeLabel = this.reportingType === 'bs' ? 'Balance Sheet' : 'Profit & Loss';
        let subtitle = this.cycletype;
        if (periodName) subtitle += ` - ${periodName}`;
        subtitle += ` - ${reportingTypeLabel}`;
        
        // Use bulksubmitcolumns - remove last 2 columns for the template (Local Approve & Submit columns)
        // This matches helpers.js downloadExcel which uses columns 0-26 (27 columns after splice)
        const initializedColumns = this.initializeBulkSubmitColumns();
        let excelColumns = [...initializedColumns];
        excelColumns.splice(-2, 2);
        const dt = [
          [''],
          ['', { v: this.commentaryrudata?.name || '', s: { font: { bold: true, sz: 20 } } }],
          ['', { v: subtitle, s: { font: { bold: true, sz: 14 } } }],
          [''],
          [
            '',
            { v: excelColumns[0], s: { font: { bold: true }, fill: { fgColor: { rgb: primarycolor } } } },
            { v: excelColumns[1], s: { font: { bold: true }, fill: { fgColor: { rgb: primarycolor } } } },
            { v: excelColumns[2], s: { font: { bold: true }, fill: { fgColor: { rgb: primarycolor } } } },
            { v: excelColumns[3], s: { font: { bold: true }, fill: { fgColor: { rgb: heading1 } } } },
            { v: excelColumns[4], s: { font: { bold: true }, fill: { fgColor: { rgb: heading2 } } } },
            { v: excelColumns[5], s: { font: { bold: true }, fill: { fgColor: { rgb: heading2 } } } },
            { v: excelColumns[6], s: { font: { bold: true }, fill: { fgColor: { rgb: heading2 } } } },
            { v: excelColumns[7], s: { font: { bold: true }, fill: { fgColor: { rgb: heading2 } } } },
            { v: excelColumns[8], s: { font: { bold: true }, fill: { fgColor: { rgb: heading2 } } } },
            { v: excelColumns[9], s: { font: { bold: true }, fill: { fgColor: { rgb: heading2 } } } },
            { v: excelColumns[10], s: { font: { bold: true }, fill: { fgColor: { rgb: heading2 } } } },
            { v: excelColumns[11], s: { font: { bold: true }, fill: { fgColor: { rgb: heading2 } } } },
            { v: excelColumns[12], s: { font: { bold: true }, fill: { fgColor: { rgb: heading3 } } } },
            { v: excelColumns[13], s: { font: { bold: true }, fill: { fgColor: { rgb: heading3 } } } },
            { v: excelColumns[14], s: { font: { bold: true }, fill: { fgColor: { rgb: heading3 } } } },
            { v: excelColumns[15], s: { font: { bold: true }, fill: { fgColor: { rgb: heading3 } } } },
            { v: excelColumns[16], s: { font: { bold: true }, fill: { fgColor: { rgb: heading3 } } } },
            { v: excelColumns[17], s: { font: { bold: true }, fill: { fgColor: { rgb: heading3 } } } },
            { v: excelColumns[18], s: { font: { bold: true }, fill: { fgColor: { rgb: heading3 } } } },
            { v: excelColumns[19], s: { font: { bold: true }, fill: { fgColor: { rgb: heading3 } } } },
            { v: excelColumns[20], s: { font: { bold: true }, fill: { fgColor: { rgb: heading3 } } } },
            { v: excelColumns[21], s: { font: { bold: true }, fill: { fgColor: { rgb: primarycolor } } } },
            { v: excelColumns[22], s: { font: { bold: true }, fill: { fgColor: { rgb: primarycolor } } } },
            { v: excelColumns[23], s: { font: { bold: true }, fill: { fgColor: { rgb: primarycolor } } } },
            { v: excelColumns[24], s: { font: { bold: true }, fill: { fgColor: { rgb: primarycolor } } } },
            { v: excelColumns[25], s: { font: { bold: true }, fill: { fgColor: { rgb: primarycolor } } } },
            { v: excelColumns[26], s: { font: { bold: true }, fill: { fgColor: { rgb: primarycolor } } } }
          ]
        ];
        
        // Add data rows - matching helpers.js downloadExcel format
        for (const v of this.commentarydata) {
          if (v.cycle) {
            // Compute status values for Local and Regional
            const stageLocal = (v.stage_local === -1) ? 'No' : ((v.stage_local === 2) ? 'Yes' : '');
            const localApproveReason = (v.stage_local === -1) ? (v.rejectreason || '') : ((v.stage_local === 2) ? (v.approvereason || '') : '');
            const stageRegional = (v.stage_regional === -1) ? 'No' : ((v.stage_regional === 2) ? 'Yes' : '');
            const regionalApproveReason = (v.stage_regional === -1) ? (v.regionalrejectreason || '') : ((v.stage_regional === 2) ? (v.regionalapprovereason || '') : '');
            
            dt.push([
              '',
              v.glcode_detail?.code,
              v.glcode_detail?.name,
              { v: this.$nova.formatCurrency((v.amount1 || 0).toFixed(1), '', false, true), s: { fill: { fgColor: { rgb: body1 } } } },
              { v: this.$nova.formatCurrency((v.amount2 || 0).toFixed(1), '', false, true), s: { fill: { fgColor: { rgb: body2 } } } },
              { v: this.$nova.formatCurrency((v.varianceamount1 || 0).toFixed(1), '', false, true), s: { font: { color: { rgb: ((v.varianceamount1 || 0) > 0) ? scolor : ecolor } }, fill: { fgColor: { rgb: body2 } } } },
              { v: this.$nova.formatCurrency(((v.variancepercent1 || 0)).toFixed(1), '', false, true) + (((v.variancepercent1 || 0) !== 0) ? '%' : ''), s: { font: { color: { rgb: ((v.varianceamount1 || 0) > 0) ? scolor : ecolor } }, fill: { fgColor: { rgb: body2 } } } },
              { v: v.var1_cross_control ? 'Yes' : 'No', s: { fill: { fgColor: { rgb: body2 } } } },
              { v: v.var1_cross_management ? 'Yes' : 'No', s: { fill: { fgColor: { rgb: body2 } } } },
              { v: v.var1_cross_control_regional ? 'Yes' : 'No', s: { fill: { fgColor: { rgb: body2 } } } },
              { v: v.var1_cross_management_regional ? 'Yes' : 'No', s: { fill: { fgColor: { rgb: body2 } } } },
              { v: v.commentary1 || '', s: { fill: { fgColor: { rgb: body2 } } } },
              { v: v.regionalcommentary1 || '', s: { fill: { fgColor: { rgb: body2 } } } },
              { v: this.$nova.formatCurrency((v.amount3 || 0).toFixed(1), '', false, true), s: { fill: { fgColor: { rgb: body3 } } } },
              { v: this.$nova.formatCurrency((v.varianceamount2 || 0).toFixed(1), '', false, true), s: { font: { color: { rgb: ((v.varianceamount2 || 0) > 0) ? scolor : ecolor } }, fill: { fgColor: { rgb: body3 } } } },
              { v: this.$nova.formatCurrency(((v.variancepercent2 || 0)).toFixed(1), '', false, true) + (((v.variancepercent2 || 0) !== 0) ? '%' : ''), s: { font: { color: { rgb: ((v.varianceamount2 || 0) > 0) ? scolor : ecolor } }, fill: { fgColor: { rgb: body3 } } } },
              { v: v.var2_cross_control ? 'Yes' : 'No', s: { fill: { fgColor: { rgb: body3 } } } },
              { v: v.var2_cross_management ? 'Yes' : 'No', s: { fill: { fgColor: { rgb: body3 } } } },
              { v: v.var2_cross_control_regional ? 'Yes' : 'No', s: { fill: { fgColor: { rgb: body3 } } } },
              { v: v.var2_cross_management_regional ? 'Yes' : 'No', s: { fill: { fgColor: { rgb: body3 } } } },
              { v: v.commentary2 || '', s: { fill: { fgColor: { rgb: body3 } } } },
              { v: v.regionalcommentary2 || '', s: { fill: { fgColor: { rgb: body3 } } } },
              this.getStageText(v.stage_local),
              this.getStageText(v.stage_regional),
              { v: stageLocal, s: { fill: { fgColor: { rgb: primarycolor } } } },
              { v: localApproveReason, s: { fill: { fgColor: { rgb: primarycolor } } } },
              { v: stageRegional, s: { fill: { fgColor: { rgb: primarycolor } } } },
              { v: regionalApproveReason, s: { fill: { fgColor: { rgb: primarycolor } } } }
            ]);
          }
        }
        
        const worksheet = styledxlsx.utils.aoa_to_sheet(dt);
        styledxlsx.utils.book_append_sheet(workbook, worksheet, 'TOP SHEET');
        
        // Build filename with GL name, period, and year
        const glName = this.selectedGLCommentary?.glcode_detail?.name || 
                       this.selectedGLCommentary?.description || 
                       this.SLData?.glName || '';
        const glCode = this.selectedGLCommentary?.glcode_detail?.code || 
                       this.selectedGLCommentary?.glcode || '';
        const glPart = glCode ? `_${glCode}` : (glName ? `_${glName.replace(/[^a-zA-Z0-9]/g, '_')}` : '');
        const periodPart = periodName ? `_${periodName.replace(/[^a-zA-Z0-9]/g, '_')}` : '';
        const yearPart = yearName ? `_${yearName}` : '';
        const filename = `${runame}${glPart}${periodPart}${yearPart}_SL_Breakup.xlsx`;
        
        styledxlsx.writeFile(workbook, filename);
      }).catch(err => {
        this.$store.commit('sbError', err.message || err || 'Unknown error!');
        console.error(err);
      }).finally(() => {
        this.bulksubmitloading = false;
      });
    },
    
    downloadBulkApproveTemplate() {
      // Download bulk approve template - uses same format as downloadBulkTemplate
      this.downloadBulkTemplate();
    },
    
    readBulkSubmit() {
    let file = this.bulksubmitfiledatafile;
    this.bulksubmitfiledataList = [];
    if ((file || {}).name && !this.bulksubmitloading) {
      this.bulksubmitfiledataerror = false;
      this.bulksubmitloading = true;
      let commentary1Index = 11;
      let commentary2Index = 20;
      let ext = ((file || {}).name || "").split(".").pop();
      Promise.resolve().then(() => {
        if (["xlsx", "xls", "xlsm", "xlsb"].indexOf(ext) === -1) throw new Error("Only xlsx,xls,xlsm,xlsb file extension supported");
        return this.$nova.readExcelFile(file, "TOP SHEET");
      }).then(dt => {
        let excelColumns = [...this.bulksubmitcolumns];
        excelColumns.splice(-2, 2);
        if (JSON.stringify(dt[4] || []) === JSON.stringify(["", ...excelColumns])) {
          let gllist = [];
          let uploaddata = {};
          let finaldata = {};
          let haserror = false;
          for (let i = 4; i < dt.length; i++) {
            if (i > 4) {
              const el = dt[i];
              let glcode = (el[1] || "").toString();
              let ndt = el;
              gllist.push(glcode);
              uploaddata[glcode] = ndt;
            }
          }
          for (let i = 0; i < this.commentarydata.length; i++) {
            const el = this.commentarydata[i];
            let glcode = (el.glcode || "").toString();
            let code = (el.glcode_detail?.code || "").toString();
            if (gllist.indexOf(code) > -1) {
              // Determine if threshold flags should be shown based on role and stage
              // Local Preparer: show flags only when stage_local === 4 or 3
              // Local Approver / Regional Preparer: show flags only when stage_regional === 4 or 3
              const showThresholdFlags = this.ispreparer 
                ? (el.stage_local === 4 || el.stage_local === 3) 
                : (this.isapprover && (el.stage_regional === 4 || el.stage_regional === 3));
              // Get threshold values from Excel upload (uploaddata) at indices 7, 8, 16, 17
              // If Excel data is different from DB, use the Excel (latest) values
              const excelCrossControlProforma = uploaddata[code][7]; // Index 7: Cross Control vs Proforma
              const excelCrossManagementProforma = uploaddata[code][8]; // Index 8: Cross Management vs Proforma
              const excelCrossControlForecast = uploaddata[code][16]; // Index 16: Cross Control vs Forecast
              const excelCrossManagementForecast = uploaddata[code][17]; // Index 17: Cross Management vs Forecast
              
              // Convert DB values to Yes/No for comparison
              const dbCrossControlProforma = el.var1_cross_control ? 'Yes' : 'No';
              const dbCrossManagementProforma = el.var1_cross_management ? 'Yes' : 'No';
              const dbCrossControlForecast = el.var2_cross_control ? 'Yes' : 'No';
              const dbCrossManagementForecast = el.var2_cross_management ? 'Yes' : 'No';
              
              // Check if Excel values are different from DB values
              const isControlProformaChanged = excelCrossControlProforma && excelCrossControlProforma !== dbCrossControlProforma;
              const isManagementProformaChanged = excelCrossManagementProforma && excelCrossManagementProforma !== dbCrossManagementProforma;
              const isControlForecastChanged = excelCrossControlForecast && excelCrossControlForecast !== dbCrossControlForecast;
              const isManagementForecastChanged = excelCrossManagementForecast && excelCrossManagementForecast !== dbCrossManagementForecast;
              
              // Use Excel values if different from DB, otherwise use DB values
              const finalCrossControlProforma = isControlProformaChanged ? excelCrossControlProforma : dbCrossControlProforma;
              const finalCrossManagementProforma = isManagementProformaChanged ? excelCrossManagementProforma : dbCrossManagementProforma;
              const finalCrossControlForecast = isControlForecastChanged ? excelCrossControlForecast : dbCrossControlForecast;
              const finalCrossManagementForecast = isManagementForecastChanged ? excelCrossManagementForecast : dbCrossManagementForecast;
              
              // Check if any threshold value was changed in Excel
              const hasThresholdChangedFromExcel = isControlProformaChanged || isManagementProformaChanged || isControlForecastChanged || isManagementForecastChanged;
              
              finaldata[code] = {
                _id : el._id,
                code: code,
                glcode: glcode,
                name: el.glcode_detail?.name,
                actual_amount: this.$nova.formatCurrency((el.amount1 || 0).toFixed(1), '', false, true),
                proforma_amount: this.$nova.formatCurrency((el.amount2 || 0).toFixed(1), '', false, true),
                variance_amount1: this.$nova.formatCurrency((el.varianceamount1 || 0).toFixed(1), '', false, true),
                variance_percent1: this.formatPercent(el.variancepercent1 || 0),
                forecast_amount: this.$nova.formatCurrency((el.amount3 || 0).toFixed(1), '', false, true),
                variance_amount2: this.$nova.formatCurrency((el.varianceamount2 || 0).toFixed(1), '', false, true),
                variance_percent2: this.formatPercent(el.variancepercent2 || 0),
                // Threshold cross values - use Excel values if different from DB, otherwise DB values
                // Only show when applicable stage based on role
                crosscontrolthresholdvsproforma: showThresholdFlags && isControlProformaChanged ? finalCrossControlProforma : '-',
                crossmanagementthresholdvsproforma: showThresholdFlags && isManagementProformaChanged ? finalCrossManagementProforma : '-',
                crosscontrolthresholdvsforecast: showThresholdFlags && isControlForecastChanged ? finalCrossControlForecast : '-',
                crossmanagementthresholdvsforecast: showThresholdFlags && isManagementForecastChanged ? finalCrossManagementForecast : '-',
                // Store showThresholdFlags to determine isBulk for upload
                showThresholdFlags: showThresholdFlags,
                ignore: false,
                message: '',
                __found: true
              };
              // Match helpers.js: Only set if different from DB AND not null/undefined
              if (el.commentary1 !== uploaddata[code][commentary1Index] && uploaddata[code][commentary1Index] !== "null" && uploaddata[code][commentary1Index] !== "undefined") {
                finaldata[code].commentary1 = uploaddata[code][commentary1Index];
              }
              if (el.commentary2 !== uploaddata[code][commentary2Index] && uploaddata[code][commentary2Index] !== "null" && uploaddata[code][commentary2Index] !== "undefined") {

                finaldata[code].commentary2 = uploaddata[code][commentary2Index];
              }
              finaldata[code].ignore = false;
              finaldata[code].message = "";
              let isValid = true;
              let isCommentary1Required = false;
              let isCommentary2Required = false;
              if (!(this.workflows.lcp || this.workflows.lmp)) {
                delete finaldata[code].commentary1
              }
              if (!(this.workflows.lcf || this.workflows.lmf)) {
                delete finaldata[code].commentary2
              }
              
              // Commentary validation logic:
              // 1. If showThresholdFlags is true AND Excel values changed from DB, validate based on new Excel threshold values
              // 2. Otherwise, follow usual validation based on DB threshold values
              
              // Commentary1 validation
              if (this.ispreparer && (this.workflows.lcp || this.workflows.lmp)) {
                let requiresCommentary1 = false;
                
                if (showThresholdFlags && hasThresholdChangedFromExcel) {
                  // Validate based on changed Excel threshold values for proforma
                  const excelRequiresCommentary1 = (finalCrossControlProforma === 'Yes' || finalCrossManagementProforma === 'Yes');
                  requiresCommentary1 = excelRequiresCommentary1;
                } else {
                  // Follow usual validation based on DB threshold values
                  requiresCommentary1 = (el.var1_cross_control || el.var1_cross_management || el.var1_cross_control_regional || el.var1_cross_management_regional);
                }
                
                if (requiresCommentary1) {
                  if (!finaldata[code].commentary1) {
                    finaldata[code].message = "Commentary1 required.";
                    isCommentary1Required = true;
                    finaldata[code].ignore = true;
                  }
                  else if (String(finaldata[code].commentary1).trim().length < 15) {
                    isCommentary1Required = true
                    finaldata[code].message = "Commentary1 minimum 15 characters required.";
                    finaldata[code].ignore = true;
                  }
                }
              }
              
              // Commentary2 validation
              if (this.ispreparer && (this.workflows.lcf || this.workflows.lmf)) {
                let requiresCommentary2 = false;
                
                if (showThresholdFlags && hasThresholdChangedFromExcel) {
                  // Validate based on changed Excel threshold values for forecast
                  const excelRequiresCommentary2 = (finalCrossControlForecast === 'Yes' || finalCrossManagementForecast === 'Yes');
                  requiresCommentary2 = excelRequiresCommentary2;
                } else {
                  // Follow usual validation based on DB threshold values
                  requiresCommentary2 = (el.var2_cross_control || el.var2_cross_management);
                }
                
                if (requiresCommentary2) {
                  if (!finaldata[code].commentary2) {
                    finaldata[code].message += "Commentary2 required.";
                    finaldata[code].ignore = true;
                    isCommentary2Required = true
                  } else if (String(finaldata[code].commentary2).trim().length < 15) {
                    finaldata[code].message += "Commentary2 minimum 15 characters required.";
                    finaldata[code].ignore = true;
                    isCommentary2Required = true
                  }
                }
              } else if (this.isapprover && (this.workflows.rcf || this.workflows.rmf) && (el.var2_cross_control_regional || el.var2_cross_management_regional)) {
                if (!finaldata[code].commentary2) {
                  finaldata[code].message += "Commentary2 required.";
                  finaldata[code].ignore = true;
                  isCommentary2Required = true
                } else if (String(finaldata[code].commentary2).trim().length < 15) {
                  finaldata[code].message += "Commentary2 minimum 15 characters required.";
                  finaldata[code].ignore = true;
                  isCommentary2Required = true
                }
              }
              
              if (!isCommentary1Required && !isCommentary2Required ) {
                finaldata[code].ignore = false;
                finaldata[code].message = "Ready to upload";
              }
              if (el.stage_local === 2) {
                finaldata[code].ignore = true;
                finaldata[code].message = "Ignored because local approve completed";
              } else if (el.stage_local === 3 && !(showThresholdFlags && hasThresholdChangedFromExcel)) {
                finaldata[code].ignore = true;
                finaldata[code].message = "Ignored because no variance detected";
                isValid = true;
              } else if (el.stage_local === 4 && !(showThresholdFlags && hasThresholdChangedFromExcel)) {
                finaldata[code].ignore = true;
                finaldata[code].message = "Ignored because no variance is immaterial";
                isValid = true;
              } else if (el.__stage === 9 || el.stage_local === 5) {
                finaldata[code].ignore = true;
                finaldata[code].message = "Ignored because not in scope";
                isValid = false;
              } else if (el.__stage === 1 && finaldata[code].ignore === true) {
                finaldata[code].message = "Ignored because commentary already submitted";
              }
              finaldata[code].code = code;
              finaldata[code].glcode = glcode;
              finaldata[code].name = el.glcode_detail?.name;
              if (!code) {
                haserror = true;
                finaldata[code].error = "GL Code not found";
              } else {
                finaldata[code].__found = true;
              }
              if (!isValid) delete finaldata[code];
              // uploaddata[glcode].__found = true;
              // uploaddata[glcode].error = ""
              // uploaddata[glcode].commentary1 = el.commentary1;
              // uploaddata[glcode].commentary2 = el.commentary2;
              // if(el.var1_cross_control || el.var1_cross_management){
              //   if(!uploaddata[glcode].data[1]){
              //     uploaddata[glcode].error = "Commentary 1 is required";
              //     haserror = true;
              //   }
              // }else if(uploaddata[glcode].data[1]) {
              //   uploaddata[glcode].error = "Commentary 1 cannot be added as the variance doesn't cross the threshold limit";
              //   haserror = true;
              // }
              // if(el.var2_cross_control || el.var2_cross_management){
              //   if(!uploaddata[glcode].data[2]){
              //     if(uploaddata[glcode].error !== "") uploaddata[glcode].error = uploaddata[glcode].error + ", ";
              //     uploaddata[glcode].error = uploaddata[glcode].error + "Commentary 2 is required";
              //     haserror = true;
              //   }
              // }else if(uploaddata[glcode].data[2]) {
              //   if(uploaddata[glcode].error !== "") uploaddata[glcode].error = uploaddata[glcode].error + ", ";
              //   uploaddata[glcode].error = uploaddata[glcode].error + "Commentary 2 cannot be added as the variance doesn't cross the threshold limit";
              //   haserror = true;
              // }
            }
          }
          // for (const k in uploaddata) {
          //     if (Object.hasOwnProperty.call(uploaddata, k)) {
          //       const el = uploaddata[k];
          //       if(el.__found === false) haserror = true;
          //     }
          //   }
          this.bulksubmitfiledataerror = haserror;
          this.bulksubmitfiledata = finaldata;
          Object.keys(finaldata).forEach((key) => {
            this.bulksubmitfiledataList.push(finaldata[key]);
          })
        } else throw new Error("Columns 'GL Code','Commentary 1','Commentary 2' are required in the same order");
      }).catch(err => {
        this.$store.commit("sbError", err.message || err || "Unknown error!");
        console.log(err);
      }).finally(() => {
        this.bulksubmitfiledatafile = null;
        this.bulksubmitloading = false;
      });
    }
  },
  readBulkSubmitisApprover() {
    const file = this.approverBulkSubmitDataFile;
    this.approverBulkSubmitFileDataListis = [];

    if (!(file && file.name) || this.approverBulkSubmitLoading) return;

    this.bulksubmitfiledataerrorisApprover = false;
    this.approverBulkSubmitLoading = true;
    
    // Column indices for approver template (27 columns after splice, matching helpers.js):
    // 1: Client Code, 2: Description, 3: Actual Amount, 4: Proforma Amount, 
    // 5: Variance Amt(Act vs Pro), 6: Variance %(Act vs Pro),
    // 7: Cross Local Ctrl, 8: Cross Local Mngt, 9: Cross Regional Ctrl, 10: Cross Regional Mngt,
    // 11: Local Act vs Pro Commentary, 12: Regional Act vs Pro Commentary,
    // 13: Forecast Amount, 14: Variance Amt(Act vs For), 15: Variance %(Act vs For),
    // 16: Cross Local Ctrl, 17: Cross Local Mngt, 18: Cross Regional Ctrl, 19: Cross Regional Mngt,
    // 20: Local Act vs For Commentary, 21: Regional Act vs For Commentary,
    // 22: Status Local, 23: Status Regional,
    // 24: Local Approve/Reject (Yes/No), 25: Local Approve/Reject Reason,
    // 26: Regional Approve/Reject (Yes/No), 27: Regional Approve/Reject Reason
    const regionalCommentary1Index = 12; // Regional Act vs Pro Commentary
    const regionalCommentary2Index = 21; // Regional Act vs For Commentary
    
    const ext = (file.name || "").split(".").pop();

    const isValidExtension = ["xlsx", "xls", "xlsm", "xlsb"].includes(ext);
    if (!isValidExtension) {
      this.$store.commit("sbError", "Only xlsx,xls,xlsm,xlsb file extension supported");
      this.approverBulkSubmitLoading = false;
      return;
    }

    this.$nova.readExcelFile(file, "TOP SHEET")
      .then(dt => {
        // Validate column structure.
        // The current approver download template omits the last 2 columns
        // (Local Approve & Submit columns), but we tolerate both variants.
        const normalizeCell = (cell) => {
          if (cell === null || cell === undefined) return '';
          if (typeof cell === 'string') return cell.trim();
          return cell;
        };
        const trimTrailingEmpties = (arr) => {
          const out = (arr || []).map(normalizeCell);
          while (out.length && (out[out.length - 1] === '' || out[out.length - 1] === undefined)) {
            out.pop();
          }
          return out;
        };

        const excelHeaderRow = trimTrailingEmpties(dt[4] || []);
        const expectedHeaderRowFull = trimTrailingEmpties(["", ...this.bulksubmitcolumns]);
        const expectedHeaderRowWithoutApproveSubmit = trimTrailingEmpties([
          "",
          ...this.bulksubmitcolumns.slice(0, Math.max(0, this.bulksubmitcolumns.length - 2)),
        ]);

        const matchesFull = JSON.stringify(excelHeaderRow) === JSON.stringify(expectedHeaderRowFull);
        const matchesWithoutApproveSubmit =
          JSON.stringify(excelHeaderRow) === JSON.stringify(expectedHeaderRowWithoutApproveSubmit);

        if (!matchesFull && !matchesWithoutApproveSubmit) {
          throw new Error("Columns structure mismatch. Please use the correct template.");
        }

        const gllist = [];
        const uploaddata = {};
        const finaldata = {};

        // Build GL list and upload data map
        for (let i = 5; i < dt.length; i++) {
          const el = dt[i];
          const glcode = (el[1] || "").toString();
          gllist.push(glcode);
          uploaddata[glcode] = el;
        }

        // Helper for commentary validation
        const isCommentaryValid = c => c && typeof c === "string" && c.trim().length >= 15;

        // Process commentary data
        for (const el of this.commentarydata) {
          const glcode = (el.glcode || "").toString();
          const code = (el.glcode_detail?.code || "").toString();

          if (!gllist.includes(code)) continue;

          const uploadRow = uploaddata[code];          
          // Determine if threshold flags should be shown based on role and stage
          // Approver: show flags only when stage_regional === 4 or 3
          const showThresholdFlags = this.isapprover && (el.stage_regional === 4 || el.stage_regional === 3);
          
          // Get threshold values from Excel upload at correct indices
          // Local threshold indices: 7, 8 for proforma; 16, 17 for forecast
          // Regional threshold indices: 9, 10 for proforma; 18, 19 for forecast
          const excelCrossLocalCtrlProforma = uploadRow[7];
          const excelCrossLocalMngtProforma = uploadRow[8];
          const excelCrossRegionalCtrlProforma = uploadRow[9];
          const excelCrossRegionalMngtProforma = uploadRow[10];
          const excelCrossLocalCtrlForecast = uploadRow[16];
          const excelCrossLocalMngtForecast = uploadRow[17];
          const excelCrossRegionalCtrlForecast = uploadRow[18];
          const excelCrossRegionalMngtForecast = uploadRow[19];
          
          // Convert DB values to Yes/No for comparison
          const dbCrossLocalCtrlProforma = el.var1_cross_control ? 'Yes' : 'No';
          const dbCrossLocalMngtProforma = el.var1_cross_management ? 'Yes' : 'No';
          const dbCrossRegionalCtrlProforma = el.var1_cross_control_regional ? 'Yes' : 'No';
          const dbCrossRegionalMngtProforma = el.var1_cross_management_regional ? 'Yes' : 'No';
          const dbCrossLocalCtrlForecast = el.var2_cross_control ? 'Yes' : 'No';
          const dbCrossLocalMngtForecast = el.var2_cross_management ? 'Yes' : 'No';
          const dbCrossRegionalCtrlForecast = el.var2_cross_control_regional ? 'Yes' : 'No';
          const dbCrossRegionalMngtForecast = el.var2_cross_management_regional ? 'Yes' : 'No';
          
          // Check if Excel values are different from DB values (for regional thresholds)
          const isRegionalCtrlProformaChanged = excelCrossRegionalCtrlProforma && excelCrossRegionalCtrlProforma !== dbCrossRegionalCtrlProforma;
          const isRegionalMngtProformaChanged = excelCrossRegionalMngtProforma && excelCrossRegionalMngtProforma !== dbCrossRegionalMngtProforma;
          const isRegionalCtrlForecastChanged = excelCrossRegionalCtrlForecast && excelCrossRegionalCtrlForecast !== dbCrossRegionalCtrlForecast;
          const isRegionalMngtForecastChanged = excelCrossRegionalMngtForecast && excelCrossRegionalMngtForecast !== dbCrossRegionalMngtForecast;
          
          // Check if any regional threshold value was changed in Excel
          const hasRegionalThresholdChangedFromExcel = isRegionalCtrlProformaChanged || isRegionalMngtProformaChanged || isRegionalCtrlForecastChanged || isRegionalMngtForecastChanged;
          
          // Use Excel values if different from DB, otherwise use DB values
          const finalCrossLocalCtrlProforma = (excelCrossLocalCtrlProforma && excelCrossLocalCtrlProforma !== dbCrossLocalCtrlProforma) 
            ? excelCrossLocalCtrlProforma : dbCrossLocalCtrlProforma;
          const finalCrossLocalMngtProforma = (excelCrossLocalMngtProforma && excelCrossLocalMngtProforma !== dbCrossLocalMngtProforma) 
            ? excelCrossLocalMngtProforma : dbCrossLocalMngtProforma;
          const finalCrossRegionalCtrlProforma = isRegionalCtrlProformaChanged ? excelCrossRegionalCtrlProforma : dbCrossRegionalCtrlProforma;
          const finalCrossRegionalMngtProforma = isRegionalMngtProformaChanged ? excelCrossRegionalMngtProforma : dbCrossRegionalMngtProforma;
          const finalCrossLocalCtrlForecast = (excelCrossLocalCtrlForecast && excelCrossLocalCtrlForecast !== dbCrossLocalCtrlForecast) 
            ? excelCrossLocalCtrlForecast : dbCrossLocalCtrlForecast;
          const finalCrossLocalMngtForecast = (excelCrossLocalMngtForecast && excelCrossLocalMngtForecast !== dbCrossLocalMngtForecast) 
            ? excelCrossLocalMngtForecast : dbCrossLocalMngtForecast;
          const finalCrossRegionalCtrlForecast = isRegionalCtrlForecastChanged ? excelCrossRegionalCtrlForecast : dbCrossRegionalCtrlForecast;
          const finalCrossRegionalMngtForecast = isRegionalMngtForecastChanged ? excelCrossRegionalMngtForecast : dbCrossRegionalMngtForecast;
          
          // Build finaldata with all fields matching readBulkSubmit structure
          finaldata[code] = {
            _id: el._id,
            code: code,
            glcode: glcode,
            name: el.glcode_detail?.name,
            // Amount and variance fields with formatting
            actual_amount: this.$nova.formatCurrency((el.amount1 || 0).toFixed(1), '', false, true),
            proforma_amount: this.$nova.formatCurrency((el.amount2 || 0).toFixed(1), '', false, true),
            variance_amount1: this.$nova.formatCurrency((el.varianceamount1 || 0).toFixed(1), '', false, true),
            variance_percent1: this.formatPercent(el.variancepercent1 || 0),
            forecast_amount: this.$nova.formatCurrency((el.amount3 || 0).toFixed(1), '', false, true),
            variance_amount2: this.$nova.formatCurrency((el.varianceamount2 || 0).toFixed(1), '', false, true),
            variance_percent2: this.formatPercent(el.variancepercent2 || 0),
            // Threshold cross values - Local thresholds
            crosslocalctrlvsproforma: showThresholdFlags ? finalCrossLocalCtrlProforma : '-',
            crosslocalmngtvsproforma: showThresholdFlags ? finalCrossLocalMngtProforma : '-',
            crosslocalctrlvsforecast: showThresholdFlags ? finalCrossLocalCtrlForecast : '-',
            crosslocalmngtvsforecast: showThresholdFlags ? finalCrossLocalMngtForecast : '-',
            // Threshold cross values - Regional thresholds (only show if changed)
            crossregionalctrlvsproforma: showThresholdFlags && isRegionalCtrlProformaChanged ? finalCrossRegionalCtrlProforma : '-',
            crossregionalmngtvsproforma: showThresholdFlags && isRegionalMngtProformaChanged ? finalCrossRegionalMngtProforma : '-',
            crossregionalctrlvsforecast: showThresholdFlags && isRegionalCtrlForecastChanged ? finalCrossRegionalCtrlForecast : '-',
            crossregionalmngtvsforecast: showThresholdFlags && isRegionalMngtForecastChanged ? finalCrossRegionalMngtForecast : '-',
            // Store flags to determine validation and upload behavior
            showThresholdFlags: showThresholdFlags,
            hasRegionalThresholdChangedFromExcel: hasRegionalThresholdChangedFromExcel,
            ignore: false,
            message: '',
            __found: true
          };

          
          // Regional Commentary 1 - use regionalcommentary1 (no underscore) to match DB field name
          if (
            el.regionalcommentary1 !== uploadRow[regionalCommentary1Index] &&
            uploadRow[regionalCommentary1Index] &&
            uploadRow[regionalCommentary1Index] !== "null" &&
            uploadRow[regionalCommentary1Index] !== "undefined"
          ) {
            finaldata[code].regionalcommentary1 = uploadRow[regionalCommentary1Index];
          }

          // Regional Commentary 2 - use regionalcommentary2 (no underscore) to match DB field name
          if (
            el.regionalcommentary2 !== uploadRow[regionalCommentary2Index] &&
            uploadRow[regionalCommentary2Index] &&
            uploadRow[regionalCommentary2Index] !== "null" &&
            uploadRow[regionalCommentary2Index] !== "undefined"
          ) {
            finaldata[code].regionalcommentary2 = uploadRow[regionalCommentary2Index];
          }

          // Remove regional commentary fields if not required by workflow
          if (!(this.workflows.rcp || this.workflows.rmp)) delete finaldata[code].regionalcommentary1;
          if (!(this.workflows.rcf || this.workflows.rmf)) delete finaldata[code].regionalcommentary2;

          let isRegionalCommentary1Required = false;
          let isRegionalCommentary2Required = false;
          
          // Regional Commentary validation logic:
          // 1. If showThresholdFlags is true AND Excel values changed from DB, validate based on new Excel threshold values
          // 2. Otherwise, follow usual validation based on DB threshold values
          
          // Validation for regionalcommentary1 (Act vs Pro)
          if (this.isapprover && (this.workflows.rcp || this.workflows.rmp)) {
            let requiresRegionalCommentary1 = false;
            
            if (showThresholdFlags && hasRegionalThresholdChangedFromExcel) {
              // Validate based on changed Excel threshold values for proforma
              const excelRequiresRegionalCommentary1 = (finalCrossRegionalCtrlProforma === 'Yes' || finalCrossRegionalMngtProforma === 'Yes');
              requiresRegionalCommentary1 = excelRequiresRegionalCommentary1;
            } else {
              // Follow usual validation based on DB threshold values
              requiresRegionalCommentary1 = (el.var1_cross_control_regional || el.var1_cross_management_regional);
            }
            
            if (requiresRegionalCommentary1) {
              if (!finaldata[code].regionalcommentary1) {
                finaldata[code].message = "Regional Commentary 1 required.";
                finaldata[code].ignore = true;
                isRegionalCommentary1Required = true;
              } else if (!isCommentaryValid(finaldata[code].regionalcommentary1)) {
                finaldata[code].message = "Regional Commentary 1 minimum 15 characters required.";
                finaldata[code].ignore = true;
                isRegionalCommentary1Required = true;
              }
            }
          }

          // Validation for regionalcommentary2 (Act vs For)
          if (this.isapprover && (this.workflows.rcf || this.workflows.rmf)) {
            let requiresRegionalCommentary2 = false;
            
            if (showThresholdFlags && hasRegionalThresholdChangedFromExcel) {
              // Validate based on changed Excel threshold values for forecast
              const excelRequiresRegionalCommentary2 = (finalCrossRegionalCtrlForecast === 'Yes' || finalCrossRegionalMngtForecast === 'Yes');
              requiresRegionalCommentary2 = excelRequiresRegionalCommentary2;
            } else {
              // Follow usual validation based on DB threshold values
              requiresRegionalCommentary2 = (el.var2_cross_control_regional || el.var2_cross_management_regional);
            }
            
            if (requiresRegionalCommentary2) {
              if (!finaldata[code].regionalcommentary2) {
                finaldata[code].message += "Regional Commentary 2 required.";
                finaldata[code].ignore = true;
                isRegionalCommentary2Required = true;
              } else if (!isCommentaryValid(finaldata[code].regionalcommentary2)) {
                finaldata[code].message += "Regional Commentary 2 minimum 15 characters required.";
                finaldata[code].ignore = true;
                isRegionalCommentary2Required = true;
              }
            }
          }

          // Set ready message if valid
          if (!isRegionalCommentary1Required && !isRegionalCommentary2Required) {
            finaldata[code].ignore = false;
            finaldata[code].error = false;
            finaldata[code].message = "Ready to upload";
          }

          // Ignore based on stage - use stage_regional for approver
          let isValid = true;
          if (el.stage_regional === 2) {
            finaldata[code].ignore = true;
            finaldata[code].message = "Ignored because regional approve completed";
          } else if (el.stage_regional === 3) {
            // Allow submission for immaterial variance (voluntary)
            isValid = true;
          } else if (el.stage_regional === 4 && !(showThresholdFlags && hasRegionalThresholdChangedFromExcel)) {
            // Ignore immaterial variance unless threshold changed from Excel
            finaldata[code].ignore = true;
            finaldata[code].message = "Ignored because variance is immaterial";
            isValid = true;
          } else if (el.__stage === 9 || el.stage_regional === 5) {
            finaldata[code].ignore = true;
            finaldata[code].message = "Ignored because not in scope";
            isValid = false;
          } else if (el.__stage === 1 && finaldata[code].ignore === true) {
            finaldata[code].message = "Ignored because commentary already submitted";
          }

          if (!isValid) delete finaldata[code];
        }

        // Check for errors
        let haserrorshow = false;
        for (const code in finaldata) {
          if (finaldata[code].error) {
            haserrorshow = true;
            break;
          }
        }
        
        this.bulksubmitfiledataerrorisApprover = haserrorshow;
        this.approverBulkSubmitData = finaldata;
        this.approverBulkSubmitFileDataListis = Object.values(finaldata);
      })
      .catch(err => {
        this.$store.commit("sbError", err.message || err || "Unknown error!");
        console.log(err);
      })
      .finally(() => {
        this.approverBulkSubmitDataFile = null;
        this.approverBulkSubmitLoading = false;
      });
  },
    /**
     * Parse a number from a string or formatted value
     * @param {*} value - The value to parse
     * @returns {Number} Parsed number or 0
     */
    parseNumber(value) {
      if (value === null || value === undefined || value === '') return 0;
      if (typeof value === 'number') return value;
      // Remove currency symbols, commas, and other formatting
      const cleaned = String(value).replace(/[^0-9.-]/g, '');
      const parsed = parseFloat(cleaned);
      return isNaN(parsed) ? 0 : parsed;
    },
    
    /**
     * Bulk upload commentary by GL code
     * @param {Boolean} isBulk - When true, includes threshold cross values for voluntary submissions
     */
    bulkUploadCommentaryByGL(isBulk = false) {
      this.bulksubmitloading = true;
      const url = '/v2/varianceanalysis/sl_analysis/bulkaddcommentarybygl';
      const ndt = [];
      
      
      for (const k in this.bulksubmitfiledata) {
        if (Object.hasOwnProperty.call(this.bulksubmitfiledata, k)) {
          const el = this.bulksubmitfiledata[k];
          if (el.ignore === false) {
            // For voluntary submissions (isBulk mode), include threshold cross values
            if (isBulk) {
              // Convert "Yes"/"No" strings to true/false booleans for API
              const toBoolean = (val) => val === 'Yes' || val === true;
              ndt.push({
                _id: el._id,
                glcode: el.glcode,
                commentary1: el.commentary1,
                commentary2: el.commentary2,
                crosscontrolthresholdvsproforma: toBoolean(el.crosscontrolthresholdvsproforma) || el.saved_var1_cross_control || false,
                crosscontrolthresholdvsforecast: toBoolean(el.crosscontrolthresholdvsforecast) || el.saved_var2_cross_control || false,
                crossmanagementthresholdvsproforma: toBoolean(el.crossmanagementthresholdvsproforma) || el.saved_var1_cross_management || false,
                crossmanagementthresholdvsforecast: toBoolean(el.crossmanagementthresholdvsforecast) || el.saved_var2_cross_management || false
              });
            } else {
              ndt.push({ 
                _id: el._id,
                glcode: el.glcode, 
                commentary1: el.commentary1, 
                commentary2: el.commentary2 
              });
            }
          }
        }
      }
      
      // Build filter with optional reporting_type for Balance Sheet
      const bulkCommentaryFilter = { 
        cycletype: this.cycletype, 
        cycle: this.commentarycycledata._id, 
        reportingunit: this.reportingunitId, 
        period: this.periodId,
        type: this.type,
        glcode: this.glcodeId
      };
      if (this.reportingType) {
        bulkCommentaryFilter.reporting_type = this.reportingType;
      }
      
      this.axios.post(url, { 
        data: ndt, 
        filter: bulkCommentaryFilter 
      }).then(dt => {
        if (dt.data.status === 'success') {
          this.$store.commit('sbSuccess', 'Bulk Commentary added');
          this.bulksubmitdialog = false;
          
          // Preserve UI state before reload to prevent disruptive page reset
          const preservedToggleView = Object.prototype.hasOwnProperty.call(this, 'toggleview') ? this.toggleview : undefined;
          const preservedMultiSelectData = Object.prototype.hasOwnProperty.call(this, 'multiselectdata')
            ? JSON.parse(JSON.stringify(this.multiselectdata || []))
            : undefined;
          const preservedExpandedIds = this.expandedIds ? new Set(this.expandedIds) : undefined;
          const preservedGroupedView = Object.prototype.hasOwnProperty.call(this, 'slGroupedView') ? this.slGroupedView : undefined;
          
          this.loadSLData(true);
          
          // Restore preserved UI states after reload
          this.$nextTick(() => {
            if (typeof preservedToggleView !== 'undefined') {
              this.toggleview = preservedToggleView;
            }
            if (typeof preservedMultiSelectData !== 'undefined') {
              this.multiselectdata = preservedMultiSelectData;
            }
            if (typeof preservedExpandedIds !== 'undefined') {
              this.expandedIds = preservedExpandedIds;
            }
            if (typeof preservedGroupedView !== 'undefined') {
              this.slGroupedView = preservedGroupedView;
            }
          });
        } else {
          throw new Error(dt.data.message || 'Error adding bulk commentary');
        }
      }).catch(err => {
        this.$store.commit('sbError', err.message || err || 'Unknown error!');
        console.error(err);
      }).finally(() => {
        this.bulksubmitloading = false;
      });
    },
    
    readBulkApproveLocal() {
      const file = this.bulkapprovelocalfiledatafile;
      if (!file?.name || this.bulkapprovelocalloading) {
        return;
      }
      
      this.bulkapprovelocalfiledataerror = false;
      this.bulkapprovelocalloading = true;
      
      Promise.resolve().then(() => {
        const ext = ((file || {}).name || '').split('.').pop();
        if (['xlsx', 'xls', 'xlsm', 'xlsb'].indexOf(ext) === -1) {
          throw new Error('Only xlsx,xls,xlsm,xlsb file extension supported');
        }
        return this.$nova.readExcelFile(file, 'TOP SHEET');
      }).then(excelData => {
        const sllist = [];
        const uploaddata = {};
        const finaldata = {};
        let haserror = false;
        
        // Build SL list from Excel
        for (let i = 5; i < excelData.length; i++) {
          const el = excelData[i];
          const slcode = (el[1] || '').toString();
          sllist.push(slcode);
          uploaddata[slcode] = el;
        }
        
        // Process each SL
        for (const el of this.commentarydata) {
          const code = (el.glcode_detail?.code || '').toString();
          
          if (sllist.includes(code)) {
            const uploadRow = uploaddata[code];
            finaldata[code] = {
              code: code,
              glcode: el.glcode,
              name: el.glcode_detail?.name,
              commentary1: el.commentary1 || '',
              commentary2: el.commentary2 || '',
              stage_local: el.stage_local,
              stage_regional: el.stage_regional,
              approvereason: uploadRow[10] || '', // Approve reason column
              ignore: false,
              message: 'Ready to process',
              __found: true
            };
            
            // Validation based on stage
            const hasValidStatus = 
              (this.isapprover && el.stage_local === 1) || 
              (this.isregionalapprover && el.stage_regional === 1);
            
            if (!hasValidStatus) {
              finaldata[code].ignore = true;
              finaldata[code].message = 'Not in awaiting approval status';
              finaldata[code].hasWarning = true;
              finaldata[code].warning = 'Not in awaiting approval status';
            }
            
            // Check threshold requirements for approval reason
            const requiresReason = 
              (this.isapprover && (el.var1_cross_control || el.var2_cross_control)) || 
              (this.isregionalapprover && (el.var1_cross_control_regional || el.var2_cross_control_regional));
            
            if (requiresReason && !finaldata[code].approvereason && hasValidStatus) {
              finaldata[code].ignore = true;
              finaldata[code].error = 'Approval reason required for threshold crossed items';
              finaldata[code].message = 'Approval reason required';
              haserror = true;
            }
            
            // Check bulk approval threshold settings from RU config
            const bulkapproveControl = Boolean(this.commentaryrudata?.bulkapprove_control);
            const bulkapproveManagement = Boolean(this.commentaryrudata?.bulkapprove_management);
            
            // Block if control threshold crossed and bulk approve for control is disabled
            if (!bulkapproveControl && hasValidStatus && !finaldata[code].error) {
              const crossedControl = this.isapprover 
                ? (el.var1_cross_control || el.var2_cross_control)
                : (el.var1_cross_control_regional || el.var2_cross_control_regional);
              
              if (crossedControl) {
                finaldata[code].ignore = true;
                finaldata[code].error = 'Bulk approve disabled';
                finaldata[code].message = 'Bulk approve disabled';
                haserror = true;
              }
            }
            
            // Block if management threshold crossed and bulk approve for management is disabled
            if (!bulkapproveManagement && hasValidStatus && !finaldata[code].error) {
              const crossedManagement = this.isapprover 
                ? (el.var1_cross_management || el.var2_cross_management)
                : (el.var1_cross_management_regional || el.var2_cross_management_regional);
              
              if (crossedManagement) {
                finaldata[code].ignore = true;
                finaldata[code].error = 'Bulk approve disabled';
                finaldata[code].message = 'Bulk approve disabled';
                haserror = true;
              }
            }
          }
        }
        
        // Add missing SL entries
        for (const sl of sllist) {
          if (!finaldata[sl]) {
            finaldata[sl] = {
              code: sl,
              glcode: sl,
              __found: false,
              ignore: true,
              message: 'Client Code not found',
              error: true
            };
            haserror = true;
          }
        }
        
        this.bulkapprovelocalfiledataerror = haserror;
        this.bulkapprovelocalfiledata = finaldata;
      }).catch(err => {
        this.$store.commit('sbError', err?.message || err || 'Unknown error!');
      }).finally(() => {
        this.bulkapprovelocalfiledatafile = null;
        this.bulkapprovelocalloading = false;
      });
    },
    
    bulkUploadApproveLocalCommentaryByGL() {
      this.bulkapprovelocalloading = true;
      let role = 'localapprover';
      if (this.isregionalapprover) role = 'regionalapprover';
      
      const url = '/v2/varianceanalysis/sl_analysis/bulkapprovelocalcommentarybygl';
      const ndt = [];
      
      for (const k in this.bulkapprovelocalfiledata) {
        if (Object.hasOwnProperty.call(this.bulkapprovelocalfiledata, k)) {
          const el = this.bulkapprovelocalfiledata[k];
          if (el.ignore === false && this.isapprover) {
            ndt.push({ 
              glcode: el.glcode, 
              approvereason: el.approvereason, 
              stage_local: el.stage_local, 
              stage_regional: el.stage_regional 
            });
          } else if (el.ignore === false && this.isregionalapprover) {
            ndt.push({ 
              glcode: el.glcode, 
              regionalapprovereason: el.approvereason, 
              stage_regional: el.stage_regional 
            });
          }
        }
      }
      
      // Build filter with optional reporting_type for Balance Sheet
      const bulkApproveLocalFilter = { 
        cycletype: this.cycletype, 
        cycle: this.commentarycycledata._id, 
        reportingunit: this.reportingunitId, 
        period: this.periodId,
        type: this.type,
        glcode: this.glcodeId
      };
      if (this.reportingType) {
        bulkApproveLocalFilter.reporting_type = this.reportingType;
      }
      
      this.axios.post(url, { 
        data: ndt, 
        role: role, 
        filter: bulkApproveLocalFilter 
      }).then(dt => {
        if (dt.data.status === 'success') {
          this.$store.commit('sbSuccess', 'Bulk commentary approve/reject completed');
          this.bulkapprovelocaldialog = false;
          
          // Preserve UI state before reload to prevent disruptive page reset
          const preservedToggleView = Object.prototype.hasOwnProperty.call(this, 'toggleview') ? this.toggleview : undefined;
          const preservedMultiSelectData = Object.prototype.hasOwnProperty.call(this, 'multiselectdata')
            ? JSON.parse(JSON.stringify(this.multiselectdata || []))
            : undefined;
          const preservedExpandedIds = this.expandedIds ? new Set(this.expandedIds) : undefined;
          const preservedGroupedView = Object.prototype.hasOwnProperty.call(this, 'slGroupedView') ? this.slGroupedView : undefined;
          
          this.loadSLData(true);
          
          // Restore preserved UI states after reload
          this.$nextTick(() => {
            if (typeof preservedToggleView !== 'undefined') {
              this.toggleview = preservedToggleView;
            }
            if (typeof preservedMultiSelectData !== 'undefined') {
              this.multiselectdata = preservedMultiSelectData;
            }
            if (typeof preservedExpandedIds !== 'undefined') {
              this.expandedIds = preservedExpandedIds;
            }
            if (typeof preservedGroupedView !== 'undefined') {
              this.slGroupedView = preservedGroupedView;
            }
          });
        } else {
          throw new Error(dt.data.message || 'Error adding bulk commentary');
        }
      }).catch(err => {
        this.$store.commit('sbError', err.message || err || 'Unknown error!');
        console.error(err);
      }).finally(() => {
        this.bulkapprovelocalloading = false;
      });
    },
    
    downloadExcelisApprover() {
      // Download Excel template for approver - matches helpers.js format with full column structure
      // Uses the same column structure as downloadBulkTemplate for compatibility with readBulkSubmitisApprover
      return Promise.resolve().then(() => {
        this.bulksubmitloading = true;
      }).then(() => {
        const styledxlsx = require('sheetjs-style');
        const workbook = styledxlsx.utils.book_new();
        const primarycolor = 'd8e8f0';
        const heading1 = 'bfffbf';
        const heading2 = 'E8EEFF';
        const heading3 = 'F2E1F5';
        const body1 = 'E3FFE3';
        const body2 = 'E8EEFF';
        const body3 = 'F2E1F5';
        const scolor = '078f0e';
        const ecolor = 'd11b1b';
        const runame = this.commentaryrudata?.code || 'Report';
        
        // Get period and year info from cycle data or SLData passed from Base.vue
        const periodName = this.commentarycycledata?.period_detail?.name || 
                          this.selectedCommentaryCycle?.period_detail?.name || 
                          this.SLData?.periodName ||
                          '';
        const yearName = this.commentarycycledata?.year_detail?.name || 
                        this.selectedCommentaryCycle?.year_detail?.name || 
                        this.SLData?.yearName ||
                        this.commentarycycledata?.year || 
                        this.selectedCommentaryCycle?.year || 
                        '';
        
        // Build subtitle with period, year and reporting type info
        const reportingTypeLabel = this.reportingType === 'bs' ? 'Balance Sheet' : 'Profit & Loss';
        let subtitle = this.cycletype;
        if (periodName) subtitle += ` - ${periodName}`;
        subtitle += ` - ${reportingTypeLabel} - Approver`;
        
        // Use bulksubmitcolumns - remove last 2 columns for the template (Local Approve & Submit columns)
        // This matches the same structure as downloadBulkTemplate for compatibility with readBulkSubmitisApprover
        let excelColumns = [...this.bulksubmitcolumns];
        excelColumns.splice(-2, 2);
        
        const dt = [
          [''],
          ['', { v: this.commentaryrudata?.name || '', s: { font: { bold: true, sz: 20 } } }],
          ['', { v: subtitle, s: { font: { bold: true, sz: 14 } } }],
          [''],
          [
            '',
            { v: excelColumns[0], s: { font: { bold: true }, fill: { fgColor: { rgb: primarycolor } } } },
            { v: excelColumns[1], s: { font: { bold: true }, fill: { fgColor: { rgb: primarycolor } } } },
            { v: excelColumns[2], s: { font: { bold: true }, fill: { fgColor: { rgb: primarycolor } } } },
            { v: excelColumns[3], s: { font: { bold: true }, fill: { fgColor: { rgb: heading1 } } } },
            { v: excelColumns[4], s: { font: { bold: true }, fill: { fgColor: { rgb: heading2 } } } },
            { v: excelColumns[5], s: { font: { bold: true }, fill: { fgColor: { rgb: heading2 } } } },
            { v: excelColumns[6], s: { font: { bold: true }, fill: { fgColor: { rgb: heading2 } } } },
            { v: excelColumns[7], s: { font: { bold: true }, fill: { fgColor: { rgb: heading2 } } } },
            { v: excelColumns[8], s: { font: { bold: true }, fill: { fgColor: { rgb: heading2 } } } },
            { v: excelColumns[9], s: { font: { bold: true }, fill: { fgColor: { rgb: heading2 } } } },
            { v: excelColumns[10], s: { font: { bold: true }, fill: { fgColor: { rgb: heading2 } } } },
            { v: excelColumns[11], s: { font: { bold: true }, fill: { fgColor: { rgb: heading2 } } } },
            { v: excelColumns[12], s: { font: { bold: true }, fill: { fgColor: { rgb: heading3 } } } },
            { v: excelColumns[13], s: { font: { bold: true }, fill: { fgColor: { rgb: heading3 } } } },
            { v: excelColumns[14], s: { font: { bold: true }, fill: { fgColor: { rgb: heading3 } } } },
            { v: excelColumns[15], s: { font: { bold: true }, fill: { fgColor: { rgb: heading3 } } } },
            { v: excelColumns[16], s: { font: { bold: true }, fill: { fgColor: { rgb: heading3 } } } },
            { v: excelColumns[17], s: { font: { bold: true }, fill: { fgColor: { rgb: heading3 } } } },
            { v: excelColumns[18], s: { font: { bold: true }, fill: { fgColor: { rgb: heading3 } } } },
            { v: excelColumns[19], s: { font: { bold: true }, fill: { fgColor: { rgb: heading3 } } } },
            { v: excelColumns[20], s: { font: { bold: true }, fill: { fgColor: { rgb: heading3 } } } },
            { v: excelColumns[21], s: { font: { bold: true }, fill: { fgColor: { rgb: primarycolor } } } },
            { v: excelColumns[22], s: { font: { bold: true }, fill: { fgColor: { rgb: primarycolor } } } },
            { v: excelColumns[23], s: { font: { bold: true }, fill: { fgColor: { rgb: primarycolor } } } },
            { v: excelColumns[24], s: { font: { bold: true }, fill: { fgColor: { rgb: primarycolor } } } },
            { v: excelColumns[25], s: { font: { bold: true }, fill: { fgColor: { rgb: primarycolor } } } },
            { v: excelColumns[26], s: { font: { bold: true }, fill: { fgColor: { rgb: primarycolor } } } }
          ]
        ];
        
        // Always use all items (ungrouped view) for template regardless of current view
        // Only include items with stage 5 (Regional Commentary Awaited) or -2 (Regional Rejected)
        for (const v of this.commentarydata) {
          if ((v.__stage === 5 || v.__stage === -2) && v.cycle) {
            // Compute status values for Local and Regional - matching helpers.js downloadExcelisApprover
            const stageLocal = (v.stage_local === -1) ? 'No' : ((v.stage_local === 2) ? 'Yes' : '');
            const localApproveReason = (v.stage_local === -1) ? (v.rejectreason || '') : ((v.stage_local === 2) ? (v.approvereason || '') : '');
            const stageRegional = (v.stage_regional === -1) ? 'No' : ((v.stage_regional === 2) ? 'Yes' : '');
            const regionalApproveReason = (v.stage_regional === -1) ? (v.regionalrejectreason || '') : ((v.stage_regional === 2) ? (v.regionalapprovereason || '') : '');
            
            dt.push([
              '',
              v.glcode_detail?.code,
              v.glcode_detail?.name,
              { v: this.$nova.formatCurrency((v.amount1 || 0).toFixed(1), '', false, true), s: { fill: { fgColor: { rgb: body1 } } } },
              { v: this.$nova.formatCurrency((v.amount2 || 0).toFixed(1), '', false, true), s: { fill: { fgColor: { rgb: body2 } } } },
              { v: this.$nova.formatCurrency((v.varianceamount1 || 0).toFixed(1), '', false, true), s: { font: { color: { rgb: ((v.varianceamount1 || 0) > 0) ? scolor : ecolor } }, fill: { fgColor: { rgb: body2 } } } },
              { v: this.$nova.formatCurrency(((v.variancepercent1 || 0)).toFixed(1), '', false, true) + (((v.variancepercent1 || 0) !== 0) ? '%' : ''), s: { font: { color: { rgb: ((v.varianceamount1 || 0) > 0) ? scolor : ecolor } }, fill: { fgColor: { rgb: body2 } } } },
              { v: v.var1_cross_control ? 'Yes' : 'No', s: { fill: { fgColor: { rgb: body2 } } } },
              { v: v.var1_cross_management ? 'Yes' : 'No', s: { fill: { fgColor: { rgb: body2 } } } },
              { v: v.var1_cross_control_regional ? 'Yes' : 'No', s: { fill: { fgColor: { rgb: body2 } } } },
              { v: v.var1_cross_management_regional ? 'Yes' : 'No', s: { fill: { fgColor: { rgb: body2 } } } },
              { v: v.commentary1 || '', s: { fill: { fgColor: { rgb: body2 } } } },
              { v: v.regionalcommentary1 || ((v.commentary1 || '') + (localApproveReason || '')) || '', s: { fill: { fgColor: { rgb: body2 } } } },
              { v: this.$nova.formatCurrency((v.amount3 || 0).toFixed(1), '', false, true), s: { fill: { fgColor: { rgb: body3 } } } },
              { v: this.$nova.formatCurrency((v.varianceamount2 || 0).toFixed(1), '', false, true), s: { font: { color: { rgb: ((v.varianceamount2 || 0) > 0) ? scolor : ecolor } }, fill: { fgColor: { rgb: body3 } } } },
              { v: this.$nova.formatCurrency(((v.variancepercent2 || 0)).toFixed(1), '', false, true) + (((v.variancepercent2 || 0) !== 0) ? '%' : ''), s: { font: { color: { rgb: ((v.varianceamount2 || 0) > 0) ? scolor : ecolor } }, fill: { fgColor: { rgb: body3 } } } },
              { v: v.var2_cross_control ? 'Yes' : 'No', s: { fill: { fgColor: { rgb: body3 } } } },
              { v: v.var2_cross_management ? 'Yes' : 'No', s: { fill: { fgColor: { rgb: body3 } } } },
              { v: v.var2_cross_control_regional ? 'Yes' : 'No', s: { fill: { fgColor: { rgb: body3 } } } },
              { v: v.var2_cross_management_regional ? 'Yes' : 'No', s: { fill: { fgColor: { rgb: body3 } } } },
              { v: v.commentary2 || '', s: { fill: { fgColor: { rgb: body3 } } } },
              { v: v.regionalcommentary2 || ((v.commentary2 || '') + (localApproveReason || '')) || '', s: { fill: { fgColor: { rgb: body3 } } } },
              this.getStageText(v.stage_local),
              this.getStageText(v.stage_regional),
              { v: stageLocal, s: { fill: { fgColor: { rgb: primarycolor } } } },
              { v: localApproveReason, s: { fill: { fgColor: { rgb: primarycolor } } } },
              { v: stageRegional, s: { fill: { fgColor: { rgb: primarycolor } } } },
              { v: regionalApproveReason, s: { fill: { fgColor: { rgb: primarycolor } } } }
            ]);
          }
        }
        
        const worksheet = styledxlsx.utils.aoa_to_sheet(dt);
        styledxlsx.utils.book_append_sheet(workbook, worksheet, 'TOP SHEET');
        
        // Build filename with GL name, period, and year
        const glName = this.selectedGLCommentary?.glcode_detail?.name || 
                       this.selectedGLCommentary?.description || 
                       this.SLData?.glName || '';
        const glCode = this.selectedGLCommentary?.glcode_detail?.code || 
                       this.selectedGLCommentary?.glcode || '';
        const glPart = glCode ? `_${glCode}` : (glName ? `_${glName.replace(/[^a-zA-Z0-9]/g, '_')}` : '');
        const periodPart = periodName ? `_${periodName.replace(/[^a-zA-Z0-9]/g, '_')}` : '';
        const yearPart = yearName ? `_${yearName}` : '';
        const filename = `${runame}${glPart}${periodPart}${yearPart}_SL_Breakup_Approver.xlsx`;
        
        styledxlsx.writeFile(workbook, filename);
      }).catch(err => {
        this.$store.commit('sbError', err.message || err || 'Unknown error!');
        console.error(err);
      }).finally(() => {
        this.bulksubmitloading = false;
      });
    },
    
    bulkUploadCommentaryByGLisApprover() {
      this.approverBulkSubmitLoading = true;
      const url = '/v2/varianceanalysis/sl_analysis/addbulkfileuploadregionalcommentary';
      const ndt = [];
      
      for (const k in this.approverBulkSubmitData) {
        const el = this.approverBulkSubmitData[k];
        if (el.ignore === false) {
          ndt.push({ 
            glcode: el._id, 
            regionalcommentary1: el.regionalcommentary1, 
            regionalcommentary2: el.regionalcommentary2 
          });
        }
      }
      
      // Build filter with optional reporting_type for Balance Sheet
      const regionalBulkFilter = { 
        cycletype: this.cycletype, 
        cycle: this.commentarycycledata._id, 
        reportingunit: this.reportingunitId, 
        period: this.periodId,
        type: this.type,
        glcode: this.glcodeId
      };
      if (this.reportingType) {
        regionalBulkFilter.reporting_type = this.reportingType;
      }
      
      this.axios.post(url, { 
        data: ndt, 
        filter: regionalBulkFilter 
      }).then(dt => {
        if (dt.data.status === 'success') {
          this.$store.commit('sbSuccess', 'Bulk Commentary added');
          this.approverBulkSubmitPop = false;
          
          // Preserve UI state before reload to prevent disruptive page reset
          const preservedToggleView = Object.prototype.hasOwnProperty.call(this, 'toggleview') ? this.toggleview : undefined;
          const preservedMultiSelectData = Object.prototype.hasOwnProperty.call(this, 'multiselectdata')
            ? JSON.parse(JSON.stringify(this.multiselectdata || []))
            : undefined;
          const preservedExpandedIds = this.expandedIds ? new Set(this.expandedIds) : undefined;
          const preservedGroupedView = Object.prototype.hasOwnProperty.call(this, 'slGroupedView') ? this.slGroupedView : undefined;
          
          this.loadSLData(true);
          
          // Restore preserved UI states after reload
          this.$nextTick(() => {
            if (typeof preservedToggleView !== 'undefined') {
              this.toggleview = preservedToggleView;
            }
            if (typeof preservedMultiSelectData !== 'undefined') {
              this.multiselectdata = preservedMultiSelectData;
            }
            if (typeof preservedExpandedIds !== 'undefined') {
              this.expandedIds = preservedExpandedIds;
            }
            if (typeof preservedGroupedView !== 'undefined') {
              this.slGroupedView = preservedGroupedView;
            }
          });
        } else {
          throw new Error(dt.data.message || 'Error adding bulk commentary');
        }
      }).catch(err => {
        this.$store.commit('sbError', err.message || err || 'Unknown error!');
        console.error(err);
      }).finally(() => {
        this.approverBulkSubmitLoading = false;
        this.approverBulkSubmitData = {};
      });
    },
    
    openBulkCommentaryDialogLocal() {
      if (this.workflows.islocalenabled) {
        this.bulksubmitdialog = true;
        this.bulksubmitfiledata = {};
        this.bulksubmitfiledataList = [];
        this.bulksubmitfiledataerror = false;
        this.bulksubmitfiledatafile = null;
        this.initializeBulkSubmitColumns();
      }
    },
    
    openBulkCommentaryDialogApprover() {
      if (this.workflows.isregionalenabled || this.workflows.islocalenabled) {
        this.approverBulkSubmitPop = true;
        this.approverBulkSubmitData = {};
        this.bulksubmitfiledataerrorisApprover = false;
        this.approverBulkSubmitFileDataListis = [];

        this.initializeBulkSubmitColumns();
      }
    },
    
    openBulkApproveDialog() {
      if ((this.isapprover && this.workflows.islocalenabled) || (this.isregionalapprover && this.workflows.isregionalenabled)) {
        this.bulkapprovelocaldialog = true;
        this.bulkapprovelocalfiledata = {};
      }
    },
    
    getNetSalesData() {
      this.$store.commit('sbInfo', 'Net sales data view is available in the main analysis page');
    },
    
    getRevenueData() {
      this.$store.commit('sbInfo', 'Revenue data view is available in the main analysis page');
    },
    
    // ===== Commentary Dialog Handlers =====
    toggleLocalCommentaryCollapse() {
      this.isLocalCommentaryCollapsed = !this.isLocalCommentaryCollapsed;
    },
    
    toggleLocalCommentaryReasonCollapse() {
      this.isLocalCommentaryReasonCollapsed = !this.isLocalCommentaryReasonCollapsed;
    },
    
    async handleGenerateAI({ commentary, slot, mode }) {
      const normalizedVariant = (slot || '').toLowerCase() === 'forecast' ? 'forecast' : 'proforma';
      try {
        await this.generateAI({
          variant: normalizedVariant,
          commentaryOverride: commentary || null,
          requestType: mode || '',
        });
      } catch (error) {
        console.error('[SLBreakup]: handleGenerateAI failed', error);
      }
    },
    
    async handleGenerateAISummary({ commentary, slot, mode }) {
      const normalizedVariant = (slot || '').toLowerCase() === 'forecast' ? 'forecast' : 'proforma';
      try {
        await this.generateAISummary({
          variant: normalizedVariant,
          commentaryOverride: commentary || null,
          requestType: mode || '',
        });
      } catch (error) {
        console.error('[SLBreakup]: handleGenerateAISummary failed', error);
      }
    },
    
    handleAttachmentChange(id) {
       this.uploadAttachmentFile(id);
    },

    uploadAttachmentFile(id) {
      if (this.attachmentfileloading === false) {
        this.attachmentfileloading = true;
        this.commentaryloading = true;
        this.attachmentfilepercentage = 0;
        let file = this.attachmentfile || {};
        let fileUpDetail = {}; 
        this.$nova.uploadFile(this.axios, file, {
          progressfunction: (e) => {
            let p = (e.loaded * 100) / e.total;
            this.attachmentfilepercentage = Math.round(p);
            // console.log(this.attachmentfilepercentage);
          },
        })
          .then((dt) => {
            if (dt.data.status === "success") {
              fileUpDetail = dt.data.data[0];
              console.log("File uploaded:", fileUpDetail);
              // Build filter with optional reporting_type for Balance Sheet
              const attachFilter = { cycletype: this.cycletype };
              if (this.reportingType) {
                attachFilter.reporting_type = this.reportingType;
              }
              return this.axios.post("/v2/varianceanalysis/sl_analysis/attachfile/" + id, { 
                data: { upload: fileUpDetail._id, }, 
                filter: attachFilter,
                client: this.$store.state.client
              });
            } else throw new Error("Unable to upload file");
          })
          .then((dt) => {
            if (dt.data.status === "success") {
              this.selectedcommentary.upload = fileUpDetail._id;
              if (this.selectedcommentary.__key !== undefined && this.commentarydata[this.selectedcommentary.__key]) {
                  this.commentarydata[this.selectedcommentary.__key].upload = fileUpDetail._id;
              }
              if (this.commentarydatajson[this.selectedcommentary.glcode]) {
                  this.commentarydatajson[this.selectedcommentary.glcode].upload = fileUpDetail._id;
              }
              this.closeCommentaryDialog();
              this.$store.commit("sbSuccess", "File Uploaded");
            } else throw new Error(dt.data.message || "Error storing file");
          })
          .catch((err) => {
            this.$store.commit("sbError", err.message || err || "Unknown error!");
          })
          .finally(() => {
            this.attachmentfile = null;
            this.attachmentfileloading = false;
            this.commentaryloading = false;
            this.commantorydialog = true;
          });
      }
    },
    
    handleGenerateAISection(type, apltype) {
      const fallbackVariant = type === 'Two' ? 'forecast' : 'proforma';
      const normalizedVariant = (apltype || '').toLowerCase() || fallbackVariant;
      this.generateAI({ variant: normalizedVariant });
    },
    
    async generateAI({ variant, commentaryOverride = null, requestType = '' } = {}) {
      const normalizedVariant = String(variant || '').toLowerCase();
      if (!normalizedVariant) {
        this.$store.commit('sbInfo', 'Select a commentary type to generate.');
        return;
      }

      if (this.isThresholdExceedCommentary) {
        this.$store.commit('sbError', 'Threshold exceeded. Gen AI summarisation is disabled.');
        return;
      }

      const select = commentaryOverride || this.activeCommentary;
      if (!select || !select.glcode_detail) {
        this.$store.commit('sbError', 'No SL code selected for AI generation.');
        return;
      }

      const cycleId = this.commentarycycledata._id || this.cycleId;
      const glcodeId = select.glcode_detail?._id;
      if (!cycleId || !glcodeId) {
        this.$store.commit('sbError', 'No cycle context available for AI generation.');
        return;
      }

      const axiosInstance = this.axios || this.$axios || this.$http;
      if (!axiosInstance) {
        this.$store.commit('sbError', 'Network client unavailable for AI generation.');
        return;
      }

      if (this.typingFrame) {
        cancelAnimationFrame(this.typingFrame);
        this.typingFrame = null;
      }
      this.shouldStop = true;

      if (normalizedVariant === 'proforma') {
        this.aiProforma = '';
      } else if (normalizedVariant === 'forecast') {
        this.aiForecast = '';
      }

      try {
        await this.generateSlCommentaryAiAction({
          axios: axiosInstance,
          cycleId,
          glcodeId,
          variant: normalizedVariant,
          featureName: this.commentaryStatusData?.name || '',
          requestType,
          resource: this.isRevenue ? 'revenue' : 'netsales',
        });
      } catch (error) {
        console.error('[SLBreakup]: generateAI failed', error);
      } finally {
        this.shouldStop = false;
      }
    },

    async generateAISummary({ variant, commentaryOverride = null, requestType = '' } = {}) {
      const normalizedVariant = String(variant || '').toLowerCase();
      if (!normalizedVariant) {
        this.$store.commit('sbInfo', 'Select a commentary type to generate.');
        return;
      }

      if (this.isThresholdExceedJVSummarisation) {
        this.$store.commit('sbError', 'Threshold exceeded. Gen AI summarisation is disabled.');
        return;
      }

      const select = commentaryOverride || this.activeCommentary;
      if (!select || !select.glcode_detail) {
        this.$store.commit('sbError', 'No SL code selected for AI generation.');
        return;
      }

      const cycleId = this.commentarycycledata._id || this.cycleId;
      const glcodeId = select.glcode_detail?._id;
      if (!cycleId || !glcodeId) {
        this.$store.commit('sbError', 'No cycle context available for AI generation.');
        return;
      }

      const axiosInstance = this.axios || this.$axios || this.$http;
      if (!axiosInstance) {
        this.$store.commit('sbError', 'Network client unavailable for AI generation.');
        return;
      }

      if (normalizedVariant === 'proforma') {
        this.summaryAiProforma = '';
      } else if (normalizedVariant === 'forecast') {
        this.summaryAiForecast = '';
      }

      try {
        await this.generateSlCommentarySummaryAction({
          axios: axiosInstance,
          cycleId,
          glcodeId,
          variant: normalizedVariant,
          featureName: this.commentaryStatusData?.name || '',
          requestType,
        });
      } catch (error) {
        console.error('[SLBreakup]: generateAISummary failed', error);
      }
    },
    
    typeEffect(type) {
      if (this.shouldStop || this.index >= this.aiResponseText.length) {
        this.isTyping = false;
        return;
      }

      if (type === 'One') {
        this.aiProforma += this.aiResponseText[this.index];
      } else {
        this.aiForecast += this.aiResponseText[this.index];
      }
      this.index++;

      this.typingFrame = requestAnimationFrame(() => {
        setTimeout(() => this.typeEffect(type), this.speed);
      });
    },
    
    /**
     * Validates selected GLs for bulk approval eligibility
     * Uses RU-level flags (bulkapprove_control, bulkapprove_management) and GL-level threshold flags
     * 
     * @param {string} role - 'approver' for local, 'regionalapprover' for regional
     * @returns {Object} - { valid: boolean, invalidGLs: Array, errorMessage: string }
     */
    validateBulkApproveSelection(role) {
      // Get selected GL objects from commentarydata using multiselectdata IDs
      const selectedGLs = this.multiselectdata
        ?.map(id => this.commentarydata?.find(item => item?._id === id))
        .filter(Boolean);

      if (selectedGLs.length === 0) {
        return {
          valid: false,
          invalidGLs: [],
          errorMessage: 'No valid GLs selected for bulk approval',
        };
      }

      // Get RU configuration for bulk approve flags
      const reportingUnit = {
        bulkapprove_control: Boolean(this.commentaryrudata?.bulkapprove_control),
        bulkapprove_management: Boolean(this.commentaryrudata?.bulkapprove_management),
      };

      // Validate using the utility function
      const validationResult = validateBulkApprove(selectedGLs, reportingUnit, role);

      return validationResult;
    },
    
    // ===== Commentary CRUD Operations =====
    async approveCommentary() {
      this.commentaryloading = true;
      const axiosInstance = this.axios || this.$axios || this.$http;
      if (!axiosInstance) {
        this.$store.commit('sbError', 'Network client unavailable for approval.');
        this.commentaryloading = false;
        return;
      }

      try {
        const isBulk = this.bulksubmit;
        const payload = isBulk ? this.multiselectdata : this.selectedcommentary?._id;
        if (!payload) {
          throw new Error('No commentary selected for approval');
        }

        // Determine if this is a local or regional approval based on commentarytype or __myaction
        const isLocalApproval = isBulk 
          ? this.bulktype === 'approvelocal'
          : (this.commentarytype === 'approvelocal' || 
             this.commentarytype === 'localapprove' ||
             this.selectedcommentary.__myaction === 'localapprove');
        
        // Determine role based on approval type
        const role = isLocalApproval ? 'approver' : 'regionalapprover';

        // ===== BULK APPROVE VALIDATION =====
        // Validate selected GLs before making API call for bulk operations
        if (isBulk) {
          const validationResult = this.validateBulkApproveSelection(role);
          if (!validationResult.valid) {
            this.$store.commit('sbError', validationResult.errorMessage);
            // Log invalid GLs for debugging
            if (validationResult.invalidGLs && validationResult.invalidGLs.length > 0) {
              console.warn('[SLBreakup]: Bulk approve validation failed. Invalid GLs:', 
                validationResult.invalidGLs.map(item => ({
                  code: item.glCode,
                  reason: item.reason
                }))
              );
            }
            this.commentaryloading = false;
            return;
          }
        }
        
        // Build approval reason data - exactly like helpers.js
        let data = {};
        if (isLocalApproval) {
          data = { approvereason: this.selectedcommentary?.approvereason || '' };
        } else {
          // Regional approval
          data = { regionalapprovereason: this.selectedcommentary?.regionalapprovereason || '' };
        }
        
        // Build filter with optional reporting_type for Balance Sheet
        const filter = {
          cycletype: this.cycletype,
          level: isLocalApproval ? 'local' : 'regional',
          reportingunit: this.reportingunitId,
          period: this.periodId,
          type: this.type,
          glcode: this.glcodeId,
        };
        if (this.reportingType) {
          filter.reporting_type = this.reportingType;
        }

        const success = await this.approveSlCommentaryAction({
          axios: axiosInstance,
          payload,
          isBulk,
          role,
          filter,
          data,
        });

        if (success) {
          this.closeCommentaryDialog();
          
          // Preserve UI state before reload to prevent disruptive page reset
          const preservedToggleView = Object.prototype.hasOwnProperty.call(this, 'toggleview') ? this.toggleview : undefined;
          const preservedMultiSelectData = Object.prototype.hasOwnProperty.call(this, 'multiselectdata')
            ? JSON.parse(JSON.stringify(this.multiselectdata || []))
            : undefined;
          const preservedExpandedIds = this.expandedIds ? new Set(this.expandedIds) : undefined;
          const preservedGroupedView = Object.prototype.hasOwnProperty.call(this, 'slGroupedView') ? this.slGroupedView : undefined;
          
          await this.loadSLData(true);
          
          // Restore preserved UI states
          if (typeof preservedToggleView !== 'undefined') {
            this.toggleview = preservedToggleView;
          }
          if (typeof preservedMultiSelectData !== 'undefined') {
            this.multiselectdata = preservedMultiSelectData;
          }
          if (typeof preservedExpandedIds !== 'undefined') {
            this.expandedIds = preservedExpandedIds;
          }
          if (typeof preservedGroupedView !== 'undefined') {
            this.slGroupedView = preservedGroupedView;
          }
        }
      } catch (error) {
        console.error('[SLBreakup]: approveCommentary failed', error);
      } finally {
        this.commentaryloading = false;
      }
    },
    
    async rejectCommentary(rejectTarget) {
      this.commentaryloading = true;
      const axiosInstance = this.axios || this.$axios || this.$http;
      if (!axiosInstance) {
        this.$store.commit('sbError', 'Network client unavailable for rejection.');
        this.commentaryloading = false;
        return;
      }

      try {
        const isBulk = this.bulksubmit;
        const payload = isBulk ? this.multiselectdata : this.selectedcommentary?._id;
        if (!payload) {
          throw new Error('No commentary selected for rejection');
        }

        // Determine if this is a local or regional rejection
        // For inline buttons (non-dialog), check __myaction from selected row
        const isLocalRejection = 
          this.bulktype === 'approvelocal' || 
          this.commentarytype === 'approvelocal' ||
          this.selectedcommentary?.__myaction === 'localapprove';
        
        // Validate rejection reason for Local Approver
        if (isLocalRejection && (!this.selectedcommentary?.approvereason || !String(this.selectedcommentary?.approvereason).trim())) {
          this.$store.commit('sbError', 'Rejection reason is required.');
          if (this.validationErrorField !== undefined) {
            this.validationErrorField = 'local_approval_reason';
            setTimeout(() => { this.validationErrorField = ''; }, 2000);
          }
          this.commentaryloading = false;
          return;
        }

        // Validate rejection reason for Regional Approver
        if (!isLocalRejection && (!this.selectedcommentary?.regionalapprovereason || !String(this.selectedcommentary?.regionalapprovereason).trim())) {
          this.$store.commit('sbError', 'Regional Rejection reason is required.');
          if (this.validationErrorField !== undefined) {
             this.validationErrorField = 'regional_approval_reason';
             setTimeout(() => { this.validationErrorField = ''; }, 2000);
          }
          this.commentaryloading = false;
          return;
        }
        
        // Set role based on actual rejection level, not just user's overall role
        const role = isLocalRejection ? 'approver' : 'regionalapprover';

        // ===== BULK REJECT VALIDATION =====
        // Validate selected GLs before making API call for bulk operations
        if (isBulk) {
          const validationResult = this.validateBulkApproveSelection(role);
          if (!validationResult.valid) {
            this.$store.commit('sbError', validationResult.errorMessage);
            // Log invalid GLs for debugging
            if (validationResult.invalidGLs && validationResult.invalidGLs.length > 0) {
              console.warn('[SLBreakup]: Bulk reject validation failed. Invalid GLs:', 
                validationResult.invalidGLs.map(item => ({
                  code: item.glCode,
                  reason: item.reason
                }))
              );
            }
            this.commentaryloading = false;
            return;
          }
        }

        // Build reject data - modified to match GLBreakdown logic
        let data = {};
        if (isBulk) {
          if (this.bulktype === 'approvelocal') {
            data = { rejectreason: this.selectedcommentary?.approvereason || '' };
          } else {
            // Regional rejection (bulk)
            data = { 
              rejectreason: this.selectedcommentary?.regionalapprovereason || '',
              rejection_target: rejectTarget
            };
          }
        } else {
          if (isLocalRejection) {
            data = { rejectreason: this.selectedcommentary?.approvereason || '' };
          } else {
            // Regional rejection (single)
            data = { 
              rejectreason: this.selectedcommentary?.regionalapprovereason || '',
              rejection_target: rejectTarget
            };
          }
        }

        // Build filter with optional reporting_type for Balance Sheet
        const filter = {
          cycletype: this.cycletype,
          level: isLocalRejection ? 'local' : 'regional',
          reportingunit: this.reportingunitId,
          period: this.periodId,
          type: this.type,
          glcode: this.glcodeId,
        };
        if (this.reportingType) {
          filter.reporting_type = this.reportingType;
        }

        const success = await this.rejectSlCommentaryAction({
          axios: axiosInstance,
          payload,
          isBulk,
          role,
          filter,
          data,
        });

        if (success) {
          this.closeCommentaryDialog();
          
          // Preserve UI state before reload to prevent disruptive page reset
          const preservedToggleView = Object.prototype.hasOwnProperty.call(this, 'toggleview') ? this.toggleview : undefined;
          const preservedMultiSelectData = Object.prototype.hasOwnProperty.call(this, 'multiselectdata')
            ? JSON.parse(JSON.stringify(this.multiselectdata || []))
            : undefined;
          const preservedExpandedIds = this.expandedIds ? new Set(this.expandedIds) : undefined;
          const preservedGroupedView = Object.prototype.hasOwnProperty.call(this, 'slGroupedView') ? this.slGroupedView : undefined;
          
          await this.loadSLData(true);
          
          // Restore preserved UI states
          if (typeof preservedToggleView !== 'undefined') {
            this.toggleview = preservedToggleView;
          }
          if (typeof preservedMultiSelectData !== 'undefined') {
            this.multiselectdata = preservedMultiSelectData;
          }
          if (typeof preservedExpandedIds !== 'undefined') {
            this.expandedIds = preservedExpandedIds;
          }
          if (typeof preservedGroupedView !== 'undefined') {
            this.slGroupedView = preservedGroupedView;
          }
        }
      } catch (error) {
        console.error('[SLBreakup]: rejectCommentary failed', error);
      } finally {
        this.commentaryloading = false;
      }
    },
    
    async saveCommentary(field) {
      this.commentaryloading = true;
      this.saveLoading = true;
      this.saveLocalCommentaryField = field || '';
      const axiosInstance = this.axios || this.$axios || this.$http;
      if (!axiosInstance) {
        this.$store.commit('sbError', 'Network client unavailable for saving commentary.');
        this.commentaryloading = false;
        this.saveLoading = false;
        this.saveLocalCommentaryField = '';
        return;
      }

      try {
        const isBulk = this.bulksubmit;
        const targetId = isBulk ? this.multiselectdata : this.selectedcommentary?._id;
        if (!targetId) {
          throw new Error('No commentary selected for save');
        }

        const baseUrl = isBulk
          ? '/v2/varianceanalysis/sl_analysis/addbulkcommentary'
          : `/v2/varianceanalysis/sl_analysis/addcommentary/${targetId}`;

        const isShortOnly = (text) => text && String(text).trim().length > 0 && String(text).trim().length < 15;

        if (this.ispreparer && (!field || field === 'proforma') && isShortOnly(this.selectedcommentary?.commentary1)) {
           this.$store.commit('sbError', `${this.proformaLabel} commentary too short (min 15 chars).`);
           this.commentaryloading = false;
           this.saveLoading = false;
           this.saveLocalCommentaryField = '';
           return;
        }
        if (this.ispreparer && (!field || field === 'forecast') && isShortOnly(this.selectedcommentary?.commentary2)) {
           this.$store.commit('sbError', `${this.forecastLabel} commentary too short (min 15 chars).`);
           this.commentaryloading = false;
           this.saveLoading = false;
           this.saveLocalCommentaryField = '';
           return;
        }

        let thresholdcross = {};
        if (this.ispreparer) {
          const controlFlag = this.requestcommentarylocalcontrolvsProforma || this.requestcommentarylocalcontrol;
          const managementFlag = this.requestcommentarylocalmanagementvsProforma || this.requestcommentarylocalmanagement;
          thresholdcross = {
            crosscontrolthresholdvsproforma: controlFlag,
            crosscontrolthresholdvsforecast: this.requestcommentarylocalcontrolvsForecast || this.requestcommentarylocalcontrol,
            crossmanagementthresholdvsproforma: managementFlag,
            crossmanagementthresholdvsforecast: this.requestcommentarylocalmanagementvsForecast || this.requestcommentarylocalmanagement,
          };
        }

        const saveFilter = {
          save: true,
          cycletype: this.cycletype,
          all: this.bulkcommentall,
          replace: this.bulkcommentreplace,
          reportingunit: this.reportingunitId,
          type: this.type,
          glcode: this.glcodeId,
        };
        if (this.reportingType) {
          saveFilter.reporting_type = this.reportingType;
        }
        if (field === 'proforma' || field === 'forecast') {
          saveFilter.commentaryField = field;
        }
        const data = {
          commentary1: String(this.selectedcommentary?.commentary1 ?? '').trim(),
          commentary2: String(this.selectedcommentary?.commentary2 ?? '').trim(),
          summarycommentary1: String(this.summaryAiProforma ?? '').trim(),
          summarycommentary2: String(this.summaryAiForecast ?? '').trim(),
        };

        const body = {
          id: targetId,
          filter: {
            ...saveFilter,
            ...thresholdcross,
          },
          data: {
            ...data,
          },
        };

        const success = await this.saveSlCommentaryAction({
          axios: axiosInstance,
          url: baseUrl,
          body,
        });

        if (success && this.selectedcommentary) {
          if (field === 'proforma') {
            const savedValue = String(this.selectedcommentary.commentary1 ?? '').trim();
            this.$set(this.selectedcommentary, 'savedcommentary1', savedValue);
            this.updateCommentaryBaseline('commentary1', savedValue);
            this.syncSelectedCommentaryDraftInCache({
              savedcommentary1: savedValue,
            });
          } else if (field === 'forecast') {
            const savedValue = String(this.selectedcommentary.commentary2 ?? '').trim();
            this.$set(this.selectedcommentary, 'savedcommentary2', savedValue);
            this.updateCommentaryBaseline('commentary2', savedValue);
            this.syncSelectedCommentaryDraftInCache({
              savedcommentary2: savedValue,
            });
          } else {
            const savedOne = String(this.selectedcommentary.commentary1 ?? '').trim();
            const savedTwo = String(this.selectedcommentary.commentary2 ?? '').trim();
            this.$set(this.selectedcommentary, 'savedcommentary1', savedOne);
            this.$set(this.selectedcommentary, 'savedcommentary2', savedTwo);
            this.updateCommentaryBaseline('commentary1', savedOne);
            this.updateCommentaryBaseline('commentary2', savedTwo);
            this.syncSelectedCommentaryDraftInCache({
              savedcommentary1: savedOne,
              savedcommentary2: savedTwo,
            });
          }
        }
      } catch (error) {
        console.error('[SLBreakup]: saveCommentary failed', error);
      } finally {
        this.commentaryloading = false;
        this.saveLoading = false;
        this.saveLocalCommentaryField = '';
      }
    },

    async saveRegionalCommentary(field) {
      this.commentaryloading = true;
      this.saveLoading = true;
      this.saveRegionalCommentaryField = field || '';
      const axiosInstance = this.axios || this.$axios || this.$http;
      if (!axiosInstance) {
        this.$store.commit('sbError', 'Network client unavailable for saving regional commentary.');
        this.commentaryloading = false;
        this.saveLoading = false;
        this.saveRegionalCommentaryField = '';
        return;
      }

      try {
        const targetId = this.selectedcommentary?._id;
        if (!targetId) {
          throw new Error('No commentary selected for regional save');
        }

        const baseUrl = `/v2/varianceanalysis/sl_analysis/addcommentary/${targetId}`;

        const isShortOnly = (text) => text && String(text).trim().length > 0 && String(text).trim().length < 15;

        if ((!field || field === 'proforma') && isShortOnly(this.selectedcommentary?.regionalcommentary1)) {
           this.$store.commit('sbError', `${this.proformaLabel} regional commentary too short (min 15 chars).`);
           this.commentaryloading = false;
           this.saveLoading = false;
           this.saveRegionalCommentaryField = '';
           return;
        }
        if ((!field || field === 'forecast') && isShortOnly(this.selectedcommentary?.regionalcommentary2)) {
           this.$store.commit('sbError', `${this.forecastLabel} regional commentary too short (min 15 chars).`);
           this.commentaryloading = false;
           this.saveLoading = false;
           this.saveRegionalCommentaryField = '';
           return;
        }

        const saveFilter = {
          save: true,
          saveType: 'regional_commentary',
          regional: true,
          commentaryField: field, // 'proforma' or 'forecast'
          cycletype: this.cycletype,
          reportingunit: this.reportingunitId,
          type: this.type,
          glcode: this.glcodeId,
        };
        if (this.reportingType) {
          saveFilter.reporting_type = this.reportingType;
        }

        const data = {};
        
        // Only send the field being saved
        if (field === 'proforma') {
          data.regionalcommentary1 = String(this.selectedcommentary?.regionalcommentary1 ?? '').trim();
        } else if (field === 'forecast') {
          data.regionalcommentary2 = String(this.selectedcommentary?.regionalcommentary2 ?? '').trim();
        }

        const body = {
          id: targetId,
          filter: {
            ...saveFilter,
          },
          data: {
            ...data,
          },
        };

        const success = await this.saveSlCommentaryAction({
          axios: axiosInstance,
          url: baseUrl,
          body,
        });

        if (success && this.selectedcommentary) {
          if (field === 'proforma') {
            const savedValue = String(this.selectedcommentary.regionalcommentary1 ?? '').trim();
            this.$set(this.selectedcommentary, 'savedregionalcommentary1', savedValue);
            this.updateCommentaryBaseline('regionalcommentary1', savedValue);
            this.syncSelectedCommentaryDraftInCache({
              savedregionalcommentary1: savedValue,
            });
          } else if (field === 'forecast') {
            const savedValue = String(this.selectedcommentary.regionalcommentary2 ?? '').trim();
            this.$set(this.selectedcommentary, 'savedregionalcommentary2', savedValue);
            this.updateCommentaryBaseline('regionalcommentary2', savedValue);
            this.syncSelectedCommentaryDraftInCache({
              savedregionalcommentary2: savedValue,
            });
          }
        }
      } catch (error) {
        console.error('[SLBreakup]: saveRegionalCommentary failed', error);
      } finally {
        this.commentaryloading = false;
        this.saveLoading = false;
        this.saveRegionalCommentaryField = '';
      }
    },

    normalizeCommentaryText(value) {
      return String(value ?? '').replace(/<[^>]*>/g, '').trim();
    },

    isCommentaryTextDirty(current, baseline) {
      if (!this.commentaryBaselinesReady) {
        return false;
      }
      const currentValue = this.normalizeCommentaryText(current);
      const baselineValue = this.normalizeCommentaryText(baseline);
      return currentValue !== baselineValue;
    },

    hydrateSavedCommentaryDrafts(commentary) {
      if (!commentary || typeof commentary !== 'object') {
        return {};
      }

      const hydrated = { ...commentary };
      const isEmpty = (val) => !this.normalizeCommentaryText(val);

      // Local commentary precedence: submitted > saved
      if (isEmpty(hydrated.commentary1) && !isEmpty(hydrated.savedcommentary1)) {
        hydrated.commentary1 = hydrated.savedcommentary1;
      }
      if (isEmpty(hydrated.commentary2) && !isEmpty(hydrated.savedcommentary2)) {
        hydrated.commentary2 = hydrated.savedcommentary2;
      }
      if (isEmpty(hydrated.regionalcommentary1) && !isEmpty(hydrated.savedregionalcommentary1)) {
        hydrated.regionalcommentary1 = hydrated.savedregionalcommentary1;
      }
      if (isEmpty(hydrated.regionalcommentary2) && !isEmpty(hydrated.savedregionalcommentary2)) {
        hydrated.regionalcommentary2 = hydrated.savedregionalcommentary2;
      }

      // Regional commentary precedence: submitted > saved > copied-over
      // Check if regional commentary has been actually submitted (stage_regional === 3 or 4 means submitted/approved)
      const isRegionalSubmitted = commentary.stage_regional === 3 || commentary.stage_regional === 4;
      
      // For regionalcommentary1 (Proforma)
      if (!isRegionalSubmitted && !isEmpty(hydrated.savedregionalcommentary1)) {
        // If regional not submitted yet and there's a saved draft, prefer saved draft over copied-over value
        hydrated.regionalcommentary1 = hydrated.savedregionalcommentary1;
      } else if (isEmpty(hydrated.regionalcommentary1) && !isEmpty(hydrated.savedregionalcommentary1)) {
        // Fallback: if regionalcommentary1 is empty and saved exists, use saved
        hydrated.regionalcommentary1 = hydrated.savedregionalcommentary1;
      }
      
      // For regionalcommentary2 (Forecast)
      if (!isRegionalSubmitted && !isEmpty(hydrated.savedregionalcommentary2)) {
        // If regional not submitted yet and there's a saved draft, prefer saved draft over copied-over value
        hydrated.regionalcommentary2 = hydrated.savedregionalcommentary2;
      } else if (isEmpty(hydrated.regionalcommentary2) && !isEmpty(hydrated.savedregionalcommentary2)) {
        // Fallback: if regionalcommentary2 is empty and saved exists, use saved
        hydrated.regionalcommentary2 = hydrated.savedregionalcommentary2;
      }

      return hydrated;
    },

    prepareCommentaryForDialog(row) {
      if (!row || typeof row !== 'object') {
        return {};
      }

      const savedKey = this.normalizeLookupKey(row._id);
      const latest = savedKey ? (this.commentarydatajsonById[savedKey] || row) : row;
      const merged = {
        ...latest,
        ...row,
        _id: row._id || latest._id,
      };

      // Row data can wipe saved drafts with empty values; restore from cache.
      const savedFields = [
        'savedcommentary1',
        'savedcommentary2',
        'savedregionalcommentary1',
        'savedregionalcommentary2',
      ];
      savedFields.forEach((field) => {
        if (!this.normalizeCommentaryText(merged[field]) && this.normalizeCommentaryText(latest[field])) {
          merged[field] = latest[field];
        }
      });

      // Store original submitted values before hydration
      merged.__submittedCommentary1 = merged.commentary1;
      merged.__submittedCommentary2 = merged.commentary2;
      merged.__submittedRegionalCommentary1 = merged.regionalcommentary1;
      merged.__submittedRegionalCommentary2 = merged.regionalcommentary2;

      return this.hydrateSavedCommentaryDrafts(merged);
    },

    isSubmittedCommentaryField(field) {
      const submittedKey = field === 'commentary1' ? '__submittedCommentary1' : '__submittedCommentary2';
      if (!Object.prototype.hasOwnProperty.call(this.selectedcommentary || {}, submittedKey)) {
        return false;
      }
      return Boolean(this.normalizeCommentaryText(this.selectedcommentary[submittedKey]));
    },

    isSubmittedRegionalCommentaryField(field) {
      const submittedKey = field === 'regionalcommentary1' ? '__submittedRegionalCommentary1' : '__submittedRegionalCommentary2';
      if (!Object.prototype.hasOwnProperty.call(this.selectedcommentary || {}, submittedKey)) {
        return false;
      }
      return Boolean(this.normalizeCommentaryText(this.selectedcommentary[submittedKey]));
    },

    confirmUnsavedCommentaryClose() {
      this.unsavedCommentaryDialog = false;
      this.closeCommentaryDialog();
    },

    cancelUnsavedCommentaryClose() {
      this.unsavedCommentaryDialog = false;
    },

    closeCommentaryDialog() {
      this.allowCommentaryDialogClose = true;
      this.commantorydialog = false;
    },

    captureCommentaryBaselines() {
      const commentary = this.selectedcommentary || {};
      this.commentaryBaselines = {
        commentary1: this.normalizeCommentaryText(commentary.commentary1),
        commentary2: this.normalizeCommentaryText(commentary.commentary2),
        regionalcommentary1: this.normalizeCommentaryText(commentary.regionalcommentary1),
        regionalcommentary2: this.normalizeCommentaryText(commentary.regionalcommentary2),
      };
      this.commentaryBaselinesReady = true;
    },

    scheduleCommentaryBaselineCapture() {
      if (this.commentaryBaselinesReady) {
        return;
      }
      this.commentaryBaselinesReady = false;
      this.$nextTick(() => {
        this.$nextTick(() => {
          this.captureCommentaryBaselines();
        });
      });
    },

    updateCommentaryBaseline(field, value) {
      if (!field || !Object.prototype.hasOwnProperty.call(this.commentaryBaselines, field)) {
        return;
      }
      this.$set(this.commentaryBaselines, field, this.normalizeCommentaryText(value));
    },

    syncSelectedCommentaryDraftInCache(fieldsOrKey, value) {
      const commentaryId = this.selectedcommentary?._id;
      if (!commentaryId) {
        return;
      }

      const updates = typeof fieldsOrKey === 'object' && fieldsOrKey !== null
        ? fieldsOrKey
        : { [fieldsOrKey]: value };

      if (!updates || !Object.keys(updates).length) {
        return;
      }

      const savedKey = this.normalizeLookupKey(commentaryId);
      if (!savedKey) {
        return;
      }

      const applyUpdates = (target) => {
        if (!target || typeof target !== 'object') {
          return;
        }
        Object.keys(updates).forEach((field) => {
          if (!field) {
            return;
          }
          this.$set(target, field, updates[field]);
        });
      };

      let cached = this.commentarydatajsonById?.[savedKey];
      if (!cached) {
        cached = { ...(this.selectedcommentary || {}), _id: commentaryId };
        this.$set(this.commentarydatajsonById, savedKey, cached);
      }
      applyUpdates(cached);

      // Keep alternate lookup maps in sync when present.
      const glKey = this.normalizeLookupKey(cached.glcode || this.selectedcommentary?.glcode);
      if (glKey && this.commentarydatajsonByGLCode?.[glKey]) {
        applyUpdates(this.commentarydatajsonByGLCode[glKey]);
      }
      if (glKey && this.commentarydatajson?.[glKey]) {
        applyUpdates(this.commentarydatajson[glKey]);
      }

      // Patch matching rows in tree/flat lists so reopen uses saved text.
      const patchList = (list) => {
        if (!Array.isArray(list)) {
          return;
        }
        list.forEach((item) => {
          if (!item || typeof item !== 'object') {
            return;
          }
          if (this.normalizeLookupKey(item._id) === savedKey) {
            applyUpdates(item);
          }
          if (Array.isArray(item.children) && item.children.length) {
            patchList(item.children);
          }
        });
      };
      patchList(this.commentarydata);
      patchList(this.slUngroupedData);
    },
    
    async addCommentary() {
      this.commentaryloading = true;
      const axiosInstance = this.axios || this.$axios || this.$http;
      if (!axiosInstance) {
        this.$store.commit('sbError', 'Network client unavailable for adding commentary.');
        this.commentaryloading = false;
        return;
      }
      try {
        const isBulk = this.bulksubmit;
        const url = isBulk
          ? '/v2/varianceanalysis/sl_analysis/addbulkcommentary'
          : `/v2/varianceanalysis/sl_analysis/addcommentary/${this.selectedcommentary._id}`;
        
        const id = isBulk ? this.multiselectdata : this.selectedcommentary._id;
        
        // Helper to check if commentary is too short
        const isShortOrEmpty = (text) => !text || String(text).trim().length < 15;
        const isShortOnly = (text) => text && String(text).trim().length > 0 && String(text).trim().length < 15;
        
        // Build threshold cross data
        // The voluntary checkboxes (requestcommentarylocalcontrol, requestcommentarylocalmanagement)
        // apply to BOTH proforma and forecast. Use these if the specific vsProforma/vsForecast aren't set.
        let thresholdcross = {};
        if (this.ispreparer) {
          const controlFlag = this.requestcommentarylocalcontrolvsProforma || this.requestcommentarylocalcontrol;
          const managementFlag = this.requestcommentarylocalmanagementvsProforma || this.requestcommentarylocalmanagement;
          thresholdcross = { 
            crosscontrolthresholdvsproforma: controlFlag, 
            crosscontrolthresholdvsforecast: this.requestcommentarylocalcontrolvsForecast || this.requestcommentarylocalcontrol,
            crossmanagementthresholdvsproforma: managementFlag, 
            crossmanagementthresholdvsforecast: this.requestcommentarylocalmanagementvsForecast || this.requestcommentarylocalmanagement
          };
        } else if (this.isapprover) {
          const controlFlag = this.requestcommentarylocalcontrolvsProforma || this.requestcommentaryregionalcontrol;
          const managementFlag = this.requestcommentarylocalmanagementvsProforma || this.requestcommentaryregionalmanagement;
          thresholdcross = { 
            crosscontrolthresholdvsproforma: controlFlag, 
            crosscontrolthresholdvsforecast: this.requestcommentarylocalcontrolvsForecast || this.requestcommentaryregionalcontrol,
            crossmanagementthresholdvsproforma: managementFlag, 
            crossmanagementthresholdvsforecast: this.requestcommentarylocalmanagementvsForecast || this.requestcommentaryregionalmanagement
          };
        }
        
        // Validation helpers
        const hasThreshold = () => Object.values(thresholdcross).some(Boolean);
        const hasItemThreshold = () => {
          return Boolean(
            this.selectedcommentary?.var1_cross_control
            || this.selectedcommentary?.var1_cross_management
            || this.selectedcommentary?.var2_cross_control
            || this.selectedcommentary?.var2_cross_management
          );
        };
        const hasVoluntaryProformaReason = Boolean(
          thresholdcross.crosscontrolthresholdvsproforma
          || thresholdcross.crossmanagementthresholdvsproforma
        );
        const hasVoluntaryForecastReason = Boolean(
          thresholdcross.crosscontrolthresholdvsforecast
          || thresholdcross.crossmanagementthresholdvsforecast
        );

        // For bulk, re-OR threshold flags across selection so mandatory checks stay accurate.
        if (isBulk) {
          Object.assign(this.selectedcommentary || {}, this.getAggregatedMultiselectThresholdFlags());
        }

        // Validate commentary requirements from threshold flags (bulk uses OR across selection).
        // For single immaterial voluntary submit, selected voluntary reasons also make the matching field mandatory.
        const isProformaMandatory = this.ispreparer && (
          this.selectedcommentary.var1_cross_control
          || this.selectedcommentary.var1_cross_management
          || (!isBulk && hasVoluntaryProformaReason)
        );
        const preparerProformaNeeded = isProformaMandatory 
          ? isShortOrEmpty(this.selectedcommentary?.commentary1)
          : isShortOnly(this.selectedcommentary?.commentary1);
          
        const isForecastMandatory = this.ispreparer && (
          this.selectedcommentary.var2_cross_control
          || this.selectedcommentary.var2_cross_management
          || (!isBulk && hasVoluntaryForecastReason)
        );
        const preparerForecastNeeded = isForecastMandatory
          ? isShortOrEmpty(this.selectedcommentary?.commentary2)
          : isShortOnly(this.selectedcommentary?.commentary2);
        
        const isRegionalProformaMandatory = this.isapprover && (this.selectedcommentary.var1_cross_management_regional || this.selectedcommentary.var1_cross_control_regional);
        const approverProformaNeeded = isRegionalProformaMandatory
          ? isShortOrEmpty(this.selectedcommentary?.regionalcommentary1)
          : isShortOnly(this.selectedcommentary?.regionalcommentary1);
        
        const isRegionalForecastMandatory = this.isapprover && (this.selectedcommentary.var2_cross_management_regional || this.selectedcommentary.var2_cross_control_regional);
        const approverForecastNeeded = isRegionalForecastMandatory
          ? isShortOrEmpty(this.selectedcommentary?.regionalcommentary2)
          : isShortOnly(this.selectedcommentary?.regionalcommentary2);
        
        // Validation for voluntary submissions
        const isVoluntary = this.selectedcommentary.stage_local === 3 || this.selectedcommentary.stage_local === 4;
        if (this.ispreparer && !hasThreshold() && !isBulk && !hasItemThreshold() && isVoluntary) {
          this.$store.commit('sbError', 'Voluntary commentary submission reason is required.');
          this.commentaryloading = false;
          return;
        }
        
        if (preparerProformaNeeded || approverProformaNeeded) {
          this.$store.commit('sbError', `${this.proformaLabel} commentary is required and should be minimum 15 characters.`);
          this.commentaryloading = false;
          return;
        }
        
        if (preparerForecastNeeded || approverForecastNeeded) {
          this.$store.commit('sbError', `${this.forecastLabel} commentary is required and should be minimum 15 characters.`);
          this.commentaryloading = false;
          return;
        }
        
        // Calculate voluntary submit flag matched with helpers.js
        let isVolunterySubmit = false;
        if (this.ispreparer && !isBulk) {
          if ([3, 4, 5].indexOf(this.selectedcommentary?.stage_local) > -1) {
            isVolunterySubmit = true;
          }
        }

        // Build data payload
        const dta = this.isapprover ? {
          regionalcommentary1: String(this.selectedcommentary?.regionalcommentary1 ?? '').trim(),
          regionalcommentary2: String(this.selectedcommentary?.regionalcommentary2 ?? '').trim()
        } : {
          commentary1: String(this.selectedcommentary?.commentary1 ?? '').trim(),
          commentary2: String(this.selectedcommentary?.commentary2 ?? '').trim(),
          isvolunterysubmit: isVolunterySubmit
        };
        
        // Build filter with optional reporting_type for Balance Sheet
        const addFilter = {
          regional: this.isapprover,
          cycletype: this.cycletype,
          all: this.bulkcommentall,
          replace: this.bulkcommentreplace,
          ...thresholdcross,
          reportingunit: this.reportingunitId,
          type: this.type,
          glcode: this.glcodeId,
        };
        if (this.reportingType) {
          addFilter.reporting_type = this.reportingType;
        }
        
        const body = {
          id,
          filter: addFilter,
          data: dta,
        };

        const success = await this.addSlCommentaryAction({
          axios: axiosInstance,
          url,
          body,
        });

        if (success) {
          this.closeCommentaryDialog();
          
          // Preserve UI state before reload to prevent disruptive page reset
          const preservedToggleView = Object.prototype.hasOwnProperty.call(this, 'toggleview') ? this.toggleview : undefined;
          const preservedMultiSelectData = Object.prototype.hasOwnProperty.call(this, 'multiselectdata')
            ? JSON.parse(JSON.stringify(this.multiselectdata || []))
            : undefined;
          const preservedExpandedIds = this.expandedIds ? new Set(this.expandedIds) : undefined;
          const preservedGroupedView = Object.prototype.hasOwnProperty.call(this, 'slGroupedView') ? this.slGroupedView : undefined;
          
          await this.loadSLData(true);
          
          // Restore preserved UI states
          if (typeof preservedToggleView !== 'undefined') {
            this.toggleview = preservedToggleView;
          }
          if (typeof preservedMultiSelectData !== 'undefined') {
            this.multiselectdata = preservedMultiSelectData;
          }
          if (typeof preservedExpandedIds !== 'undefined') {
            this.expandedIds = preservedExpandedIds;
          }
          if (typeof preservedGroupedView !== 'undefined') {
            this.slGroupedView = preservedGroupedView;
          }
        }
      } catch (error) {
        console.error('[SLBreakup]: addCommentary failed', error);
      } finally {
        this.commentaryloading = false;
      }
    },
    
    /**
     * Get stage text for local/regional commentary status
     * Matches helpers.js getStageText method
     * @param {number} x - Stage number
     * @returns {string} Stage text
     */
    getStageText(x) {
      if (x === -1) return 'Rejected commentary';
      else if (x === 0) return 'Commentary awaited';
      else if (x === 1) return 'Commentary awaiting approval';
      else if (x === 2) return 'Approved commentary';
      else if (x === 3) return 'Nil value accounts';
      else if (x === 4) return 'Immaterial variance';
      else if (x === 5) return 'Not in Scope';
      else return '';
    },
  },
  
  beforeDestroy() {
    if (this.typingFrame) {
      cancelAnimationFrame(this.typingFrame);
    }
    this.shouldStop = true;
    this.isSummaryExpanded = true;
    
    // Reset cycle data to prevent stale state
    this.commentarycycledata = {};
  },
  beforeRouteLeave(to, from, next) {
    // Only skip reload when navigating back to Analysis (Actual/Forecast) pages.
    // If the user navigates to Reports or any other page, do NOT keep this flag,
    // otherwise Filter.vue will restore the old Base filters and never reset.
    const toPath = (to && to.path) ? String(to.path) : '';
    const isGoingToAnalysis =
      toPath.indexOf('/varianceanalysis/actualanalysis') === 0 ||
      toPath.indexOf('/varianceanalysis/forecastanalysis') === 0;
    const isGoingToCommentary = toPath.indexOf('/varianceanalysis/commentary/') === 0;

    this.$store.commit('varianceanalysis/setSkipReloadOnBack', isGoingToAnalysis);

    // If leaving the Analysis/drilldown flow entirely, clear the cached Base page state.
    // Keep it when navigating deeper into drilldown (e.g., SLBreakup -> GLBreakdown).
    if (!isGoingToAnalysis && !isGoingToCommentary) {
      this.$store.commit('varianceanalysis/clearBasePageState');
    }
    next();
  },
};
</script>

<style scoped lang="scss">
/* Commentary Actions Border */
.border-top {
  border-top: 1px solid #e0e0e0;
}

/* Summary card styles */
.summary-card {
  background: #ffffff;
  padding: 16px;
  border-radius: var(--Space-sm, 12px);
  border: 1px solid var(--Background-default, #F7F7F7);
  box-shadow: 4px 4px 20px 0 rgba(0, 0, 0, 0.08);
}

.summary-card__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
}

.summary-card__header:focus {
  outline: none;
}

.summary-card__header:focus-visible {
  box-shadow: 0 0 0 2px rgba(25, 118, 210, 0.4);
  border-radius: 8px;
}

.summary-card__body {
  width: 100%;
}

/* Card wrapper for GLActionToolbar and RUDataTable */
.sl-data-card {
  background: #ffffff;
  border-radius: 8px;
  overflow: hidden;
}

.sl-toolbar-shimmer {
  background: #fafafa;
  margin-bottom: 0;
  padding: 0;
}

.sl-table-shimmer {
  min-height: 500px;
  margin-top: 0;
}

.sl-table-header-shimmer {
  border-bottom: 2px solid #e5e7eb;
}

.sl-table-row-shimmer {
  border-bottom: 1px solid #f3f4f6;
}

.sl-table-row-shimmer:last-child {
  border-bottom: none;
}

/* Gap utility class for flexbox */
.gap-2 {
  gap: 8px;
}

.gap-3 {
  gap: 12px;
}

.revenue-breakup-page,
.netsales-breakup-page {
  width: 100%;
  height: 100%;
  padding: 0;
}

.parent-row {
  cursor: pointer;
  font-weight: 500;
  background-color: #f5f5f5;
  
  &:hover {
    background-color: #eeeeee;
  }
}

.child-row {
  background-color: #fafafa;
}

.toggle-btn {
  width: 24px;
  height: 24px;
}

.table-wrapper,
.table-wrapper-ungrouped {
  width: 100%;
  overflow-x: auto;
}

.skeleton-textarea {
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  padding: 12px;
}

.noTransform {
  text-transform: none;
}

.font-size-md {
  font-size: 16px;
  font-weight: 500;
}

.revenue-summary__header,
.netsales-summary__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 24px;
  gap: 16px;
}

.summary-code {
  font-size: 20px;
  font-weight: 600;
  color: #1f2937;
}

.summary-description {
  color: #6b7280;
  font-size: 14px;
  margin-top: 4px;
}

.summary-chip {
  display: flex;
  align-items: center;
}

.revenue-summary__grid,
.netsales-summary__grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 24px;
}

.summary-panel__title {
  font-weight: 600;
}

.summary-panel__metrics {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.sl-commentary-card {
  background: #ffffff;
  border-radius: 12px;
}

.sl-commentary-status {
  gap: 16px;
}

.summary-metric {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  gap: 12px;
}

.summary-metric__label {
  font-size: 14px;
  color: var(--color-status-card-text);
  font-weight: 600;
}

.summary-metric__value {
  font-size: 14px;
  font-weight: 600;
  color: #404047;
}

.summary-metric__separator {
  margin: 0 8px;
  color: #9ca3af;
}

.summary-commentary {
  background: #ffffff;
  border-radius: 10px;
  padding: 16px;
  border: 1px solid #e5e7eb;
}

.summary-commentary__label {
  font-size: 13px;
  font-weight: 600;
  color: #6b7280;
  margin-bottom: 8px;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.summary-commentary__text {
  font-size: 14px;
  color: #1f2937;
  line-height: 1.6;
  white-space: pre-line;
}

.summary-commentary__text--empty {
  color: #9ca3af;
  font-style: italic;
}

.slbreakup__tabs .v-tab{
  font-size: var(--font-size-sm, 16px);
  font-weight: 400;
  color: var(--color-tabs-header);
  padding: var(--space-2) var(--space-8);
  letter-spacing: normal;
}
.slbreakup__tabs .v-tab--active{
  font-weight: 600;
  color: var(--color-tabs-header-active);
}
// .slbreakup-card {
//   padding: var(--space-9) var(--space-6);
// }
::v-deep .bulk-upload-commentary .v-data-table__wrapper {
  max-height: 500px;
}
</style>

<style lang="scss">
/* Teleported dialog — must be unscoped so warning stacks above Add Commentary */
.v-dialog__content.sl-breakup__unsaved-warning-dialog {
  z-index: var(--z-tooltip) !important;
}
</style>
